/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf, ObservableInput } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    versionGet(): Observable<string> {
        let url_ = this.baseUrl + "/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVersionGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVersionGet(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processVersionGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public versionGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<string>) => ObservableInput<string> | ObservableInput<never>,
    }): (err: any, caught: Observable<string>) => ObservableInput<string> | ObservableInput<never> {
        return (err: any, caught: Observable<string>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param objektTyp (optional) 
     * @param search (optional) 
     * @return OK
     */
    apiAutoCompleteObjektGet(objektTyp?: ObjektTyp | undefined, search?: string | undefined): Observable<ObjektAutoCompleteResult[]> {
        let url_ = this.baseUrl + "/api/AutoComplete/Objekt?";
        if (objektTyp === null)
            throw new Error("The parameter 'objektTyp' cannot be null.");
        else if (objektTyp !== undefined)
            url_ += "objektTyp=" + encodeURIComponent("" + objektTyp) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiAutoCompleteObjektGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiAutoCompleteObjektGet(<any>response_);
                } catch (e) {
                    return <Observable<ObjektAutoCompleteResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjektAutoCompleteResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiAutoCompleteObjektGet(response: HttpResponseBase): Observable<ObjektAutoCompleteResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObjektAutoCompleteResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjektAutoCompleteResult[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiAutoCompleteObjektGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ObjektAutoCompleteResult[]>) => ObservableInput<ObjektAutoCompleteResult[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<ObjektAutoCompleteResult[]>) => ObservableInput<ObjektAutoCompleteResult[]> | ObservableInput<never> {
        return (err: any, caught: Observable<ObjektAutoCompleteResult[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiBenutzerProfilGet(): Observable<BenutzerProfil> {
        let url_ = this.baseUrl + "/api/BenutzerProfil";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBenutzerProfilGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBenutzerProfilGet(<any>response_);
                } catch (e) {
                    return <Observable<BenutzerProfil>><any>_observableThrow(e);
                }
            } else
                return <Observable<BenutzerProfil>><any>_observableThrow(response_);
        }));
    }

    protected processApiBenutzerProfilGet(response: HttpResponseBase): Observable<BenutzerProfil> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenutzerProfil.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BenutzerProfil>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiBenutzerProfilGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<BenutzerProfil>) => ObservableInput<BenutzerProfil> | ObservableInput<never>,
    }): (err: any, caught: Observable<BenutzerProfil>) => ObservableInput<BenutzerProfil> | ObservableInput<never> {
        return (err: any, caught: Observable<BenutzerProfil>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param typ (optional) 
     * @param id (optional) 
     * @return OK
     */
    apiBenutzerProfilFavoritenGet(typ?: ObjektTyp | undefined, id?: number | undefined): Observable<BenutzerProfilFavorit[]> {
        let url_ = this.baseUrl + "/api/BenutzerProfil/Favoriten?";
        if (typ === null)
            throw new Error("The parameter 'typ' cannot be null.");
        else if (typ !== undefined)
            url_ += "typ=" + encodeURIComponent("" + typ) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBenutzerProfilFavoritenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBenutzerProfilFavoritenGet(<any>response_);
                } catch (e) {
                    return <Observable<BenutzerProfilFavorit[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BenutzerProfilFavorit[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiBenutzerProfilFavoritenGet(response: HttpResponseBase): Observable<BenutzerProfilFavorit[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BenutzerProfilFavorit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BenutzerProfilFavorit[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiBenutzerProfilFavoritenGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<BenutzerProfilFavorit[]>) => ObservableInput<BenutzerProfilFavorit[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<BenutzerProfilFavorit[]>) => ObservableInput<BenutzerProfilFavorit[]> | ObservableInput<never> {
        return (err: any, caught: Observable<BenutzerProfilFavorit[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiBenutzerProfilFavoritenPost(body?: BenutzerProfilFavorit | undefined): Observable<BenutzerProfilFavorit> {
        let url_ = this.baseUrl + "/api/BenutzerProfil/Favoriten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBenutzerProfilFavoritenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBenutzerProfilFavoritenPost(<any>response_);
                } catch (e) {
                    return <Observable<BenutzerProfilFavorit>><any>_observableThrow(e);
                }
            } else
                return <Observable<BenutzerProfilFavorit>><any>_observableThrow(response_);
        }));
    }

    protected processApiBenutzerProfilFavoritenPost(response: HttpResponseBase): Observable<BenutzerProfilFavorit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenutzerProfilFavorit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BenutzerProfilFavorit>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiBenutzerProfilFavoritenPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<BenutzerProfilFavorit>) => ObservableInput<BenutzerProfilFavorit> | ObservableInput<never>,
    }): (err: any, caught: Observable<BenutzerProfilFavorit>) => ObservableInput<BenutzerProfilFavorit> | ObservableInput<never> {
        return (err: any, caught: Observable<BenutzerProfilFavorit>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiBenutzerProfilFavoritenByTypByIdPost(typ: ObjektTyp, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/BenutzerProfil/Favoriten/{typ}/{id}";
        if (typ === undefined || typ === null)
            throw new Error("The parameter 'typ' must be defined.");
        url_ = url_.replace("{typ}", encodeURIComponent("" + typ));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBenutzerProfilFavoritenByTypByIdPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBenutzerProfilFavoritenByTypByIdPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiBenutzerProfilFavoritenByTypByIdPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiBenutzerProfilFavoritenByTypByIdPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    apiBenutzerProfilClientStatePut(body?: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/BenutzerProfil/ClientState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiBenutzerProfilClientStatePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiBenutzerProfilClientStatePut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiBenutzerProfilClientStatePut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiBenutzerProfilClientStatePutErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erstellt eine Konfiguration
     * @param body (optional) Konfiguration-Daten
     * @return Konfiguration erstellt
     */
    apiConfigurationPost(body?: Configuration | undefined): Observable<Configuration> {
        let url_ = this.baseUrl + "/api/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationPost(<any>response_);
                } catch (e) {
                    return <Observable<Configuration>><any>_observableThrow(e);
                }
            } else
                return <Observable<Configuration>><any>_observableThrow(response_);
        }));
    }

    protected processApiConfigurationPost(response: HttpResponseBase): Observable<Configuration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Configuration.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Configuration>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiConfigurationPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
    }): (err: any, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never> {
        return (err: any, caught: Observable<Configuration>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert eine Konfiguration
     * @param id Konfiguration-Id
     * @return Konfiguration
     */
    apiConfigurationByIdGet(id: number): Observable<Configuration> {
        let url_ = this.baseUrl + "/api/Configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationByIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationByIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Configuration>><any>_observableThrow(e);
                }
            } else
                return <Observable<Configuration>><any>_observableThrow(response_);
        }));
    }

    protected processApiConfigurationByIdGet(response: HttpResponseBase): Observable<Configuration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Configuration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Konfiguration existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Configuration>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Konfiguration existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiConfigurationByIdGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
    }): (err: any, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never> {
        return (err: any, caught: Observable<Configuration>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Aktualisiert eine Konfiguration
     * @param id Konfiguration-Id
     * @param body (optional) Konfiguration-Daten
     * @return Konfiguration aktualisiert
     */
    apiConfigurationByIdPut(id: number, body?: Configuration | undefined): Observable<Configuration> {
        let url_ = this.baseUrl + "/api/Configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationByIdPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationByIdPut(<any>response_);
                } catch (e) {
                    return <Observable<Configuration>><any>_observableThrow(e);
                }
            } else
                return <Observable<Configuration>><any>_observableThrow(response_);
        }));
    }

    protected processApiConfigurationByIdPut(response: HttpResponseBase): Observable<Configuration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Configuration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Konfiguration existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Configuration>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Konfiguration existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiConfigurationByIdPutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never>,
    }): (err: any, caught: Observable<Configuration>) => ObservableInput<Configuration> | ObservableInput<never> {
        return (err: any, caught: Observable<Configuration>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Löscht eine Konfiguration
     * @param id Konfiguration-Id
     * @return Konfiguration gelöscht
     */
    apiConfigurationByIdDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiConfigurationByIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiConfigurationByIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiConfigurationByIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - MasterConfigurationCannotBeDeleted : Master Konfiguration kann nicht gel\u00f6scht werden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Konfiguration existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - MasterConfigurationCannotBeDeleted : Master Konfiguration kann nicht gel\u00f6scht werden
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Konfiguration existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiConfigurationByIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param ownWorkspace (optional) 
     * @param body (optional) 
     * @return OK
     */
    apiErfassungListPost(ownWorkspace?: boolean | undefined, body?: TableInput | undefined): Observable<ListErfassungResult> {
        let url_ = this.baseUrl + "/api/Erfassung/List?";
        if (ownWorkspace === null)
            throw new Error("The parameter 'ownWorkspace' cannot be null.");
        else if (ownWorkspace !== undefined)
            url_ += "ownWorkspace=" + encodeURIComponent("" + ownWorkspace) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListErfassungResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListErfassungResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungListPost(response: HttpResponseBase): Observable<ListErfassungResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListErfassungResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListErfassungResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungListPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ListErfassungResult>) => ObservableInput<ListErfassungResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListErfassungResult>) => ObservableInput<ListErfassungResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListErfassungResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert ein Dossier zu einer Erfassung.
     * @param erfassungId Erfassung-Id
     * @return Dossier
     */
    apiErfassungByErfassungIdGet(erfassungId: number): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\', \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existieren nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\', \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existieren nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Löscht die Erfassung.
     * @param erfassungId Erfassung-Id
     * @return Erfassung wurde geloescht
     */
    apiErfassungByErfassungIdDelete(erfassungId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdDeleteErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert die Fehler einer Erfassung.
     * @param erfassungId Erfassung-Id
     * @return Fehler
     */
    apiErfassungByErfassungIdFehlerGet(erfassungId: number): Observable<ErfassungErrorResult[]> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/Fehler";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdFehlerGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdFehlerGet(<any>response_);
                } catch (e) {
                    return <Observable<ErfassungErrorResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ErfassungErrorResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdFehlerGet(response: HttpResponseBase): Observable<ErfassungErrorResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErfassungErrorResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existieren nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErfassungErrorResult[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existieren nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdFehlerGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<ErfassungErrorResult[]>) => ObservableInput<ErfassungErrorResult[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ErfassungErrorResult[]>) => ObservableInput<ErfassungErrorResult[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<ErfassungErrorResult[]>) => ObservableInput<ErfassungErrorResult[]> | ObservableInput<never> {
        return (err: any, caught: Observable<ErfassungErrorResult[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiErfassungByErfassungIdFreigabeProzessStartenPost(erfassungId: number, body?: FreigabeProzessStartenRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/FreigabeProzessStarten";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdFreigabeProzessStartenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdFreigabeProzessStartenPost(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdFreigabeProzessStartenPost(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - IdentityCollision (data: ObjektDatenKey) : Identit\u00e4t existiert bereits\r\n - CardinalityValidationFailed (data: CardinalityValidationResult[]) : Ung\u00fcltige Anzahl von Sachverhalten\r\n - DuplicateCopiesInAttributes : Sachverhaltduplikate in Merkmalen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - IdentityCollision (data: ObjektDatenKey) : Identit\u00e4t existiert bereits\r\n - CardinalityValidationFailed (data: CardinalityValidationResult[]) : Ung\u00fcltige Anzahl von Sachverhalten\r\n - DuplicateCopiesInAttributes : Sachverhaltduplikate in Merkmalen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdFreigabeProzessStartenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
    }): (err: any, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never> {
        return (err: any, caught: Observable<boolean>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Gibt die Erfassung als Fachlektor frei.
     * @param erfassungId Erfassung-Id
     * @return Freigabe ist erfolgt.
     */
    apiErfassungByErfassungIdFreigebenAlsFachlektorPost(erfassungId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/FreigebenAlsFachlektor";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdFreigebenAlsFachlektorPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdFreigebenAlsFachlektorPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdFreigebenAlsFachlektorPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdFreigebenAlsFachlektorPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Gibt die Erfassung als Länderadministrator frei.
     * @param erfassungId Erfassung-Id
     * @return Freigabe ist erfolgt.
     */
    apiErfassungByErfassungIdFreigebenAlsLaenderadministratorPost(erfassungId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/FreigebenAlsLaenderadministrator";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdFreigebenAlsLaenderadministratorPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdFreigebenAlsLaenderadministratorPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdFreigebenAlsLaenderadministratorPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdFreigebenAlsLaenderadministratorPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiErfassungBatchFreigabeProzessStartenPost(body?: BatchFreigabeProzessStartenRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Erfassung/Batch/FreigabeProzessStarten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungBatchFreigabeProzessStartenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungBatchFreigabeProzessStartenPost(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungBatchFreigabeProzessStartenPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungBatchFreigabeProzessStartenPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<number>) => ObservableInput<number> | ObservableInput<never>,
    }): (err: any, caught: Observable<number>) => ObservableInput<number> | ObservableInput<never> {
        return (err: any, caught: Observable<number>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Gibt eine Liste von Erfassungen als Fachlektor frei.
     * @param abortOnError (optional) True, wenn keine Freigabe erfolgen soll, sollte bei mindestens einem Stoff die Validierung fehlschlagen. False, wenn Stoffe, deren Validierung fehlschlägt, übersprungen werden sollen.
     * @param body (optional) Erfassung-Ids
     * @return Ergebnis der Batchoperation
     */
    apiErfassungBatchFreigebenAlsFachlektorPost(abortOnError?: boolean | undefined, body?: number[] | undefined): Observable<FreigebenResult> {
        let url_ = this.baseUrl + "/api/Erfassung/Batch/FreigebenAlsFachlektor?";
        if (abortOnError === null)
            throw new Error("The parameter 'abortOnError' cannot be null.");
        else if (abortOnError !== undefined)
            url_ += "abortOnError=" + encodeURIComponent("" + abortOnError) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungBatchFreigebenAlsFachlektorPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungBatchFreigebenAlsFachlektorPost(<any>response_);
                } catch (e) {
                    return <Observable<FreigebenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FreigebenResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungBatchFreigebenAlsFachlektorPost(response: HttpResponseBase): Observable<FreigebenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FreigebenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FreigebenResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungBatchFreigebenAlsFachlektorPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<FreigebenResult>) => ObservableInput<FreigebenResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FreigebenResult>) => ObservableInput<FreigebenResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FreigebenResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Gibt eine Liste von Erfassungen als Länderadministrator frei.
     * @param abortOnError (optional) True, wenn keine Freigabe erfolgen soll, sollte bei mindestens einem Stoff die Validierung fehlschlagen. False, wenn Stoffe, deren Validierung fehlschlägt, übersprungen werden sollen.
     * @param body (optional) Erfassung-Ids
     * @return Ergebnis der Batchoperation
     */
    apiErfassungBatchFreigebenAlsLaenderadministratorPost(abortOnError?: boolean | undefined, body?: number[] | undefined): Observable<FreigebenResult> {
        let url_ = this.baseUrl + "/api/Erfassung/Batch/FreigebenAlsLaenderadministrator?";
        if (abortOnError === null)
            throw new Error("The parameter 'abortOnError' cannot be null.");
        else if (abortOnError !== undefined)
            url_ += "abortOnError=" + encodeURIComponent("" + abortOnError) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungBatchFreigebenAlsLaenderadministratorPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungBatchFreigebenAlsLaenderadministratorPost(<any>response_);
                } catch (e) {
                    return <Observable<FreigebenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FreigebenResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungBatchFreigebenAlsLaenderadministratorPost(response: HttpResponseBase): Observable<FreigebenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FreigebenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FreigebenResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungBatchFreigebenAlsLaenderadministratorPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<FreigebenResult>) => ObservableInput<FreigebenResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FreigebenResult>) => ObservableInput<FreigebenResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FreigebenResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Weist eine Erfassung als Fachlektor zurück.
     * @param erfassungId Erfassung-Id
     * @param body (optional) Grund
     * @return Stoffdatenänderung wurde zurückgewiesen
     */
    apiErfassungByErfassungIdAblehnenAlsFachlektorPost(erfassungId: number, body?: RejectReason | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/AblehnenAlsFachlektor";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdAblehnenAlsFachlektorPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdAblehnenAlsFachlektorPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdAblehnenAlsFachlektorPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdAblehnenAlsFachlektorPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Weist eine Erfassung als Länderadministrator zurück.
     * @param erfassungId Erfassung-Id
     * @param body (optional) Grund
     * @return Stoffdatenänderung wurde zurückgewiesen
     */
    apiErfassungByErfassungIdAblehnenAlsLaenderadministratorPost(erfassungId: number, body?: RejectReason | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/AblehnenAlsLaenderadministrator";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdAblehnenAlsLaenderadministratorPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdAblehnenAlsLaenderadministratorPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdAblehnenAlsLaenderadministratorPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdAblehnenAlsLaenderadministratorPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Gibt eine Stoffzusammenfuehrung frei.
     * @param erfassungId Erfassung-Id
     * @return Freigabe ist erfolgt.
     */
    apiErfassungByErfassungIdStoffzusammenfuehrungFreigebenPost(erfassungId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/StoffzusammenfuehrungFreigeben";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdStoffzusammenfuehrungFreigebenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdStoffzusammenfuehrungFreigebenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdStoffzusammenfuehrungFreigebenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdStoffzusammenfuehrungFreigebenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Weist eine Stoffzusammenführung zurück.
     * @param erfassungId Erfassung-Id
     * @param body (optional) Grund
     * @return Stoffdatenänderung wurde zurückgewiesen
     */
    apiErfassungByErfassungIdStoffzusammenfuehrungAblehnenPost(erfassungId: number, body?: RejectReason | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/StoffzusammenfuehrungAblehnen";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdStoffzusammenfuehrungAblehnenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdStoffzusammenfuehrungAblehnenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdStoffzusammenfuehrungAblehnenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'\r\n - NoFactsToApproveOrReject : Keine Sachverhalte vorhanden, die durch den Nutzer freigegeben oder zur\u00fcckgewiesen werden k\u00f6nnen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdStoffzusammenfuehrungAblehnenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Akzeptiert die Zurückweisung und erlaubt die Weiterbearbeitung.
     * @param erfassungId Erfassung-Id
     * @return Zurückweisung wurde akzeptiert, die Erfassung kann weiterbearbeitet werden
     */
    apiErfassungByErfassungIdWeiterarbeitenPost(erfassungId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/Weiterarbeiten";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdWeiterarbeitenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdWeiterarbeitenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdWeiterarbeitenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Zurueckgewiesen\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Nutzer hat schon Erfassung f\u00fcr den Stoff offen", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Zurueckgewiesen\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Nutzer hat schon Erfassung f\u00fcr den Stoff offen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdWeiterarbeitenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Zieht eine eingereichte Erfassung zurück.
     * @param erfassungId Erfassung-Id
     * @return Erfassung zurückgezogen
     */
    apiErfassungByErfassungIdZurueckziehenPost(erfassungId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/Zurueckziehen";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdZurueckziehenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdZurueckziehenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdZurueckziehenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'InFreigabe\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdZurueckziehenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Übernimmt eine fremde Erfassung.
    Die Erfassung wird dem aktuellen Nutzer zugeordnet.
     * @param erfassungId Erfassung-Id
     * @return Erfassung übernommen
     */
    apiErfassungByErfassungIdUebernehmenPost(erfassungId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/Uebernehmen";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdUebernehmenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdUebernehmenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdUebernehmenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Nutzer hat schon Erfassung f\u00fcr den Stoff offen", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung existiert nicht
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Nutzer hat schon Erfassung f\u00fcr den Stoff offen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdUebernehmenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiErfassungBatchArchivierenPost(body?: number[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Erfassung/BatchArchivieren";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungBatchArchivierenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungBatchArchivierenPost(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungBatchArchivierenPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungBatchArchivierenPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<number>) => ObservableInput<number> | ObservableInput<never>,
    }): (err: any, caught: Observable<number>) => ObservableInput<number> | ObservableInput<never> {
        return (err: any, caught: Observable<number>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Weist eine Erfassung einem Nutzer zu.
     * @param erfassungId Erfassung-Id
     * @param body (optional) Nutzer
     * @return Erfassung wurde ausgeblendet
     */
    apiErfassungByErfassungIdZuweisenPost(erfassungId: number, body?: ErfassungZuweisenInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Erfassung/{erfassungId}/Zuweisen";
        if (erfassungId === undefined || erfassungId === null)
            throw new Error("The parameter 'erfassungId' must be defined.");
        url_ = url_.replace("{erfassungId}", encodeURIComponent("" + erfassungId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungByErfassungIdZuweisenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungByErfassungIdZuweisenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungByErfassungIdZuweisenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungByErfassungIdZuweisenPostErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param erfassungId (optional) 
     * @return OK
     */
    apiErfassungZuweisbareUserGet(erfassungId?: number | undefined): Observable<UserItem[]> {
        let url_ = this.baseUrl + "/api/Erfassung/ZuweisbareUser?";
        if (erfassungId === null)
            throw new Error("The parameter 'erfassungId' cannot be null.");
        else if (erfassungId !== undefined)
            url_ += "erfassungId=" + encodeURIComponent("" + erfassungId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiErfassungZuweisbareUserGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiErfassungZuweisbareUserGet(<any>response_);
                } catch (e) {
                    return <Observable<UserItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiErfassungZuweisbareUserGet(response: HttpResponseBase): Observable<UserItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserItem[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiErfassungZuweisbareUserGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<UserItem[]>) => ObservableInput<UserItem[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<UserItem[]>) => ObservableInput<UserItem[]> | ObservableInput<never> {
        return (err: any, caught: Observable<UserItem[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiExportAuftragListPost(body?: TableInput | undefined): Observable<ListExportAuftraegeResult> {
        let url_ = this.baseUrl + "/api/ExportAuftrag/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiExportAuftragListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiExportAuftragListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListExportAuftraegeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListExportAuftraegeResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiExportAuftragListPost(response: HttpResponseBase): Observable<ListExportAuftraegeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListExportAuftraegeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListExportAuftraegeResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiExportAuftragListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListExportAuftraegeResult>) => ObservableInput<ListExportAuftraegeResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListExportAuftraegeResult>) => ObservableInput<ListExportAuftraegeResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListExportAuftraegeResult>) => ObservableInput<ListExportAuftraegeResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListExportAuftraegeResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiExportAuftragPost(body?: ExportAuftrag | undefined): Observable<ExportAuftrag> {
        let url_ = this.baseUrl + "/api/ExportAuftrag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiExportAuftragPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiExportAuftragPost(<any>response_);
                } catch (e) {
                    return <Observable<ExportAuftrag>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExportAuftrag>><any>_observableThrow(response_);
        }));
    }

    protected processApiExportAuftragPost(response: HttpResponseBase): Observable<ExportAuftrag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ExportAuftrag.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportAuftrag>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiExportAuftragPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<ExportAuftrag>) => ObservableInput<ExportAuftrag> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<ExportAuftrag>) => ObservableInput<ExportAuftrag> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ExportAuftrag>) => ObservableInput<ExportAuftrag> | ObservableInput<never>,
    }): (err: any, caught: Observable<ExportAuftrag>) => ObservableInput<ExportAuftrag> | ObservableInput<never> {
        return (err: any, caught: Observable<ExportAuftrag>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiExportAuftragByIdGet(id: number): Observable<ExportAuftrag> {
        let url_ = this.baseUrl + "/api/ExportAuftrag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiExportAuftragByIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiExportAuftragByIdGet(<any>response_);
                } catch (e) {
                    return <Observable<ExportAuftrag>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExportAuftrag>><any>_observableThrow(response_);
        }));
    }

    protected processApiExportAuftragByIdGet(response: HttpResponseBase): Observable<ExportAuftrag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportAuftrag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportAuftrag>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiExportAuftragByIdGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ExportAuftrag>) => ObservableInput<ExportAuftrag> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<ExportAuftrag>) => ObservableInput<ExportAuftrag> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ExportAuftrag>) => ObservableInput<ExportAuftrag> | ObservableInput<never>,
    }): (err: any, caught: Observable<ExportAuftrag>) => ObservableInput<ExportAuftrag> | ObservableInput<never> {
        return (err: any, caught: Observable<ExportAuftrag>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiExportAuftragByIdDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ExportAuftrag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiExportAuftragByIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiExportAuftragByIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiExportAuftragByIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiExportAuftragByIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiExportAuftragRankingTagsGet(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/ExportAuftrag/RankingTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiExportAuftragRankingTagsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiExportAuftragRankingTagsGet(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiExportAuftragRankingTagsGet(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiExportAuftragRankingTagsGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never> {
        return (err: any, caught: Observable<string[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiExportAuftragFormateGet(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/ExportAuftrag/Formate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiExportAuftragFormateGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiExportAuftragFormateGet(<any>response_);
                } catch (e) {
                    return <Observable<{ [key: string]: string; }>><any>_observableThrow(e);
                }
            } else
                return <Observable<{ [key: string]: string; }>><any>_observableThrow(response_);
        }));
    }

    protected processApiExportAuftragFormateGet(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiExportAuftragFormateGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never>,
    }): (err: any, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never> {
        return (err: any, caught: Observable<{ [key: string]: string; }>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiFavoritenListeListPost(body?: TableInput | undefined): Observable<ListFavoritenListeResult> {
        let url_ = this.baseUrl + "/api/FavoritenListe/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFavoritenListeListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFavoritenListeListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListFavoritenListeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListFavoritenListeResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFavoritenListeListPost(response: HttpResponseBase): Observable<ListFavoritenListeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListFavoritenListeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListFavoritenListeResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFavoritenListeListPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ListFavoritenListeResult>) => ObservableInput<ListFavoritenListeResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListFavoritenListeResult>) => ObservableInput<ListFavoritenListeResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListFavoritenListeResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param objektTyp (optional) 
     * @param objektId (optional) 
     * @return OK
     */
    apiFavoritenListeGet(objektTyp?: ObjektTyp | undefined, objektId?: number | undefined): Observable<FavoritenListeTabelleResult[]> {
        let url_ = this.baseUrl + "/api/FavoritenListe?";
        if (objektTyp === null)
            throw new Error("The parameter 'objektTyp' cannot be null.");
        else if (objektTyp !== undefined)
            url_ += "objektTyp=" + encodeURIComponent("" + objektTyp) + "&";
        if (objektId === null)
            throw new Error("The parameter 'objektId' cannot be null.");
        else if (objektId !== undefined)
            url_ += "objektId=" + encodeURIComponent("" + objektId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFavoritenListeGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFavoritenListeGet(<any>response_);
                } catch (e) {
                    return <Observable<FavoritenListeTabelleResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FavoritenListeTabelleResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiFavoritenListeGet(response: HttpResponseBase): Observable<FavoritenListeTabelleResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FavoritenListeTabelleResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FavoritenListeTabelleResult[]>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFavoritenListeGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<FavoritenListeTabelleResult[]>) => ObservableInput<FavoritenListeTabelleResult[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<FavoritenListeTabelleResult[]>) => ObservableInput<FavoritenListeTabelleResult[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<FavoritenListeTabelleResult[]>) => ObservableInput<FavoritenListeTabelleResult[]> | ObservableInput<never> {
        return (err: any, caught: Observable<FavoritenListeTabelleResult[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiFavoritenListePost(body?: FavoritenListeInput | undefined): Observable<FavoritenListeResult> {
        let url_ = this.baseUrl + "/api/FavoritenListe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFavoritenListePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFavoritenListePost(<any>response_);
                } catch (e) {
                    return <Observable<FavoritenListeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FavoritenListeResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFavoritenListePost(response: HttpResponseBase): Observable<FavoritenListeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FavoritenListeResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FavoritenListeResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFavoritenListePostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FavoritenListeResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiFavoritenListeByIdGet(id: number): Observable<FavoritenListeResult> {
        let url_ = this.baseUrl + "/api/FavoritenListe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFavoritenListeByIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFavoritenListeByIdGet(<any>response_);
                } catch (e) {
                    return <Observable<FavoritenListeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FavoritenListeResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFavoritenListeByIdGet(response: HttpResponseBase): Observable<FavoritenListeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FavoritenListeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FavoritenListeResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFavoritenListeByIdGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FavoritenListeResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiFavoritenListeByIdPut(id: number, body?: FavoritenListeInput | undefined): Observable<FavoritenListeResult> {
        let url_ = this.baseUrl + "/api/FavoritenListe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFavoritenListeByIdPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFavoritenListeByIdPut(<any>response_);
                } catch (e) {
                    return <Observable<FavoritenListeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FavoritenListeResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFavoritenListeByIdPut(response: HttpResponseBase): Observable<FavoritenListeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FavoritenListeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FavoritenListeResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFavoritenListeByIdPutErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FavoritenListeResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiFavoritenListeByIdDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/FavoritenListe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFavoritenListeByIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFavoritenListeByIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiFavoritenListeByIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFavoritenListeByIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param merge (optional) 
     * @param file (optional) 
     * @return OK
     */
    apiFavoritenListeByIdPost(id: number, merge?: boolean | undefined, file?: FileParameter | undefined): Observable<FavoritenListeResult> {
        let url_ = this.baseUrl + "/api/FavoritenListe/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (merge === null)
            throw new Error("The parameter 'merge' cannot be null.");
        else if (merge !== undefined)
            url_ += "merge=" + encodeURIComponent("" + merge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFavoritenListeByIdPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFavoritenListeByIdPost(<any>response_);
                } catch (e) {
                    return <Observable<FavoritenListeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FavoritenListeResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFavoritenListeByIdPost(response: HttpResponseBase): Observable<FavoritenListeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FavoritenListeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FavoritenListeResult>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFavoritenListeByIdPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FavoritenListeResult>) => ObservableInput<FavoritenListeResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FavoritenListeResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiFavoritenListeByIdTabelleByTabelleIdListPost(id: number, tabelleId: number, body?: TableInput | undefined): Observable<ListFavoritenListeZeileResult> {
        let url_ = this.baseUrl + "/api/FavoritenListe/{id}/Tabelle/{tabelleId}/List";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tabelleId === undefined || tabelleId === null)
            throw new Error("The parameter 'tabelleId' must be defined.");
        url_ = url_.replace("{tabelleId}", encodeURIComponent("" + tabelleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFavoritenListeByIdTabelleByTabelleIdListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFavoritenListeByIdTabelleByTabelleIdListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListFavoritenListeZeileResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListFavoritenListeZeileResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFavoritenListeByIdTabelleByTabelleIdListPost(response: HttpResponseBase): Observable<ListFavoritenListeZeileResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListFavoritenListeZeileResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListFavoritenListeZeileResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFavoritenListeByIdTabelleByTabelleIdListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListFavoritenListeZeileResult>) => ObservableInput<ListFavoritenListeZeileResult> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<ListFavoritenListeZeileResult>) => ObservableInput<ListFavoritenListeZeileResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListFavoritenListeZeileResult>) => ObservableInput<ListFavoritenListeZeileResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListFavoritenListeZeileResult>) => ObservableInput<ListFavoritenListeZeileResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListFavoritenListeZeileResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiFeedbackListPost(body?: TableInput | undefined): Observable<ListFeedbacksResult> {
        let url_ = this.baseUrl + "/api/Feedback/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFeedbackListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFeedbackListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListFeedbacksResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListFeedbacksResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFeedbackListPost(response: HttpResponseBase): Observable<ListFeedbacksResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListFeedbacksResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListFeedbacksResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFeedbackListPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ListFeedbacksResult>) => ObservableInput<ListFeedbacksResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListFeedbacksResult>) => ObservableInput<ListFeedbacksResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListFeedbacksResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiFeedbackByFeedbackUidGet(feedbackUid: string): Observable<FeedbackResult> {
        let url_ = this.baseUrl + "/api/Feedback/{feedbackUid}";
        if (feedbackUid === undefined || feedbackUid === null)
            throw new Error("The parameter 'feedbackUid' must be defined.");
        url_ = url_.replace("{feedbackUid}", encodeURIComponent("" + feedbackUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFeedbackByFeedbackUidGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFeedbackByFeedbackUidGet(<any>response_);
                } catch (e) {
                    return <Observable<FeedbackResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedbackResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFeedbackByFeedbackUidGet(response: HttpResponseBase): Observable<FeedbackResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFeedbackByFeedbackUidGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FeedbackResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiFeedbackByFeedbackUidPut(feedbackUid: string, body?: UpdateFeedbackInput | undefined): Observable<FeedbackResult> {
        let url_ = this.baseUrl + "/api/Feedback/{feedbackUid}";
        if (feedbackUid === undefined || feedbackUid === null)
            throw new Error("The parameter 'feedbackUid' must be defined.");
        url_ = url_.replace("{feedbackUid}", encodeURIComponent("" + feedbackUid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFeedbackByFeedbackUidPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFeedbackByFeedbackUidPut(<any>response_);
                } catch (e) {
                    return <Observable<FeedbackResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedbackResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFeedbackByFeedbackUidPut(response: HttpResponseBase): Observable<FeedbackResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidStateTransition : Ung\u00fcltiger Zustands\u00fcbergang", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackResult>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidStateTransition : Ung\u00fcltiger Zustands\u00fcbergang
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFeedbackByFeedbackUidPutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FeedbackResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiFeedbackByFeedbackUidDelete(feedbackUid: string): Observable<FeedbackResult> {
        let url_ = this.baseUrl + "/api/Feedback/{feedbackUid}";
        if (feedbackUid === undefined || feedbackUid === null)
            throw new Error("The parameter 'feedbackUid' must be defined.");
        url_ = url_.replace("{feedbackUid}", encodeURIComponent("" + feedbackUid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFeedbackByFeedbackUidDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFeedbackByFeedbackUidDelete(<any>response_);
                } catch (e) {
                    return <Observable<FeedbackResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedbackResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFeedbackByFeedbackUidDelete(response: HttpResponseBase): Observable<FeedbackResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = FeedbackResult.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFeedbackByFeedbackUidDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FeedbackResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiFeedbackPost(body?: CreateFeedbackInput | undefined): Observable<FeedbackResult> {
        let url_ = this.baseUrl + "/api/Feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFeedbackPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFeedbackPost(<any>response_);
                } catch (e) {
                    return <Observable<FeedbackResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedbackResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiFeedbackPost(response: HttpResponseBase): Observable<FeedbackResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FeedbackResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFeedbackPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<FeedbackResult>) => ObservableInput<FeedbackResult> | ObservableInput<never> {
        return (err: any, caught: Observable<FeedbackResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    apiFeedbackAnhangDelete(body?: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Feedback/Anhang";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFeedbackAnhangDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFeedbackAnhangDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiFeedbackAnhangDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFeedbackAnhangDeleteErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param anhangUid (optional) 
     * @return No Content
     */
    apiFeedbackAnhangRemovePost(anhangUid?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Feedback/Anhang/Remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (anhangUid === null || anhangUid === undefined)
            throw new Error("The parameter 'anhangUid' cannot be null.");
        else
            content_.append("anhangUid", anhangUid.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFeedbackAnhangRemovePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFeedbackAnhangRemovePost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiFeedbackAnhangRemovePost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFeedbackAnhangRemovePostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    apiFeedbackAnhangSavePost(file?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Feedback/Anhang/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiFeedbackAnhangSavePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiFeedbackAnhangSavePost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiFeedbackAnhangSavePost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiFeedbackAnhangSavePostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiImportByImportIdGet(importId: number): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Import/{importId}";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportByImportIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportByImportIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportByImportIdGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportByImportIdGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiImportByImportIdDelete(importId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Import/{importId}";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportByImportIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportByImportIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportByImportIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportByImportIdDeleteErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiImportByImportIdByObjektTypByImportObjektIdGet(importId: number, objektTyp: ObjektTyp, importObjektId: number): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Import/{importId}/{objektTyp}/{importObjektId}";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        if (objektTyp === undefined || objektTyp === null)
            throw new Error("The parameter 'objektTyp' must be defined.");
        url_ = url_.replace("{objektTyp}", encodeURIComponent("" + objektTyp));
        if (importObjektId === undefined || importObjektId === null)
            throw new Error("The parameter 'importObjektId' must be defined.");
        url_ = url_.replace("{importObjektId}", encodeURIComponent("" + importObjektId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportByImportIdByObjektTypByImportObjektIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportByImportIdByObjektTypByImportObjektIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportByImportIdByObjektTypByImportObjektIdGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportByImportIdByObjektTypByImportObjektIdGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiImportByImportIdByObjektTypByImportObjektIdBySachverhaltKeyAusgewaehltPut(importId: number, objektTyp: ObjektTyp, importObjektId: number, sachverhaltKey: string, body?: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Import/{importId}/{objektTyp}/{importObjektId}/{sachverhaltKey}/Ausgewaehlt";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        if (objektTyp === undefined || objektTyp === null)
            throw new Error("The parameter 'objektTyp' must be defined.");
        url_ = url_.replace("{objektTyp}", encodeURIComponent("" + objektTyp));
        if (importObjektId === undefined || importObjektId === null)
            throw new Error("The parameter 'importObjektId' must be defined.");
        url_ = url_.replace("{importObjektId}", encodeURIComponent("" + importObjektId));
        if (sachverhaltKey === undefined || sachverhaltKey === null)
            throw new Error("The parameter 'sachverhaltKey' must be defined.");
        url_ = url_.replace("{sachverhaltKey}", encodeURIComponent("" + sachverhaltKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportByImportIdByObjektTypByImportObjektIdBySachverhaltKeyAusgewaehltPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportByImportIdByObjektTypByImportObjektIdBySachverhaltKeyAusgewaehltPut(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportByImportIdByObjektTypByImportObjektIdBySachverhaltKeyAusgewaehltPut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportByImportIdByObjektTypByImportObjektIdBySachverhaltKeyAusgewaehltPutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
    }): (err: any, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never> {
        return (err: any, caught: Observable<boolean>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param konflikteAutomatischLoesen (optional) 
     * @return No Content
     */
    apiImportByImportIdFreigebenPost(importId: number, konflikteAutomatischLoesen?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Import/{importId}/Freigeben?";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        if (konflikteAutomatischLoesen === null)
            throw new Error("The parameter 'konflikteAutomatischLoesen' cannot be null.");
        else if (konflikteAutomatischLoesen !== undefined)
            url_ += "konflikteAutomatischLoesen=" + encodeURIComponent("" + konflikteAutomatischLoesen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportByImportIdFreigebenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportByImportIdFreigebenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportByImportIdFreigebenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\', \'Zurueckgewiesen\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportByImportIdFreigebenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Blendet die Import-Erfassung aus.
     * @param importId Import-Erfassung-Id
     * @return Import-Erfassung wurde ausgeblendet
     */
    apiImportByImportIdAusblendenPost(importId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Import/{importId}/Ausblenden";
        if (importId === undefined || importId === null)
            throw new Error("The parameter 'importId' must be defined.");
        url_ = url_.replace("{importId}", encodeURIComponent("" + importId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportByImportIdAusblendenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportByImportIdAusblendenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportByImportIdAusblendenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Abgeschlossen\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Abgeschlossen\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportByImportIdAusblendenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiImportAuftragListPost(body?: TableInput | undefined): Observable<ListImportAuftraegeResult> {
        let url_ = this.baseUrl + "/api/ImportAuftrag/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportAuftragListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportAuftragListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListImportAuftraegeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListImportAuftraegeResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportAuftragListPost(response: HttpResponseBase): Observable<ListImportAuftraegeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListImportAuftraegeResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListImportAuftraegeResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportAuftragListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListImportAuftraegeResult>) => ObservableInput<ListImportAuftraegeResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListImportAuftraegeResult>) => ObservableInput<ListImportAuftraegeResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListImportAuftraegeResult>) => ObservableInput<ListImportAuftraegeResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListImportAuftraegeResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param lieferantId (optional) 
     * @param format (optional) 
     * @param sachverhalteUeberspringen (optional) 
     * @param stoffeErstellen (optional) 
     * @param modus (optional) 
     * @param file (optional) 
     * @return Created
     */
    apiImportAuftragPost(lieferantId?: number | undefined, format?: string | undefined, sachverhalteUeberspringen?: boolean | undefined, stoffeErstellen?: boolean | undefined, modus?: Modus | undefined, file?: FileParameter | undefined): Observable<ImportAuftrag> {
        let url_ = this.baseUrl + "/api/ImportAuftrag?";
        if (lieferantId === null)
            throw new Error("The parameter 'lieferantId' cannot be null.");
        else if (lieferantId !== undefined)
            url_ += "lieferantId=" + encodeURIComponent("" + lieferantId) + "&";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (sachverhalteUeberspringen === null)
            throw new Error("The parameter 'sachverhalteUeberspringen' cannot be null.");
        else if (sachverhalteUeberspringen !== undefined)
            url_ += "sachverhalteUeberspringen=" + encodeURIComponent("" + sachverhalteUeberspringen) + "&";
        if (stoffeErstellen === null)
            throw new Error("The parameter 'stoffeErstellen' cannot be null.");
        else if (stoffeErstellen !== undefined)
            url_ += "stoffeErstellen=" + encodeURIComponent("" + stoffeErstellen) + "&";
        if (modus === null)
            throw new Error("The parameter 'modus' cannot be null.");
        else if (modus !== undefined)
            url_ += "modus=" + encodeURIComponent("" + modus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportAuftragPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportAuftragPost(<any>response_);
                } catch (e) {
                    return <Observable<ImportAuftrag>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportAuftrag>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportAuftragPost(response: HttpResponseBase): Observable<ImportAuftrag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ImportAuftrag.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportAuftrag>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportAuftragPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<ImportAuftrag>) => ObservableInput<ImportAuftrag> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<ImportAuftrag>) => ObservableInput<ImportAuftrag> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ImportAuftrag>) => ObservableInput<ImportAuftrag> | ObservableInput<never>,
    }): (err: any, caught: Observable<ImportAuftrag>) => ObservableInput<ImportAuftrag> | ObservableInput<never> {
        return (err: any, caught: Observable<ImportAuftrag>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiImportAuftragByIdDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ImportAuftrag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportAuftragByIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportAuftragByIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportAuftragByIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportAuftragByIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiImportAuftragByIdProtokollGet(id: number): Observable<ImportAuftragLogItem[]> {
        let url_ = this.baseUrl + "/api/ImportAuftrag/{id}/Protokoll";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportAuftragByIdProtokollGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportAuftragByIdProtokollGet(<any>response_);
                } catch (e) {
                    return <Observable<ImportAuftragLogItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportAuftragLogItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportAuftragByIdProtokollGet(response: HttpResponseBase): Observable<ImportAuftragLogItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportAuftragLogItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportAuftragLogItem[]>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportAuftragByIdProtokollGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ImportAuftragLogItem[]>) => ObservableInput<ImportAuftragLogItem[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ImportAuftragLogItem[]>) => ObservableInput<ImportAuftragLogItem[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<ImportAuftragLogItem[]>) => ObservableInput<ImportAuftragLogItem[]> | ObservableInput<never> {
        return (err: any, caught: Observable<ImportAuftragLogItem[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiImportAuftragFormateGet(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/ImportAuftrag/Formate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportAuftragFormateGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportAuftragFormateGet(<any>response_);
                } catch (e) {
                    return <Observable<{ [key: string]: string; }>><any>_observableThrow(e);
                }
            } else
                return <Observable<{ [key: string]: string; }>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportAuftragFormateGet(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportAuftragFormateGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never>,
    }): (err: any, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never> {
        return (err: any, caught: Observable<{ [key: string]: string; }>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiImportAuftragLieferantenGet(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/ImportAuftrag/Lieferanten";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiImportAuftragLieferantenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiImportAuftragLieferantenGet(<any>response_);
                } catch (e) {
                    return <Observable<{ [key: string]: string; }>><any>_observableThrow(e);
                }
            } else
                return <Observable<{ [key: string]: string; }>><any>_observableThrow(response_);
        }));
    }

    protected processApiImportAuftragLieferantenGet(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiImportAuftragLieferantenGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never>,
    }): (err: any, caught: Observable<{ [key: string]: string; }>) => ObservableInput<{ [key: string]: string; }> | ObservableInput<never> {
        return (err: any, caught: Observable<{ [key: string]: string; }>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiKonfigurationListPost(body?: TableInput | undefined): Observable<ListKonfigurationResult> {
        let url_ = this.baseUrl + "/api/Konfiguration/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiKonfigurationListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiKonfigurationListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListKonfigurationResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListKonfigurationResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiKonfigurationListPost(response: HttpResponseBase): Observable<ListKonfigurationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListKonfigurationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListKonfigurationResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiKonfigurationListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListKonfigurationResult>) => ObservableInput<ListKonfigurationResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListKonfigurationResult>) => ObservableInput<ListKonfigurationResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListKonfigurationResult>) => ObservableInput<ListKonfigurationResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListKonfigurationResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert ein Dossier zu einem Lieferanten.
     * @param lieferantId Lieferant-Id
     * @return Dossier
     */
    apiLieferantByLieferantIdGet(lieferantId: number): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Lieferant/{lieferantId}";
        if (lieferantId === undefined || lieferantId === null)
            throw new Error("The parameter 'lieferantId' must be defined.");
        url_ = url_.replace("{lieferantId}", encodeURIComponent("" + lieferantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiLieferantByLieferantIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiLieferantByLieferantIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiLieferantByLieferantIdGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Lieferant existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Lieferant existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiLieferantByLieferantIdGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert eine Liste von Objekten, die den Lieferanten referenzieren.
     * @param lieferantId Lieferant-Id
     * @param skip (optional) Anzahl der Elemente, die übersprungen werden
     * @param pageSize (optional) Maximale Anzahl der Elemente
     * @return ReferenziertDurch
     */
    apiLieferantByLieferantIdReferenziertDurchGet(lieferantId: number, skip?: number | undefined, pageSize?: number | undefined): Observable<ReferencesResult> {
        let url_ = this.baseUrl + "/api/Lieferant/{lieferantId}/ReferenziertDurch?";
        if (lieferantId === undefined || lieferantId === null)
            throw new Error("The parameter 'lieferantId' must be defined.");
        url_ = url_.replace("{lieferantId}", encodeURIComponent("" + lieferantId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiLieferantByLieferantIdReferenziertDurchGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiLieferantByLieferantIdReferenziertDurchGet(<any>response_);
                } catch (e) {
                    return <Observable<ReferencesResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReferencesResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiLieferantByLieferantIdReferenziertDurchGet(response: HttpResponseBase): Observable<ReferencesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferencesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferencesResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiLieferantByLieferantIdReferenziertDurchGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ReferencesResult>) => ObservableInput<ReferencesResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ReferencesResult>) => ObservableInput<ReferencesResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ReferencesResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert den Lieferanten des angemeldeten Nuters.
     * @return Lieferant oder leer
     */
    apiMeinLieferantGet(): Observable<Lieferant> {
        let url_ = this.baseUrl + "/api/MeinLieferant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiMeinLieferantGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiMeinLieferantGet(<any>response_);
                } catch (e) {
                    return <Observable<Lieferant>><any>_observableThrow(e);
                }
            } else
                return <Observable<Lieferant>><any>_observableThrow(response_);
        }));
    }

    protected processApiMeinLieferantGet(response: HttpResponseBase): Observable<Lieferant> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Lieferant.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Kein Lieferant zugeordnet", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Lieferant existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Lieferant>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Lieferant existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiMeinLieferantGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<Lieferant>) => ObservableInput<Lieferant> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Lieferant>) => ObservableInput<Lieferant> | ObservableInput<never>,
    }): (err: any, caught: Observable<Lieferant>) => ObservableInput<Lieferant> | ObservableInput<never> {
        return (err: any, caught: Observable<Lieferant>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert den Merkmal-Baum.
     * @return OK
     */
    apiMerkmalBaumGet(): Observable<MerkmalBaum[]> {
        let url_ = this.baseUrl + "/api/MerkmalBaum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiMerkmalBaumGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiMerkmalBaumGet(<any>response_);
                } catch (e) {
                    return <Observable<MerkmalBaum[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MerkmalBaum[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiMerkmalBaumGet(response: HttpResponseBase): Observable<MerkmalBaum[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerkmalBaum.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MerkmalBaum[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiMerkmalBaumGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<MerkmalBaum[]>) => ObservableInput<MerkmalBaum[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<MerkmalBaum[]>) => ObservableInput<MerkmalBaum[]> | ObservableInput<never> {
        return (err: any, caught: Observable<MerkmalBaum[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiNachschlageTabelleListPost(body?: TableInput | undefined): Observable<ListNachschlageTabellenResult> {
        let url_ = this.baseUrl + "/api/NachschlageTabelle/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiNachschlageTabelleListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiNachschlageTabelleListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListNachschlageTabellenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListNachschlageTabellenResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiNachschlageTabelleListPost(response: HttpResponseBase): Observable<ListNachschlageTabellenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListNachschlageTabellenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListNachschlageTabellenResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiNachschlageTabelleListPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ListNachschlageTabellenResult>) => ObservableInput<ListNachschlageTabellenResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListNachschlageTabellenResult>) => ObservableInput<ListNachschlageTabellenResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListNachschlageTabellenResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    apiNachschlageTabelleGet(name?: string | undefined): Observable<NachschlageTabelle> {
        let url_ = this.baseUrl + "/api/NachschlageTabelle?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiNachschlageTabelleGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiNachschlageTabelleGet(<any>response_);
                } catch (e) {
                    return <Observable<NachschlageTabelle>><any>_observableThrow(e);
                }
            } else
                return <Observable<NachschlageTabelle>><any>_observableThrow(response_);
        }));
    }

    protected processApiNachschlageTabelleGet(response: HttpResponseBase): Observable<NachschlageTabelle> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NachschlageTabelle.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NachschlageTabelle>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiNachschlageTabelleGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<NachschlageTabelle>) => ObservableInput<NachschlageTabelle> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<NachschlageTabelle>) => ObservableInput<NachschlageTabelle> | ObservableInput<never>,
    }): (err: any, caught: Observable<NachschlageTabelle>) => ObservableInput<NachschlageTabelle> | ObservableInput<never> {
        return (err: any, caught: Observable<NachschlageTabelle>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiNachschlageTabelleByNachschlageTabelleIdGet(nachschlageTabelleId: number): Observable<NachschlageTabelle> {
        let url_ = this.baseUrl + "/api/NachschlageTabelle/{nachschlageTabelleId}";
        if (nachschlageTabelleId === undefined || nachschlageTabelleId === null)
            throw new Error("The parameter 'nachschlageTabelleId' must be defined.");
        url_ = url_.replace("{nachschlageTabelleId}", encodeURIComponent("" + nachschlageTabelleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiNachschlageTabelleByNachschlageTabelleIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiNachschlageTabelleByNachschlageTabelleIdGet(<any>response_);
                } catch (e) {
                    return <Observable<NachschlageTabelle>><any>_observableThrow(e);
                }
            } else
                return <Observable<NachschlageTabelle>><any>_observableThrow(response_);
        }));
    }

    protected processApiNachschlageTabelleByNachschlageTabelleIdGet(response: HttpResponseBase): Observable<NachschlageTabelle> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NachschlageTabelle.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NachschlageTabelle>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiNachschlageTabelleByNachschlageTabelleIdGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<NachschlageTabelle>) => ObservableInput<NachschlageTabelle> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<NachschlageTabelle>) => ObservableInput<NachschlageTabelle> | ObservableInput<never>,
    }): (err: any, caught: Observable<NachschlageTabelle>) => ObservableInput<NachschlageTabelle> | ObservableInput<never> {
        return (err: any, caught: Observable<NachschlageTabelle>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiNachschlageTabelleByNachschlageTabelleIdWertPost(nachschlageTabelleId: number, body?: NachschlageTabelleWertInput | undefined): Observable<NachschlageTabelleWert> {
        let url_ = this.baseUrl + "/api/NachschlageTabelle/{nachschlageTabelleId}/Wert";
        if (nachschlageTabelleId === undefined || nachschlageTabelleId === null)
            throw new Error("The parameter 'nachschlageTabelleId' must be defined.");
        url_ = url_.replace("{nachschlageTabelleId}", encodeURIComponent("" + nachschlageTabelleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiNachschlageTabelleByNachschlageTabelleIdWertPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiNachschlageTabelleByNachschlageTabelleIdWertPost(<any>response_);
                } catch (e) {
                    return <Observable<NachschlageTabelleWert>><any>_observableThrow(e);
                }
            } else
                return <Observable<NachschlageTabelleWert>><any>_observableThrow(response_);
        }));
    }

    protected processApiNachschlageTabelleByNachschlageTabelleIdWertPost(response: HttpResponseBase): Observable<NachschlageTabelleWert> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = NachschlageTabelleWert.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - ClosedTable : Die Nachschlagetabelle ist geschlossen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Conflict", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NachschlageTabelleWert>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - ClosedTable : Die Nachschlagetabelle ist geschlossen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Conflict
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiNachschlageTabelleByNachschlageTabelleIdWertPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<NachschlageTabelleWert>) => ObservableInput<NachschlageTabelleWert> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<NachschlageTabelleWert>) => ObservableInput<NachschlageTabelleWert> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<NachschlageTabelleWert>) => ObservableInput<NachschlageTabelleWert> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<NachschlageTabelleWert>) => ObservableInput<NachschlageTabelleWert> | ObservableInput<never>,
    }): (err: any, caught: Observable<NachschlageTabelleWert>) => ObservableInput<NachschlageTabelleWert> | ObservableInput<never> {
        return (err: any, caught: Observable<NachschlageTabelleWert>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiNachschlageTabelleByNachschlageTabelleIdWertByNachschlageTabelleWertIdDelete(nachschlageTabelleId: number, nachschlageTabelleWertId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/NachschlageTabelle/{nachschlageTabelleId}/Wert/{nachschlageTabelleWertId}";
        if (nachschlageTabelleId === undefined || nachschlageTabelleId === null)
            throw new Error("The parameter 'nachschlageTabelleId' must be defined.");
        url_ = url_.replace("{nachschlageTabelleId}", encodeURIComponent("" + nachschlageTabelleId));
        if (nachschlageTabelleWertId === undefined || nachschlageTabelleWertId === null)
            throw new Error("The parameter 'nachschlageTabelleWertId' must be defined.");
        url_ = url_.replace("{nachschlageTabelleWertId}", encodeURIComponent("" + nachschlageTabelleWertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiNachschlageTabelleByNachschlageTabelleIdWertByNachschlageTabelleWertIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiNachschlageTabelleByNachschlageTabelleIdWertByNachschlageTabelleWertIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiNachschlageTabelleByNachschlageTabelleIdWertByNachschlageTabelleWertIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - ClosedTable : Die Nachschlagetabelle ist geschlossen\r\n - ValueInUse : Der Wert wird verwendet", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - ClosedTable : Die Nachschlagetabelle ist geschlossen\r\n - ValueInUse : Der Wert wird verwendet
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiNachschlageTabelleByNachschlageTabelleIdWertByNachschlageTabelleWertIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    apiNachschlageTabelleByNachschlageTabelleIdWerteZusammenfuehrenPost(nachschlageTabelleId: number, body?: WerteZusammenfuehrenInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/NachschlageTabelle/{nachschlageTabelleId}/WerteZusammenfuehren";
        if (nachschlageTabelleId === undefined || nachschlageTabelleId === null)
            throw new Error("The parameter 'nachschlageTabelleId' must be defined.");
        url_ = url_.replace("{nachschlageTabelleId}", encodeURIComponent("" + nachschlageTabelleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiNachschlageTabelleByNachschlageTabelleIdWerteZusammenfuehrenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiNachschlageTabelleByNachschlageTabelleIdWerteZusammenfuehrenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiNachschlageTabelleByNachschlageTabelleIdWerteZusammenfuehrenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValueNotFound : Wert nicht gefunden", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValueNotFound : Wert nicht gefunden
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiNachschlageTabelleByNachschlageTabelleIdWerteZusammenfuehrenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPSatzRulesListPost(body?: TableInput | undefined): Observable<ListPSatzRegelnResult> {
        let url_ = this.baseUrl + "/api/PSatz/Rules/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPSatzRulesListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPSatzRulesListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListPSatzRegelnResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListPSatzRegelnResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiPSatzRulesListPost(response: HttpResponseBase): Observable<ListPSatzRegelnResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListPSatzRegelnResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListPSatzRegelnResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiPSatzRulesListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListPSatzRegelnResult>) => ObservableInput<ListPSatzRegelnResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListPSatzRegelnResult>) => ObservableInput<ListPSatzRegelnResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListPSatzRegelnResult>) => ObservableInput<ListPSatzRegelnResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListPSatzRegelnResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiPSatzRulesPost(body?: PSatzRuleData | undefined): Observable<PSatzRule> {
        let url_ = this.baseUrl + "/api/PSatz/Rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPSatzRulesPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPSatzRulesPost(<any>response_);
                } catch (e) {
                    return <Observable<PSatzRule>><any>_observableThrow(e);
                }
            } else
                return <Observable<PSatzRule>><any>_observableThrow(response_);
        }));
    }

    protected processApiPSatzRulesPost(response: HttpResponseBase): Observable<PSatzRule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PSatzRule.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PSatzRule>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiPSatzRulesPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<PSatzRule>) => ObservableInput<PSatzRule> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<PSatzRule>) => ObservableInput<PSatzRule> | ObservableInput<never>,
    }): (err: any, caught: Observable<PSatzRule>) => ObservableInput<PSatzRule> | ObservableInput<never> {
        return (err: any, caught: Observable<PSatzRule>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiPSatzRulesByIdDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/PSatz/Rules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPSatzRulesByIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPSatzRulesByIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiPSatzRulesByIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiPSatzRulesByIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPSatzCleanupRulesListPost(body?: TableInput | undefined): Observable<ListPSatzBereinigungRegelnResult> {
        let url_ = this.baseUrl + "/api/PSatz/CleanupRules/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPSatzCleanupRulesListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPSatzCleanupRulesListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListPSatzBereinigungRegelnResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListPSatzBereinigungRegelnResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiPSatzCleanupRulesListPost(response: HttpResponseBase): Observable<ListPSatzBereinigungRegelnResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListPSatzBereinigungRegelnResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListPSatzBereinigungRegelnResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiPSatzCleanupRulesListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListPSatzBereinigungRegelnResult>) => ObservableInput<ListPSatzBereinigungRegelnResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListPSatzBereinigungRegelnResult>) => ObservableInput<ListPSatzBereinigungRegelnResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListPSatzBereinigungRegelnResult>) => ObservableInput<ListPSatzBereinigungRegelnResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListPSatzBereinigungRegelnResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiPSatzCleanupRulesPost(body?: PSatzCleanUpRuleData | undefined): Observable<PSatzCleanUpRule> {
        let url_ = this.baseUrl + "/api/PSatz/CleanupRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPSatzCleanupRulesPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPSatzCleanupRulesPost(<any>response_);
                } catch (e) {
                    return <Observable<PSatzCleanUpRule>><any>_observableThrow(e);
                }
            } else
                return <Observable<PSatzCleanUpRule>><any>_observableThrow(response_);
        }));
    }

    protected processApiPSatzCleanupRulesPost(response: HttpResponseBase): Observable<PSatzCleanUpRule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PSatzCleanUpRule.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PSatzCleanUpRule>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiPSatzCleanupRulesPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<PSatzCleanUpRule>) => ObservableInput<PSatzCleanUpRule> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<PSatzCleanUpRule>) => ObservableInput<PSatzCleanUpRule> | ObservableInput<never>,
    }): (err: any, caught: Observable<PSatzCleanUpRule>) => ObservableInput<PSatzCleanUpRule> | ObservableInput<never> {
        return (err: any, caught: Observable<PSatzCleanUpRule>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiPSatzCleanupRulesByIdDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/PSatz/CleanupRules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiPSatzCleanupRulesByIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiPSatzCleanupRulesByIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiPSatzCleanupRulesByIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiPSatzCleanupRulesByIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiRankingAuftragListPost(body?: TableInput | undefined): Observable<ListRankingAuftragResult> {
        let url_ = this.baseUrl + "/api/RankingAuftrag/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingAuftragListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingAuftragListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListRankingAuftragResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListRankingAuftragResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingAuftragListPost(response: HttpResponseBase): Observable<ListRankingAuftragResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListRankingAuftragResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListRankingAuftragResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingAuftragListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListRankingAuftragResult>) => ObservableInput<ListRankingAuftragResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListRankingAuftragResult>) => ObservableInput<ListRankingAuftragResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListRankingAuftragResult>) => ObservableInput<ListRankingAuftragResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListRankingAuftragResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erstellt einen Rankingauftrag
     * @param body (optional) Rankingauftrag-Daten
     * @return Rankingauftrag erstellt
     */
    apiRankingAuftragPost(body?: RankingAuftrag | undefined): Observable<RankingAuftrag> {
        let url_ = this.baseUrl + "/api/RankingAuftrag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingAuftragPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingAuftragPost(<any>response_);
                } catch (e) {
                    return <Observable<RankingAuftrag>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankingAuftrag>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingAuftragPost(response: HttpResponseBase): Observable<RankingAuftrag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RankingAuftrag.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Offener Rankingauftrag existiert bereits", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankingAuftrag>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Offener Rankingauftrag existiert bereits
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingAuftragPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never>,
    }): (err: any, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never> {
        return (err: any, caught: Observable<RankingAuftrag>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert einen Rankingauftrag
     * @param id Rankingauftrag-Id
     * @return Rankingauftrag
     */
    apiRankingAuftragByIdGet(id: number): Observable<RankingAuftrag> {
        let url_ = this.baseUrl + "/api/RankingAuftrag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingAuftragByIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingAuftragByIdGet(<any>response_);
                } catch (e) {
                    return <Observable<RankingAuftrag>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankingAuftrag>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingAuftragByIdGet(response: HttpResponseBase): Observable<RankingAuftrag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RankingAuftrag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Rankingauftrag existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankingAuftrag>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Rankingauftrag existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingAuftragByIdGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never>,
    }): (err: any, caught: Observable<RankingAuftrag>) => ObservableInput<RankingAuftrag> | ObservableInput<never> {
        return (err: any, caught: Observable<RankingAuftrag>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Löscht einen Rankingauftrag
     * @param id Rankingauftrag-Id
     * @return Rankingauftrag gelöscht
     */
    apiRankingAuftragByIdDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RankingAuftrag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingAuftragByIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingAuftragByIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingAuftragByIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Rankingauftrag existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Rankingauftrag existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingAuftragByIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert die Statistik
     * @param id Rankingauftrag-Id
     * @return Statistik
     */
    apiRankingAuftragByIdStatistikGet(id: number): Observable<RankingAuftragStatistik> {
        let url_ = this.baseUrl + "/api/RankingAuftrag/{id}/Statistik";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingAuftragByIdStatistikGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingAuftragByIdStatistikGet(<any>response_);
                } catch (e) {
                    return <Observable<RankingAuftragStatistik>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankingAuftragStatistik>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingAuftragByIdStatistikGet(response: HttpResponseBase): Observable<RankingAuftragStatistik> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RankingAuftragStatistik.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Rankingauftrag/Statistik existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankingAuftragStatistik>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Rankingauftrag/Statistik existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingAuftragByIdStatistikGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<RankingAuftragStatistik>) => ObservableInput<RankingAuftragStatistik> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<RankingAuftragStatistik>) => ObservableInput<RankingAuftragStatistik> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<RankingAuftragStatistik>) => ObservableInput<RankingAuftragStatistik> | ObservableInput<never>,
    }): (err: any, caught: Observable<RankingAuftragStatistik>) => ObservableInput<RankingAuftragStatistik> | ObservableInput<never> {
        return (err: any, caught: Observable<RankingAuftragStatistik>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiRankingRegelListPost(body?: TableInput | undefined): Observable<ListRankingRegelResult> {
        let url_ = this.baseUrl + "/api/RankingRegel/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRegelListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRegelListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListRankingRegelResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListRankingRegelResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRegelListPost(response: HttpResponseBase): Observable<ListRankingRegelResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListRankingRegelResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListRankingRegelResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRegelListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListRankingRegelResult>) => ObservableInput<ListRankingRegelResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListRankingRegelResult>) => ObservableInput<ListRankingRegelResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListRankingRegelResult>) => ObservableInput<ListRankingRegelResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListRankingRegelResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiRankingRuleAutoCompleteLieferantenGet(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RankingRule/AutoComplete/Lieferanten";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRuleAutoCompleteLieferantenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRuleAutoCompleteLieferantenGet(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRuleAutoCompleteLieferantenGet(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRuleAutoCompleteLieferantenGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never> {
        return (err: any, caught: Observable<string[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiRankingRuleAutoCompleteNachschlageTabellenGet(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RankingRule/AutoComplete/NachschlageTabellen";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRuleAutoCompleteNachschlageTabellenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRuleAutoCompleteNachschlageTabellenGet(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRuleAutoCompleteNachschlageTabellenGet(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRuleAutoCompleteNachschlageTabellenGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never> {
        return (err: any, caught: Observable<string[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Listet alle Rankingregeln auf.
     * @return Liste der Rankingregeln
     */
    apiRankingRuleGet(): Observable<RankingRule[]> {
        let url_ = this.baseUrl + "/api/RankingRule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRuleGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRuleGet(<any>response_);
                } catch (e) {
                    return <Observable<RankingRule[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankingRule[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRuleGet(response: HttpResponseBase): Observable<RankingRule[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RankingRule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankingRule[]>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRuleGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<RankingRule[]>) => ObservableInput<RankingRule[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<RankingRule[]>) => ObservableInput<RankingRule[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<RankingRule[]>) => ObservableInput<RankingRule[]> | ObservableInput<never> {
        return (err: any, caught: Observable<RankingRule[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erstellt eine Rankingregel
     * @param body (optional) Rankingregel-Daten
     * @return Rankingregel erstellt
     */
    apiRankingRulePost(body?: RankingRule | undefined): Observable<RankingRule> {
        let url_ = this.baseUrl + "/api/RankingRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRulePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRulePost(<any>response_);
                } catch (e) {
                    return <Observable<RankingRule>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankingRule>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRulePost(response: HttpResponseBase): Observable<RankingRule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RankingRule.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Eine Rankingregel mit demselben Namen existiert bereits", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankingRule>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Eine Rankingregel mit demselben Namen existiert bereits
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRulePostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
    }): (err: any, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never> {
        return (err: any, caught: Observable<RankingRule>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert eine Rankingregel
     * @param name Rankingregel-Name
     * @return Rankingregel
     */
    apiRankingRuleByNameGet(name: string): Observable<RankingRule> {
        let url_ = this.baseUrl + "/api/RankingRule/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRuleByNameGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRuleByNameGet(<any>response_);
                } catch (e) {
                    return <Observable<RankingRule>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankingRule>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRuleByNameGet(response: HttpResponseBase): Observable<RankingRule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RankingRule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Rankingregel existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankingRule>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Rankingregel existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRuleByNameGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
    }): (err: any, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never> {
        return (err: any, caught: Observable<RankingRule>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Aktualisiert eine Rankingregel
     * @param name Rankingregel-Name
     * @param body (optional) Rankingregel-Daten
     * @return Rankingregel aktualisiert
     */
    apiRankingRuleByNamePut(name: string, body?: RankingRule | undefined): Observable<RankingRule> {
        let url_ = this.baseUrl + "/api/RankingRule/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRuleByNamePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRuleByNamePut(<any>response_);
                } catch (e) {
                    return <Observable<RankingRule>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankingRule>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRuleByNamePut(response: HttpResponseBase): Observable<RankingRule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RankingRule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Rankingregel existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Eine Rankingregel mit demselben Namen existiert bereits", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankingRule>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Rankingregel existiert nicht
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Eine Rankingregel mit demselben Namen existiert bereits
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRuleByNamePutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
    }): (err: any, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never> {
        return (err: any, caught: Observable<RankingRule>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Aktualisiert eine Rankingregel partiell
     * @param name Rankingregel-Name
     * @param body (optional) Partielle Rankingregel-Daten
     * @return Rankingregel aktualisiert
     */
    apiRankingRuleByNamePatch(name: string, body?: RankingRule | undefined): Observable<RankingRule> {
        let url_ = this.baseUrl + "/api/RankingRule/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRuleByNamePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRuleByNamePatch(<any>response_);
                } catch (e) {
                    return <Observable<RankingRule>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankingRule>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRuleByNamePatch(response: HttpResponseBase): Observable<RankingRule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RankingRule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Rankingregel existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Eine Rankingregel mit demselben Namen existiert bereits", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankingRule>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Rankingregel existiert nicht
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Eine Rankingregel mit demselben Namen existiert bereits
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRuleByNamePatchErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never>,
    }): (err: any, caught: Observable<RankingRule>) => ObservableInput<RankingRule> | ObservableInput<never> {
        return (err: any, caught: Observable<RankingRule>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Löscht eine Rankingregel
     * @param name Rankingregel-Name
     * @return Rankingregel gelöscht
     */
    apiRankingRuleByNameDelete(name: string): Observable<void> {
        let url_ = this.baseUrl + "/api/RankingRule/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiRankingRuleByNameDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiRankingRuleByNameDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiRankingRuleByNameDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Rankingregel existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Rankingregel existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiRankingRuleByNameDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiSettingsGet(): Observable<Setting[]> {
        let url_ = this.baseUrl + "/api/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSettingsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSettingsGet(<any>response_);
                } catch (e) {
                    return <Observable<Setting[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Setting[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiSettingsGet(response: HttpResponseBase): Observable<Setting[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Setting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Setting[]>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSettingsGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<Setting[]>) => ObservableInput<Setting[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Setting[]>) => ObservableInput<Setting[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<Setting[]>) => ObservableInput<Setting[]> | ObservableInput<never> {
        return (err: any, caught: Observable<Setting[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiSettingsByKeyPut(key: string, body?: string | undefined): Observable<Setting> {
        let url_ = this.baseUrl + "/api/Settings/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSettingsByKeyPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSettingsByKeyPut(<any>response_);
                } catch (e) {
                    return <Observable<Setting>><any>_observableThrow(e);
                }
            } else
                return <Observable<Setting>><any>_observableThrow(response_);
        }));
    }

    protected processApiSettingsByKeyPut(response: HttpResponseBase): Observable<Setting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Setting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Setting>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSettingsByKeyPutErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<Setting>) => ObservableInput<Setting> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Setting>) => ObservableInput<Setting> | ObservableInput<never>,
    }): (err: any, caught: Observable<Setting>) => ObservableInput<Setting> | ObservableInput<never> {
        return (err: any, caught: Observable<Setting>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert ein Dossier zu einer Spezies.
     * @param speziesId Spezies-Id
     * @return Dossier
     */
    apiSpeziesBySpeziesIdGet(speziesId: number): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Spezies/{speziesId}";
        if (speziesId === undefined || speziesId === null)
            throw new Error("The parameter 'speziesId' must be defined.");
        url_ = url_.replace("{speziesId}", encodeURIComponent("" + speziesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSpeziesBySpeziesIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSpeziesBySpeziesIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiSpeziesBySpeziesIdGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Spezies existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Spezies existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSpeziesBySpeziesIdGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Löscht eine bestehende Spezies.
     * @param speziesId Spezies-Id
     * @return Spezies wurde gelöscht
     */
    apiSpeziesBySpeziesIdDelete(speziesId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Spezies/{speziesId}";
        if (speziesId === undefined || speziesId === null)
            throw new Error("The parameter 'speziesId' must be defined.");
        url_ = url_.replace("{speziesId}", encodeURIComponent("" + speziesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSpeziesBySpeziesIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSpeziesBySpeziesIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiSpeziesBySpeziesIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ReferenceViolation : Referentielle Integrit\u00e4t wird verletzt\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Spezies existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ReferenceViolation : Referentielle Integrit\u00e4t wird verletzt\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Spezies existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSpeziesBySpeziesIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert eine Liste von Objekten, die die Spezies referenzieren.
     * @param speziesId Spezies-Id
     * @param skip (optional) Anzahl der Elemente, die übersprungen werden
     * @param pageSize (optional) Maximale Anzahl der Elemente
     * @return Referenzen
     */
    apiSpeziesBySpeziesIdReferenziertDurchGet(speziesId: number, skip?: number | undefined, pageSize?: number | undefined): Observable<ReferencesResult> {
        let url_ = this.baseUrl + "/api/Spezies/{speziesId}/ReferenziertDurch?";
        if (speziesId === undefined || speziesId === null)
            throw new Error("The parameter 'speziesId' must be defined.");
        url_ = url_.replace("{speziesId}", encodeURIComponent("" + speziesId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSpeziesBySpeziesIdReferenziertDurchGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSpeziesBySpeziesIdReferenziertDurchGet(<any>response_);
                } catch (e) {
                    return <Observable<ReferencesResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReferencesResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiSpeziesBySpeziesIdReferenziertDurchGet(response: HttpResponseBase): Observable<ReferencesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferencesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferencesResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSpeziesBySpeziesIdReferenziertDurchGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ReferencesResult>) => ObservableInput<ReferencesResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ReferencesResult>) => ObservableInput<ReferencesResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ReferencesResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Erstellung einer neuen Spezies.
     * @return Informationen zur Erstellung einer neuen Spezies
     */
    apiSpeziesErstellenGet(): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Spezies/Erstellen";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSpeziesErstellenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSpeziesErstellenGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiSpeziesErstellenGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSpeziesErstellenGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erstellt eine neue Spezies.
     * @param body (optional) Eingaben
     * @return Spezies wurden erstellt
     */
    apiSpeziesErstellenPost(body?: any | undefined): Observable<NeuesObjektErstellenCreated> {
        let url_ = this.baseUrl + "/api/Spezies/Erstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSpeziesErstellenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSpeziesErstellenPost(<any>response_);
                } catch (e) {
                    return <Observable<NeuesObjektErstellenCreated>><any>_observableThrow(e);
                }
            } else
                return <Observable<NeuesObjektErstellenCreated>><any>_observableThrow(response_);
        }));
    }

    protected processApiSpeziesErstellenPost(response: HttpResponseBase): Observable<NeuesObjektErstellenCreated> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = NeuesObjektErstellenCreated.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Spezies mit der ID existiert bereits", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NeuesObjektErstellenCreated>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Spezies mit der ID existiert bereits
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSpeziesErstellenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<NeuesObjektErstellenCreated>) => ObservableInput<NeuesObjektErstellenCreated> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<NeuesObjektErstellenCreated>) => ObservableInput<NeuesObjektErstellenCreated> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<NeuesObjektErstellenCreated>) => ObservableInput<NeuesObjektErstellenCreated> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<NeuesObjektErstellenCreated>) => ObservableInput<NeuesObjektErstellenCreated> | ObservableInput<never>,
    }): (err: any, caught: Observable<NeuesObjektErstellenCreated>) => ObservableInput<NeuesObjektErstellenCreated> | ObservableInput<never> {
        return (err: any, caught: Observable<NeuesObjektErstellenCreated>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Bearbeitung einer bestehenden Spezies.
     * @param speziesId Spezies-Id
     * @return Informationen zur Bearbeitung einer bestehenden Spezies
     */
    apiSpeziesBySpeziesIdBearbeitenGet(speziesId: number): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Spezies/{speziesId}/Bearbeiten";
        if (speziesId === undefined || speziesId === null)
            throw new Error("The parameter 'speziesId' must be defined.");
        url_ = url_.replace("{speziesId}", encodeURIComponent("" + speziesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSpeziesBySpeziesIdBearbeitenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSpeziesBySpeziesIdBearbeitenGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiSpeziesBySpeziesIdBearbeitenGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Spezies existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Spezies existiert nicht
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSpeziesBySpeziesIdBearbeitenGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Bearbeitet eine bestehende Spezies.
     * @param speziesId Spezies-Id
     * @param body (optional) Eingaben
     * @return Spezies wurde aktualisiert
     */
    apiSpeziesBySpeziesIdBearbeitenPut(speziesId: number, body?: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Spezies/{speziesId}/Bearbeiten";
        if (speziesId === undefined || speziesId === null)
            throw new Error("The parameter 'speziesId' must be defined.");
        url_ = url_.replace("{speziesId}", encodeURIComponent("" + speziesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSpeziesBySpeziesIdBearbeitenPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSpeziesBySpeziesIdBearbeitenPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiSpeziesBySpeziesIdBearbeitenPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Spezies existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Spezies existiert nicht
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSpeziesBySpeziesIdBearbeitenPutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert ein Dossier.
     * @param stoffId Stoff-Id
     * @param thesaurierteSachverhalteAufloesen (optional) Sachverhalte aus verknüpften Stoffen reinziehen
     * @return Stoff
     */
    apiStoffByStoffIdGet(stoffId: string, thesaurierteSachverhalteAufloesen?: boolean | undefined): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}?";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (thesaurierteSachverhalteAufloesen === null)
            throw new Error("The parameter 'thesaurierteSachverhalteAufloesen' cannot be null.");
        else if (thesaurierteSachverhalteAufloesen !== undefined)
            url_ += "thesaurierteSachverhalteAufloesen=" + encodeURIComponent("" + thesaurierteSachverhalteAufloesen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert eine Liste von Objekten, die den Stoff referenzieren.
     * @param stoffId Stoff-Id
     * @param skip (optional) Anzahl der Elemente, die übersprungen werden
     * @param pageSize (optional) Maximale Anzahl der Elemente
     * @return ReferenziertDurch
     */
    apiStoffByStoffIdReferenziertDurchGet(stoffId: string, skip?: number | undefined, pageSize?: number | undefined): Observable<ReferencesResult> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/ReferenziertDurch?";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdReferenziertDurchGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdReferenziertDurchGet(<any>response_);
                } catch (e) {
                    return <Observable<ReferencesResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReferencesResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdReferenziertDurchGet(response: HttpResponseBase): Observable<ReferencesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferencesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferencesResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdReferenziertDurchGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ReferencesResult>) => ObservableInput<ReferencesResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ReferencesResult>) => ObservableInput<ReferencesResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ReferencesResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Erstellung eines neuen Dossiers.
     * @return Informationen zur Erstellung eines neuen Dossiers
     */
    apiStoffErstellenGet(): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Stoff/Erstellen";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffErstellenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffErstellenGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffErstellenGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffErstellenGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erstellt einen neues Dossier.
     * @param body (optional) Eingaben
     * @return Erfassung + ErfassungSachverhalt wurden erstellt
     */
    apiStoffErstellenPost(body?: any | undefined): Observable<StoffErstellenCreated> {
        let url_ = this.baseUrl + "/api/Stoff/Erstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffErstellenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffErstellenPost(<any>response_);
                } catch (e) {
                    return <Observable<StoffErstellenCreated>><any>_observableThrow(e);
                }
            } else
                return <Observable<StoffErstellenCreated>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffErstellenPost(response: HttpResponseBase): Observable<StoffErstellenCreated> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = StoffErstellenCreated.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoffErstellenCreated>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffErstellenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<StoffErstellenCreated>) => ObservableInput<StoffErstellenCreated> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<StoffErstellenCreated>) => ObservableInput<StoffErstellenCreated> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<StoffErstellenCreated>) => ObservableInput<StoffErstellenCreated> | ObservableInput<never>,
    }): (err: any, caught: Observable<StoffErstellenCreated>) => ObservableInput<StoffErstellenCreated> | ObservableInput<never> {
        return (err: any, caught: Observable<StoffErstellenCreated>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert die Dossieransicht der Erfassung.
     * @param stoffId Stoff-Id
     * @param thesaurierteSachverhalteAufloesen (optional) Sachverhalte aus verknüpften Stoffen reinziehen
     * @return Stoff
     */
    apiStoffByStoffIdBearbeitenGet(stoffId: string, thesaurierteSachverhalteAufloesen?: boolean | undefined): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten?";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (thesaurierteSachverhalteAufloesen === null)
            throw new Error("The parameter 'thesaurierteSachverhalteAufloesen' cannot be null.");
        else if (thesaurierteSachverhalteAufloesen !== undefined)
            url_ += "thesaurierteSachverhalteAufloesen=" + encodeURIComponent("" + thesaurierteSachverhalteAufloesen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Setzt alle Änderungen am Stoff zurück.
     * @param stoffId Stoff-Id
     * @return Alle Änderungen wurden, falls vorhanden, rückgängig gemacht
     */
    apiStoffByStoffIdBearbeitenDelete(stoffId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenDeleteErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erzeugt eine Thesaurierungsvorschau.
     * @param stoffId Stoff-Id
     * @param thesaurierteSachverhalteAufloesen (optional) Sachverhalte aus verknüpften Stoffen reinziehen
     * @return Stoff
     */
    apiStoffByStoffIdBearbeitenThesaurierungVorschauGet(stoffId: string, thesaurierteSachverhalteAufloesen?: boolean | undefined): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/ThesaurierungVorschau?";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (thesaurierteSachverhalteAufloesen === null)
            throw new Error("The parameter 'thesaurierteSachverhalteAufloesen' cannot be null.");
        else if (thesaurierteSachverhalteAufloesen !== undefined)
            url_ += "thesaurierteSachverhalteAufloesen=" + encodeURIComponent("" + thesaurierteSachverhalteAufloesen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenThesaurierungVorschauGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenThesaurierungVorschauGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenThesaurierungVorschauGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenThesaurierungVorschauGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    apiStoffByStoffIdLoeschenPost(stoffId: string, body?: LoeschenRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Loeschen";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdLoeschenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdLoeschenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdLoeschenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt\r\n - ReferenceViolation : Referentielle Integrit\u00e4t wird verletzt", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt\r\n - ReferenceViolation : Referentielle Integrit\u00e4t wird verletzt
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdLoeschenPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Erstellung eines neuen Sachverhalts.
     * @param stoffId Stoff-Id
     * @param merkmal (optional) Schlüssel des Merkmals (z.B. RNAME)
     * @return Informationen zur Erstellung eines neuen Sachverhalts
     */
    apiStoffByStoffIdBearbeitenNeuerSachverhaltGet(stoffId: string, merkmal?: string | undefined): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/NeuerSachverhalt?";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (merkmal === null)
            throw new Error("The parameter 'merkmal' cannot be null.");
        else if (merkmal !== undefined)
            url_ += "merkmal=" + encodeURIComponent("" + merkmal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenNeuerSachverhaltGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenNeuerSachverhaltGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erstellt einen neuen Sachverhalt.
     * @param stoffId Stoff-Id
     * @param merkmal (optional) Schlüssel des Merkmals (z.B. RNAME)
     * @param body (optional) Eingaben
     * @return ErfassungSachverhalt wurde erstellt
     */
    apiStoffByStoffIdBearbeitenNeuerSachverhaltPost(stoffId: string, merkmal?: string | undefined, body?: any | undefined): Observable<PartialDossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/NeuerSachverhalt?";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (merkmal === null)
            throw new Error("The parameter 'merkmal' cannot be null.");
        else if (merkmal !== undefined)
            url_ += "merkmal=" + encodeURIComponent("" + merkmal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltPost(<any>response_);
                } catch (e) {
                    return <Observable<PartialDossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartialDossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenNeuerSachverhaltPost(response: HttpResponseBase): Observable<PartialDossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartialDossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - DuplicateCopy : Sachverhalt ist Duplikat\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Dossier existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartialDossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - DuplicateCopy : Sachverhalt ist Duplikat\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Dossier existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenNeuerSachverhaltPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never> {
        return (err: any, caught: Observable<PartialDossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Bearbeitung eines neu erstellten Sachverhalts.
     * @param stoffId Stoff-Id
     * @param erfassungSachverhaltId ErfassungSachverhalt-Id
     * @return Informationen zur Bearbeitung eines neu erstellten Sachverhalts
     */
    apiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdGet(stoffId: string, erfassungSachverhaltId: number): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/NeuerSachverhalt/{erfassungSachverhaltId}";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (erfassungSachverhaltId === undefined || erfassungSachverhaltId === null)
            throw new Error("The parameter 'erfassungSachverhaltId' must be defined.");
        url_ = url_.replace("{erfassungSachverhaltId}", encodeURIComponent("" + erfassungSachverhaltId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Erfassung/ErfassungSachverhalt existieren nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Erfassung/ErfassungSachverhalt existieren nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Bearbeitet einen neuen Sachverhalt.
     * @param stoffId Stoff-Id
     * @param erfassungSachverhaltId ErfassungSachverhalt-Id
     * @param body (optional) Eingaben
     * @return ErfassungSachverhalt wurde aktualisiert
     */
    apiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdPut(stoffId: string, erfassungSachverhaltId: number, body?: any | undefined): Observable<PartialDossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/NeuerSachverhalt/{erfassungSachverhaltId}";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (erfassungSachverhaltId === undefined || erfassungSachverhaltId === null)
            throw new Error("The parameter 'erfassungSachverhaltId' must be defined.");
        url_ = url_.replace("{erfassungSachverhaltId}", encodeURIComponent("" + erfassungSachverhaltId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdPut(<any>response_);
                } catch (e) {
                    return <Observable<PartialDossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartialDossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdPut(response: HttpResponseBase): Observable<PartialDossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartialDossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - DuplicateCopy : Sachverhalt ist Duplikat\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff/Erfassung/ErfassungSachverhalt existieren nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartialDossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - DuplicateCopy : Sachverhalt ist Duplikat\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff/Erfassung/ErfassungSachverhalt existieren nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdPutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never> {
        return (err: any, caught: Observable<PartialDossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Löscht einen neu erstellten Sachverhalt.
     * @param stoffId Stoff-Id
     * @param erfassungSachverhaltId ErfassungSachverhalt-Id
     * @return ErfassungSachverhalt wurde gelöscht
     */
    apiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdDelete(stoffId: string, erfassungSachverhaltId: number): Observable<PartialDossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/NeuerSachverhalt/{erfassungSachverhaltId}";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (erfassungSachverhaltId === undefined || erfassungSachverhaltId === null)
            throw new Error("The parameter 'erfassungSachverhaltId' must be defined.");
        url_ = url_.replace("{erfassungSachverhaltId}", encodeURIComponent("" + erfassungSachverhaltId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<PartialDossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartialDossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdDelete(response: HttpResponseBase): Observable<PartialDossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartialDossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff/Erfassung/ErfassungSachverhalt existieren nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartialDossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff/Erfassung/ErfassungSachverhalt existieren nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenNeuerSachverhaltByErfassungSachverhaltIdDeleteErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never> {
        return (err: any, caught: Observable<PartialDossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Bearbeitung eines bestehenden Sachverhalts.
     * @param stoffId Stoff-Id
     * @param sachverhaltId Sachverhalt-Id
     * @return Informationen zur Bearbeitung eines bestehenden Sachverhalts
     */
    apiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdGet(stoffId: string, sachverhaltId: number): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/Sachverhalt/{sachverhaltId}";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (sachverhaltId === undefined || sachverhaltId === null)
            throw new Error("The parameter 'sachverhaltId' must be defined.");
        url_ = url_.replace("{sachverhaltId}", encodeURIComponent("" + sachverhaltId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff/Sachverhalt existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff/Sachverhalt existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Bearbeitet einen bestehenden Sachverhalt.
     * @param stoffId Stoff-Id
     * @param sachverhaltId Sachverhalt-Id
     * @param body (optional) Eingaben
     * @return Sachverhalt wurde aktualisiert
     */
    apiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdPut(stoffId: string, sachverhaltId: number, body?: any | undefined): Observable<PartialDossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/Sachverhalt/{sachverhaltId}";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (sachverhaltId === undefined || sachverhaltId === null)
            throw new Error("The parameter 'sachverhaltId' must be defined.");
        url_ = url_.replace("{sachverhaltId}", encodeURIComponent("" + sachverhaltId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdPut(<any>response_);
                } catch (e) {
                    return <Observable<PartialDossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartialDossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdPut(response: HttpResponseBase): Observable<PartialDossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartialDossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - DuplicateCopy : Sachverhalt ist Duplikat\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff/Sachverhalt existieren nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartialDossier>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - DuplicateCopy : Sachverhalt ist Duplikat\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff/Sachverhalt existieren nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdPutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never> {
        return (err: any, caught: Observable<PartialDossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Setzt die Änderung an einem Sachverhalt zurück.
    Sollte die Erfassung anschließend keine Änderungen mehr beinhalten, wird sie ebenfalls gelöscht.
     * @param stoffId Stoff-Id
     * @param sachverhaltId Sachverhalt-Id
     * @return Änderungen wurden, falls vorhanden, rückgängig gemacht
     */
    apiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdDelete(stoffId: string, sachverhaltId: number): Observable<PartialDossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/Sachverhalt/{sachverhaltId}";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (sachverhaltId === undefined || sachverhaltId === null)
            throw new Error("The parameter 'sachverhaltId' must be defined.");
        url_ = url_.replace("{sachverhaltId}", encodeURIComponent("" + sachverhaltId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<PartialDossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartialDossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdDelete(response: HttpResponseBase): Observable<PartialDossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartialDossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff/Sachverhalt existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartialDossier>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff/Sachverhalt existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never> {
        return (err: any, caught: Observable<PartialDossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Markiert einen bestehenden Sachverhalt als gelöscht.
     * @param stoffId Stoff-Id
     * @param sachverhaltId Sachverhalt-Id
     * @return Sachverhalt wurde als gelöscht markiert
     */
    apiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdLoeschenPost(stoffId: string, sachverhaltId: number): Observable<PartialDossier> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/Sachverhalt/{sachverhaltId}/Loeschen";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        if (sachverhaltId === undefined || sachverhaltId === null)
            throw new Error("The parameter 'sachverhaltId' must be defined.");
        url_ = url_.replace("{sachverhaltId}", encodeURIComponent("" + sachverhaltId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdLoeschenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdLoeschenPost(<any>response_);
                } catch (e) {
                    return <Observable<PartialDossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartialDossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdLoeschenPost(response: HttpResponseBase): Observable<PartialDossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartialDossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff/Sachverhalt existieren nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartialDossier>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff/Sachverhalt existieren nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenSachverhaltBySachverhaltIdLoeschenPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<PartialDossier>) => ObservableInput<PartialDossier> | ObservableInput<never> {
        return (err: any, caught: Observable<PartialDossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * ChemSketch ZIP Import.
     * @param stoffId Stoff-Id
     * @param file (optional) 
     * @return ZIP wurde importiert
     */
    apiStoffByStoffIdBearbeitenChemSketchImportierenPost(stoffId: string, file?: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Bearbeiten/ChemSketchImportieren";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdBearbeitenChemSketchImportierenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdBearbeitenChemSketchImportierenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdBearbeitenChemSketchImportierenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Dossier existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Dossier existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdBearbeitenChemSketchImportierenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Überprüft die Eindeutigkeit der Identität.
     * @param stoffId Stoff-Id
     * @return Identitätsdaten
     */
    apiStoffByStoffIdIdentitaetPruefenGet(stoffId: string): Observable<IdentitaetPruefenResult> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/IdentitaetPruefen";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdIdentitaetPruefenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdIdentitaetPruefenGet(<any>response_);
                } catch (e) {
                    return <Observable<IdentitaetPruefenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<IdentitaetPruefenResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdIdentitaetPruefenGet(response: HttpResponseBase): Observable<IdentitaetPruefenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentitaetPruefenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IdentitaetPruefenResult>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - InvalidState : Ung\u00fcltiger Zustand. Erlaubte Zust\u00e4nde: \'Neu\'
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdIdentitaetPruefenGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<IdentitaetPruefenResult>) => ObservableInput<IdentitaetPruefenResult> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<IdentitaetPruefenResult>) => ObservableInput<IdentitaetPruefenResult> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<IdentitaetPruefenResult>) => ObservableInput<IdentitaetPruefenResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<IdentitaetPruefenResult>) => ObservableInput<IdentitaetPruefenResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<IdentitaetPruefenResult>) => ObservableInput<IdentitaetPruefenResult> | ObservableInput<never> {
        return (err: any, caught: Observable<IdentitaetPruefenResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Führt Stoffe zu einen Zielstoff zusammen.
     * @param stoffId Zielstoff-Id
     * @param body (optional) Quellstoffe
     * @return Stoffzusammenführung durchgeführt
     */
    apiStoffByStoffIdZusammenfuehrenPost(stoffId: string, body?: MergeRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Stoff/{stoffId}/Zusammenfuehren";
        if (stoffId === undefined || stoffId === null)
            throw new Error("The parameter 'stoffId' must be defined.");
        url_ = url_.replace("{stoffId}", encodeURIComponent("" + stoffId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffByStoffIdZusammenfuehrenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffByStoffIdZusammenfuehrenPost(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffByStoffIdZusammenfuehrenPost(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Nutzer hat schon Erfassung f\u00fcr den Stoff offen", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen\r\n - LockedByOtherUser (data: String[]) : Durch anderen Nutzer gesperrt
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff existiert nicht
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Nutzer hat schon Erfassung f\u00fcr den Stoff offen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffByStoffIdZusammenfuehrenPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never>,
    }): (err: any, caught: Observable<boolean>) => ObservableInput<boolean> | ObservableInput<never> {
        return (err: any, caught: Observable<boolean>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Kopiert Sachverhalte aus einem Stoff + Erfassung in eine Menge von Stoffen.
     * @param body (optional) Anfrage
     * @return Anfrage bearbeitet.
     */
    apiStoffSachverhalteKopierenPost(body?: SachverhalteKopierenRequest | undefined): Observable<SachverhalteKopierenResponseItem[]> {
        let url_ = this.baseUrl + "/api/Stoff/SachverhalteKopieren";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffSachverhalteKopierenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffSachverhalteKopierenPost(<any>response_);
                } catch (e) {
                    return <Observable<SachverhalteKopierenResponseItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhalteKopierenResponseItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffSachverhalteKopierenPost(response: HttpResponseBase): Observable<SachverhalteKopierenResponseItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SachverhalteKopierenResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Stoff existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhalteKopierenResponseItem[]>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Stoff existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffSachverhalteKopierenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<SachverhalteKopierenResponseItem[]>) => ObservableInput<SachverhalteKopierenResponseItem[]> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<SachverhalteKopierenResponseItem[]>) => ObservableInput<SachverhalteKopierenResponseItem[]> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<SachverhalteKopierenResponseItem[]>) => ObservableInput<SachverhalteKopierenResponseItem[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhalteKopierenResponseItem[]>) => ObservableInput<SachverhalteKopierenResponseItem[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhalteKopierenResponseItem[]>) => ObservableInput<SachverhalteKopierenResponseItem[]> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhalteKopierenResponseItem[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert die Merkmalssperren für eine Liste von Stoffen.
     * @param body (optional) 
     * @return OK
     */
    apiStoffBatchMerkmalSperrenPost(body?: BatchGetAttributeLocksRequest | undefined): Observable<ObjectAttributeLock[]> {
        let url_ = this.baseUrl + "/api/Stoff/Batch/MerkmalSperren";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffBatchMerkmalSperrenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffBatchMerkmalSperrenPost(<any>response_);
                } catch (e) {
                    return <Observable<ObjectAttributeLock[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ObjectAttributeLock[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffBatchMerkmalSperrenPost(response: HttpResponseBase): Observable<ObjectAttributeLock[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObjectAttributeLock.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ObjectAttributeLock[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffBatchMerkmalSperrenPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ObjectAttributeLock[]>) => ObservableInput<ObjectAttributeLock[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<ObjectAttributeLock[]>) => ObservableInput<ObjectAttributeLock[]> | ObservableInput<never> {
        return (err: any, caught: Observable<ObjectAttributeLock[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Erstellung eines neuen Sachverhalts.
     * @param merkmal (optional) Schlüssel des Merkmals (z.B. RNAME)
     * @return Informationen zur Erstellung eines neuen Sachverhalts
     */
    apiStoffBatchNeuerSachverhaltGet(merkmal?: string | undefined): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Stoff/Batch/NeuerSachverhalt?";
        if (merkmal === null)
            throw new Error("The parameter 'merkmal' cannot be null.");
        else if (merkmal !== undefined)
            url_ += "merkmal=" + encodeURIComponent("" + merkmal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffBatchNeuerSachverhaltGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffBatchNeuerSachverhaltGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffBatchNeuerSachverhaltGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffBatchNeuerSachverhaltGetErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Beantragt die Erstellung eines neuen Sachverhalts in mehreren Stoffen.
     * @param merkmal (optional) Schlüssel des Merkmals (z.B. RNAME)
     * @param batchMode (optional) Verarbeitungsmodus
     * @param body (optional) Enthält die Eingabe und die Ids der Objekte
     * @return Die Verarbeitung wurde abgeschlossen
     */
    apiStoffBatchNeuerSachverhaltPost(merkmal?: string | undefined, batchMode?: BatchMode | undefined, body?: BatchAddFactRequest | undefined): Observable<BatchResult> {
        let url_ = this.baseUrl + "/api/Stoff/Batch/NeuerSachverhalt?";
        if (merkmal === null)
            throw new Error("The parameter 'merkmal' cannot be null.");
        else if (merkmal !== undefined)
            url_ += "merkmal=" + encodeURIComponent("" + merkmal) + "&";
        if (batchMode === null)
            throw new Error("The parameter 'batchMode' cannot be null.");
        else if (batchMode !== undefined)
            url_ += "batchMode=" + encodeURIComponent("" + batchMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffBatchNeuerSachverhaltPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffBatchNeuerSachverhaltPost(<any>response_);
                } catch (e) {
                    return <Observable<BatchResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<BatchResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffBatchNeuerSachverhaltPost(response: HttpResponseBase): Observable<BatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchResult>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - RuleValidationFailed (data: RuleValidationResult[]) : Validierung durch Regeln fehlgeschlagen\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - SupplierIsNotAssigned : Lieferant ist nicht dem Merkmal zugeordnet
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffBatchNeuerSachverhaltPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<BatchResult>) => ObservableInput<BatchResult> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<BatchResult>) => ObservableInput<BatchResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<BatchResult>) => ObservableInput<BatchResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<BatchResult>) => ObservableInput<BatchResult> | ObservableInput<never> {
        return (err: any, caught: Observable<BatchResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Beantragt die Löschung mehrerer Stoffe.
     * @param batchMode (optional) Verarbeitungsmodus
     * @param body (optional) Enthält die Ids der zu löschenden Objekte
     * @return Die Verarbeitung wurde abgeschlossen
     */
    apiStoffBatchLoeschenPost(batchMode?: BatchMode2 | undefined, body?: BatchDeleteRequest | undefined): Observable<BatchResult> {
        let url_ = this.baseUrl + "/api/Stoff/Batch/Loeschen?";
        if (batchMode === null)
            throw new Error("The parameter 'batchMode' cannot be null.");
        else if (batchMode !== undefined)
            url_ += "batchMode=" + encodeURIComponent("" + batchMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiStoffBatchLoeschenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiStoffBatchLoeschenPost(<any>response_);
                } catch (e) {
                    return <Observable<BatchResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<BatchResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiStoffBatchLoeschenPost(response: HttpResponseBase): Observable<BatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiStoffBatchLoeschenPostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<BatchResult>) => ObservableInput<BatchResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<BatchResult>) => ObservableInput<BatchResult> | ObservableInput<never> {
        return (err: any, caught: Observable<BatchResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Führt eine Suche durch oder navigiert durch die Treffer der Stoffliste.
     * @param body (optional) Suchanfrage
     * @return Ergebnisliste
     */
    apiSuchePost(body?: Suchanfrage | undefined): Observable<SearchResult> {
        let url_ = this.baseUrl + "/api/Suche";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSuchePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSuchePost(<any>response_);
                } catch (e) {
                    return <Observable<SearchResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiSuchePost(response: HttpResponseBase): Observable<SearchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchResult>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSuchePostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<SearchResult>) => ObservableInput<SearchResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SearchResult>) => ObservableInput<SearchResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<SearchResult>) => ObservableInput<SearchResult> | ObservableInput<never> {
        return (err: any, caught: Observable<SearchResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Konvertiert eine Tabellensuche in einen Profisuche-Ausdruck.
     * @param body (optional) Tabellensuche
     * @return Profisuche-Ausdruck
     */
    apiSucheConvertQueryTabellenSucheToProfiSuchePost(body?: TabellenSucheZeile[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Suche/ConvertQueryTabellenSucheToProfiSuche";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSucheConvertQueryTabellenSucheToProfiSuchePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSucheConvertQueryTabellenSucheToProfiSuchePost(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processApiSucheConvertQueryTabellenSucheToProfiSuchePost(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSucheConvertQueryTabellenSucheToProfiSuchePostErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<string>) => ObservableInput<string> | ObservableInput<never>,
    }): (err: any, caught: Observable<string>) => ObservableInput<string> | ObservableInput<never> {
        return (err: any, caught: Observable<string>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Konvertiert eine einfache Suche in einen Profisuche-Ausdruck.
     * @param kontext Objekttyp
     * @param body (optional) Einfache Suche
     * @return Profisuche-Ausdruck
     */
    apiSucheByKontextConvertQueryEinfacheSucheToProfiSuchePost(kontext: ObjektTyp, body?: StringObjectKeyValuePair[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Suche/{kontext}/ConvertQueryEinfacheSucheToProfiSuche";
        if (kontext === undefined || kontext === null)
            throw new Error("The parameter 'kontext' must be defined.");
        url_ = url_.replace("{kontext}", encodeURIComponent("" + kontext));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSucheByKontextConvertQueryEinfacheSucheToProfiSuchePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSucheByKontextConvertQueryEinfacheSucheToProfiSuchePost(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processApiSucheByKontextConvertQueryEinfacheSucheToProfiSuchePost(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSucheByKontextConvertQueryEinfacheSucheToProfiSuchePostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<string>) => ObservableInput<string> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<string>) => ObservableInput<string> | ObservableInput<never>,
    }): (err: any, caught: Observable<string>) => ObservableInput<string> | ObservableInput<never> {
        return (err: any, caught: Observable<string>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert das Suchmodell der einfachen Suche.
     * @param kontext Objekttyp
     * @return Suchmodell
     */
    apiSucheByKontextEinfacheSucheModelGet(kontext: ObjektTyp): Observable<EinfacheSucheFeld[]> {
        let url_ = this.baseUrl + "/api/Suche/{kontext}/EinfacheSucheModel";
        if (kontext === undefined || kontext === null)
            throw new Error("The parameter 'kontext' must be defined.");
        url_ = url_.replace("{kontext}", encodeURIComponent("" + kontext));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSucheByKontextEinfacheSucheModelGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSucheByKontextEinfacheSucheModelGet(<any>response_);
                } catch (e) {
                    return <Observable<EinfacheSucheFeld[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EinfacheSucheFeld[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiSucheByKontextEinfacheSucheModelGet(response: HttpResponseBase): Observable<EinfacheSucheFeld[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EinfacheSucheFeld.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EinfacheSucheFeld[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSucheByKontextEinfacheSucheModelGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<EinfacheSucheFeld[]>) => ObservableInput<EinfacheSucheFeld[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<EinfacheSucheFeld[]>) => ObservableInput<EinfacheSucheFeld[]> | ObservableInput<never> {
        return (err: any, caught: Observable<EinfacheSucheFeld[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert das Suchmodell der Tabellensuche.
     * @return Suchmodell
     */
    apiSucheTabellenSucheModelGet(): Observable<TabellenSucheKey[]> {
        let url_ = this.baseUrl + "/api/Suche/TabellenSucheModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSucheTabellenSucheModelGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSucheTabellenSucheModelGet(<any>response_);
                } catch (e) {
                    return <Observable<TabellenSucheKey[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TabellenSucheKey[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiSucheTabellenSucheModelGet(response: HttpResponseBase): Observable<TabellenSucheKey[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TabellenSucheKey.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TabellenSucheKey[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSucheTabellenSucheModelGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<TabellenSucheKey[]>) => ObservableInput<TabellenSucheKey[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<TabellenSucheKey[]>) => ObservableInput<TabellenSucheKey[]> | ObservableInput<never> {
        return (err: any, caught: Observable<TabellenSucheKey[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert alle möglichen Nachschlagewerte anhand des Merkmal/Feld- oder Index-Schlüssels (z.B. RNAME.RNAME oder INDEX.NAME).
     * @param key (optional) Feldschlüssel
     * @return Nachschlagewerte
     */
    apiSucheLookupGet(key?: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Suche/Lookup?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSucheLookupGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSucheLookupGet(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiSucheLookupGet(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Schl\u00fcssel existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Schl\u00fcssel existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSucheLookupGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<string[]>) => ObservableInput<string[]> | ObservableInput<never> {
        return (err: any, caught: Observable<string[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert die Treffer einer Ergebnisliste innerhalb eines Objektes auf. Es wird eine leere Liste zurückgegeben, sollte die Ergebnisliste nicht existieren.
     * @param searchId Id der Suche
     * @param id ObjektId
     * @return Treffer innerhalb des Stoffes
     */
    apiSucheBySearchIdByIdGet(searchId: string, id: string): Observable<MatchResult[]> {
        let url_ = this.baseUrl + "/api/Suche/{searchId}/{id}";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSucheBySearchIdByIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSucheBySearchIdByIdGet(<any>response_);
                } catch (e) {
                    return <Observable<MatchResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MatchResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiSucheBySearchIdByIdGet(response: HttpResponseBase): Observable<MatchResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MatchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MatchResult[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSucheBySearchIdByIdGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<MatchResult[]>) => ObservableInput<MatchResult[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<MatchResult[]>) => ObservableInput<MatchResult[]> | ObservableInput<never> {
        return (err: any, caught: Observable<MatchResult[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Gibt die Systeminformationen zurück, welche auf der Startseite angezeigt werden
     * @return Systeminformationen
     */
    apiSystemInfoGet(): Observable<SystemInfo> {
        let url_ = this.baseUrl + "/api/SystemInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiSystemInfoGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiSystemInfoGet(<any>response_);
                } catch (e) {
                    return <Observable<SystemInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemInfo>><any>_observableThrow(response_);
        }));
    }

    protected processApiSystemInfoGet(response: HttpResponseBase): Observable<SystemInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemInfo>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiSystemInfoGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<SystemInfo>) => ObservableInput<SystemInfo> | ObservableInput<never>,
    }): (err: any, caught: Observable<SystemInfo>) => ObservableInput<SystemInfo> | ObservableInput<never> {
        return (err: any, caught: Observable<SystemInfo>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Setzt den Thesaurus zurück.
     * @return OK
     */
    apiThesaurusResetPost(): Observable<void> {
        let url_ = this.baseUrl + "/api/Thesaurus/Reset";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiThesaurusResetPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiThesaurusResetPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiThesaurusResetPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiThesaurusResetPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiThesaurusRegelListPost(body?: TableInput | undefined): Observable<ListThesaurusRegelResult> {
        let url_ = this.baseUrl + "/api/ThesaurusRegel/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiThesaurusRegelListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiThesaurusRegelListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListThesaurusRegelResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListThesaurusRegelResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiThesaurusRegelListPost(response: HttpResponseBase): Observable<ListThesaurusRegelResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListThesaurusRegelResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListThesaurusRegelResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiThesaurusRegelListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListThesaurusRegelResult>) => ObservableInput<ListThesaurusRegelResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListThesaurusRegelResult>) => ObservableInput<ListThesaurusRegelResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListThesaurusRegelResult>) => ObservableInput<ListThesaurusRegelResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListThesaurusRegelResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiThesaurusRegelPost(body?: ThesaurusRegel | undefined): Observable<ThesaurusRegel> {
        let url_ = this.baseUrl + "/api/ThesaurusRegel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiThesaurusRegelPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiThesaurusRegelPost(<any>response_);
                } catch (e) {
                    return <Observable<ThesaurusRegel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ThesaurusRegel>><any>_observableThrow(response_);
        }));
    }

    protected processApiThesaurusRegelPost(response: HttpResponseBase): Observable<ThesaurusRegel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ThesaurusRegel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Conflict", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ThesaurusRegel>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error409Handler Behandeln des Fehlers: Conflict
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiThesaurusRegelPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
        error409Handler: (error409: SwaggerException, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
    }): (err: any, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never> {
        return (err: any, caught: Observable<ThesaurusRegel>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 409:
                    return handlers.error409Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiThesaurusRegelByNameGet(name: string): Observable<ThesaurusRegel> {
        let url_ = this.baseUrl + "/api/ThesaurusRegel/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiThesaurusRegelByNameGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiThesaurusRegelByNameGet(<any>response_);
                } catch (e) {
                    return <Observable<ThesaurusRegel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ThesaurusRegel>><any>_observableThrow(response_);
        }));
    }

    protected processApiThesaurusRegelByNameGet(response: HttpResponseBase): Observable<ThesaurusRegel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThesaurusRegel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ThesaurusRegel>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiThesaurusRegelByNameGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
    }): (err: any, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never> {
        return (err: any, caught: Observable<ThesaurusRegel>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiThesaurusRegelByNamePut(name: string, body?: ThesaurusRegel | undefined): Observable<ThesaurusRegel> {
        let url_ = this.baseUrl + "/api/ThesaurusRegel/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiThesaurusRegelByNamePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiThesaurusRegelByNamePut(<any>response_);
                } catch (e) {
                    return <Observable<ThesaurusRegel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ThesaurusRegel>><any>_observableThrow(response_);
        }));
    }

    protected processApiThesaurusRegelByNamePut(response: HttpResponseBase): Observable<ThesaurusRegel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThesaurusRegel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ThesaurusRegel>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiThesaurusRegelByNamePutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never>,
    }): (err: any, caught: Observable<ThesaurusRegel>) => ObservableInput<ThesaurusRegel> | ObservableInput<never> {
        return (err: any, caught: Observable<ThesaurusRegel>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiThesaurusRegelByNameDelete(name: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ThesaurusRegel/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiThesaurusRegelByNameDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiThesaurusRegelByNameDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiThesaurusRegelByNameDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiThesaurusRegelByNameDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiUserGet(): Observable<UserItem[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiUserGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiUserGet(<any>response_);
                } catch (e) {
                    return <Observable<UserItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processApiUserGet(response: HttpResponseBase): Observable<UserItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserItem[]>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiUserGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<UserItem[]>) => ObservableInput<UserItem[]> | ObservableInput<never>,
    }): (err: any, caught: Observable<UserItem[]>) => ObservableInput<UserItem[]> | ObservableInput<never> {
        return (err: any, caught: Observable<UserItem[]>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiValidierungsRegelListPost(body?: TableInput | undefined): Observable<ListValidierungsRegelResult> {
        let url_ = this.baseUrl + "/api/ValidierungsRegel/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiValidierungsRegelListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiValidierungsRegelListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListValidierungsRegelResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListValidierungsRegelResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiValidierungsRegelListPost(response: HttpResponseBase): Observable<ListValidierungsRegelResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListValidierungsRegelResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListValidierungsRegelResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiValidierungsRegelListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListValidierungsRegelResult>) => ObservableInput<ListValidierungsRegelResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListValidierungsRegelResult>) => ObservableInput<ListValidierungsRegelResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListValidierungsRegelResult>) => ObservableInput<ListValidierungsRegelResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListValidierungsRegelResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return OK
     */
    apiValidierungsRegelByNameGet(name: string): Observable<ValidierungsRegel> {
        let url_ = this.baseUrl + "/api/ValidierungsRegel/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiValidierungsRegelByNameGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiValidierungsRegelByNameGet(<any>response_);
                } catch (e) {
                    return <Observable<ValidierungsRegel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidierungsRegel>><any>_observableThrow(response_);
        }));
    }

    protected processApiValidierungsRegelByNameGet(response: HttpResponseBase): Observable<ValidierungsRegel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidierungsRegel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidierungsRegel>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiValidierungsRegelByNameGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ValidierungsRegel>) => ObservableInput<ValidierungsRegel> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<ValidierungsRegel>) => ObservableInput<ValidierungsRegel> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ValidierungsRegel>) => ObservableInput<ValidierungsRegel> | ObservableInput<never>,
    }): (err: any, caught: Observable<ValidierungsRegel>) => ObservableInput<ValidierungsRegel> | ObservableInput<never> {
        return (err: any, caught: Observable<ValidierungsRegel>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiValidierungsRegelByNamePut(name: string, body?: ValidierungsRegel | undefined): Observable<ValidierungsRegel> {
        let url_ = this.baseUrl + "/api/ValidierungsRegel/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiValidierungsRegelByNamePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiValidierungsRegelByNamePut(<any>response_);
                } catch (e) {
                    return <Observable<ValidierungsRegel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidierungsRegel>><any>_observableThrow(response_);
        }));
    }

    protected processApiValidierungsRegelByNamePut(response: HttpResponseBase): Observable<ValidierungsRegel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidierungsRegel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidierungsRegel>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiValidierungsRegelByNamePutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<ValidierungsRegel>) => ObservableInput<ValidierungsRegel> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<ValidierungsRegel>) => ObservableInput<ValidierungsRegel> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ValidierungsRegel>) => ObservableInput<ValidierungsRegel> | ObservableInput<never>,
    }): (err: any, caught: Observable<ValidierungsRegel>) => ObservableInput<ValidierungsRegel> | ObservableInput<never> {
        return (err: any, caught: Observable<ValidierungsRegel>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @return No Content
     */
    apiValidierungsRegelByNameDelete(name: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ValidierungsRegel/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiValidierungsRegelByNameDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiValidierungsRegelByNameDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiValidierungsRegelByNameDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Not Found
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiValidierungsRegelByNameDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiWartungsfensterListPost(body?: TableInput | undefined): Observable<ListWartungsfensterResult> {
        let url_ = this.baseUrl + "/api/Wartungsfenster/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiWartungsfensterListPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiWartungsfensterListPost(<any>response_);
                } catch (e) {
                    return <Observable<ListWartungsfensterResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListWartungsfensterResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiWartungsfensterListPost(response: HttpResponseBase): Observable<ListWartungsfensterResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListWartungsfensterResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListWartungsfensterResult>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiWartungsfensterListPostErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<ListWartungsfensterResult>) => ObservableInput<ListWartungsfensterResult> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<ListWartungsfensterResult>) => ObservableInput<ListWartungsfensterResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ListWartungsfensterResult>) => ObservableInput<ListWartungsfensterResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ListWartungsfensterResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert ein Wartungsfenster
     * @param id Wartungsfenster-Id
     * @return Wartungsfenster
     */
    apiWartungsfensterByIdGet(id: number): Observable<Wartungsfenster> {
        let url_ = this.baseUrl + "/api/Wartungsfenster/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiWartungsfensterByIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiWartungsfensterByIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Wartungsfenster>><any>_observableThrow(e);
                }
            } else
                return <Observable<Wartungsfenster>><any>_observableThrow(response_);
        }));
    }

    protected processApiWartungsfensterByIdGet(response: HttpResponseBase): Observable<Wartungsfenster> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Wartungsfenster.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Wartungsfenster existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Wartungsfenster>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Wartungsfenster existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiWartungsfensterByIdGetErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
    }): (err: any, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never> {
        return (err: any, caught: Observable<Wartungsfenster>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Aktualisiert ein Wartungsfenster
     * @param id Wartungsfenster-Id
     * @param body (optional) Wartungsfenster-Daten
     * @return Wartungsfenster aktualisiert
     */
    apiWartungsfensterByIdPatch(id: number, body?: Wartungsfenster | undefined): Observable<Wartungsfenster> {
        let url_ = this.baseUrl + "/api/Wartungsfenster/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiWartungsfensterByIdPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiWartungsfensterByIdPatch(<any>response_);
                } catch (e) {
                    return <Observable<Wartungsfenster>><any>_observableThrow(e);
                }
            } else
                return <Observable<Wartungsfenster>><any>_observableThrow(response_);
        }));
    }

    protected processApiWartungsfensterByIdPatch(response: HttpResponseBase): Observable<Wartungsfenster> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Wartungsfenster.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Wartungsfenster existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Wartungsfenster>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Wartungsfenster existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiWartungsfensterByIdPatchErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
    }): (err: any, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never> {
        return (err: any, caught: Observable<Wartungsfenster>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Löscht ein Wartungsfenster
     * @param id Wartungsfenster-Id
     * @return Wartungsfenster gelöscht
     */
    apiWartungsfensterByIdDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Wartungsfenster/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiWartungsfensterByIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiWartungsfensterByIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiWartungsfensterByIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Wartungsfenster existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Wartungsfenster existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiWartungsfensterByIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erstellt ein Wartungsfenster
     * @param body (optional) Wartungsfenster-Daten
     * @return Wartungsfenster erstellt
     */
    apiWartungsfensterPost(body?: Wartungsfenster | undefined): Observable<Wartungsfenster> {
        let url_ = this.baseUrl + "/api/Wartungsfenster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiWartungsfensterPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiWartungsfensterPost(<any>response_);
                } catch (e) {
                    return <Observable<Wartungsfenster>><any>_observableThrow(e);
                }
            } else
                return <Observable<Wartungsfenster>><any>_observableThrow(response_);
        }));
    }

    protected processApiWartungsfensterPost(response: HttpResponseBase): Observable<Wartungsfenster> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Wartungsfenster.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Wartungsfenster>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiWartungsfensterPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never>,
    }): (err: any, caught: Observable<Wartungsfenster>) => ObservableInput<Wartungsfenster> | ObservableInput<never> {
        return (err: any, caught: Observable<Wartungsfenster>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert ein Dossier zu einem Zitat.
     * @param zitatId Zitat-Id
     * @return Dossier
     */
    apiZitatByZitatIdGet(zitatId: number): Observable<Dossier> {
        let url_ = this.baseUrl + "/api/Zitat/{zitatId}";
        if (zitatId === undefined || zitatId === null)
            throw new Error("The parameter 'zitatId' must be defined.");
        url_ = url_.replace("{zitatId}", encodeURIComponent("" + zitatId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiZitatByZitatIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiZitatByZitatIdGet(<any>response_);
                } catch (e) {
                    return <Observable<Dossier>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dossier>><any>_observableThrow(response_);
        }));
    }

    protected processApiZitatByZitatIdGet(response: HttpResponseBase): Observable<Dossier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Zitat existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dossier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dossier>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Zitat existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiZitatByZitatIdGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never>,
    }): (err: any, caught: Observable<Dossier>) => ObservableInput<Dossier> | ObservableInput<never> {
        return (err: any, caught: Observable<Dossier>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Löscht ein bestehendes Zitat.
     * @param zitatId Zitat-Id
     * @return Zitat wurde gelöscht
     */
    apiZitatByZitatIdDelete(zitatId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Zitat/{zitatId}";
        if (zitatId === undefined || zitatId === null)
            throw new Error("The parameter 'zitatId' must be defined.");
        url_ = url_.replace("{zitatId}", encodeURIComponent("" + zitatId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiZitatByZitatIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiZitatByZitatIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiZitatByZitatIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ReferenceViolation : Referentielle Integrit\u00e4t wird verletzt", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Zitat existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ReferenceViolation : Referentielle Integrit\u00e4t wird verletzt
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Zitat existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiZitatByZitatIdDeleteErrorHandlers(handlers: {
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert eine Liste von Objekten, die das Zitat referenzieren.
     * @param zitatId Zitat-Id
     * @param skip (optional) Anzahl der Elemente, die übersprungen werden
     * @param pageSize (optional) Maximale Anzahl der Elemente
     * @return Referenzen
     */
    apiZitatByZitatIdReferenziertDurchGet(zitatId: number, skip?: number | undefined, pageSize?: number | undefined): Observable<ReferencesResult> {
        let url_ = this.baseUrl + "/api/Zitat/{zitatId}/ReferenziertDurch?";
        if (zitatId === undefined || zitatId === null)
            throw new Error("The parameter 'zitatId' must be defined.");
        url_ = url_.replace("{zitatId}", encodeURIComponent("" + zitatId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiZitatByZitatIdReferenziertDurchGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiZitatByZitatIdReferenziertDurchGet(<any>response_);
                } catch (e) {
                    return <Observable<ReferencesResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReferencesResult>><any>_observableThrow(response_);
        }));
    }

    protected processApiZitatByZitatIdReferenziertDurchGet(response: HttpResponseBase): Observable<ReferencesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferencesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferencesResult>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiZitatByZitatIdReferenziertDurchGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<ReferencesResult>) => ObservableInput<ReferencesResult> | ObservableInput<never>,
    }): (err: any, caught: Observable<ReferencesResult>) => ObservableInput<ReferencesResult> | ObservableInput<never> {
        return (err: any, caught: Observable<ReferencesResult>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Erstellung eines neuen Zitats.
     * @return Informationen zur Erstellung eines neuen Zitats
     */
    apiZitatErstellenGet(): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Zitat/Erstellen";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiZitatErstellenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiZitatErstellenGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiZitatErstellenGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiZitatErstellenGetErrorHandlers(handlers: {
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Erstellt einen neues Zitat.
     * @param body (optional) Eingaben
     * @return Zitat wurden erstellt
     */
    apiZitatErstellenPost(body?: any | undefined): Observable<NeuesObjektErstellenCreated> {
        let url_ = this.baseUrl + "/api/Zitat/Erstellen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiZitatErstellenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiZitatErstellenPost(<any>response_);
                } catch (e) {
                    return <Observable<NeuesObjektErstellenCreated>><any>_observableThrow(e);
                }
            } else
                return <Observable<NeuesObjektErstellenCreated>><any>_observableThrow(response_);
        }));
    }

    protected processApiZitatErstellenPost(response: HttpResponseBase): Observable<NeuesObjektErstellenCreated> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = NeuesObjektErstellenCreated.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NeuesObjektErstellenCreated>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiZitatErstellenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<NeuesObjektErstellenCreated>) => ObservableInput<NeuesObjektErstellenCreated> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<NeuesObjektErstellenCreated>) => ObservableInput<NeuesObjektErstellenCreated> | ObservableInput<never>,
    }): (err: any, caught: Observable<NeuesObjektErstellenCreated>) => ObservableInput<NeuesObjektErstellenCreated> | ObservableInput<never> {
        return (err: any, caught: Observable<NeuesObjektErstellenCreated>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Liefert Informationen für die Bearbeitung eines bestehenden Zitats.
     * @param zitatId Zitat-Id
     * @return Informationen zur Bearbeitung eines bestehenden Zitats
     */
    apiZitatByZitatIdBearbeitenGet(zitatId: number): Observable<SachverhaltBearbeiten> {
        let url_ = this.baseUrl + "/api/Zitat/{zitatId}/Bearbeiten";
        if (zitatId === undefined || zitatId === null)
            throw new Error("The parameter 'zitatId' must be defined.");
        url_ = url_.replace("{zitatId}", encodeURIComponent("" + zitatId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiZitatByZitatIdBearbeitenGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiZitatByZitatIdBearbeitenGet(<any>response_);
                } catch (e) {
                    return <Observable<SachverhaltBearbeiten>><any>_observableThrow(e);
                }
            } else
                return <Observable<SachverhaltBearbeiten>><any>_observableThrow(response_);
        }));
    }

    protected processApiZitatByZitatIdBearbeitenGet(response: HttpResponseBase): Observable<SachverhaltBearbeiten> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SachverhaltBearbeiten.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Zitat existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SachverhaltBearbeiten>(<any>null);
    }

    /**
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Zitat existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiZitatByZitatIdBearbeitenGetErrorHandlers(handlers: {
        error404Handler: (error404: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never>,
    }): (err: any, caught: Observable<SachverhaltBearbeiten>) => ObservableInput<SachverhaltBearbeiten> | ObservableInput<never> {
        return (err: any, caught: Observable<SachverhaltBearbeiten>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * Bearbeitet einen bestehendes Zitat.
     * @param zitatId Zitat-Id
     * @param body (optional) Eingaben
     * @return Zitat wurde aktualisiert
     */
    apiZitatByZitatIdBearbeitenPut(zitatId: number, body?: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Zitat/{zitatId}/Bearbeiten";
        if (zitatId === undefined || zitatId === null)
            throw new Error("The parameter 'zitatId' must be defined.");
        url_ = url_.replace("{zitatId}", encodeURIComponent("" + zitatId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiZitatByZitatIdBearbeitenPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiZitatByZitatIdBearbeitenPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiZitatByZitatIdBearbeitenPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Zitat existiert nicht", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ValidationError (data: ValidationError) : Validierung fehlgeschlagen
     * @param {SwaggerException} handlers.error404Handler Behandeln des Fehlers: Zitat existiert nicht
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiZitatByZitatIdBearbeitenPutErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error404Handler: (error404: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 404:
                    return handlers.error404Handler(err, caught);
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    apiZitatZusammenfuehrenPost(body?: ZitatZusammenfuehrenInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Zitat/Zusammenfuehren";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiZitatZusammenfuehrenPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiZitatZusammenfuehrenPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApiZitatZusammenfuehrenPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ObjectNotFound : Objekt nicht gefunden", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ForbiddenResult.fromJS(resultData403);
            return throwException("Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param {BadRequestResult} handlers.error400Handler Behandeln des Fehlers: Bad Request\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - ObjectNotFound : Objekt nicht gefunden
     * @param {ForbiddenResult} handlers.error403Handler Behandeln des Fehlers: Forbidden\r\nM\u00f6gliche Gr\u00fcnde: \r\n----------------\r\n - Authorization : Autorisierung fehlgeschlagen
     * @param {SwaggerException} handlers.error401Handler Behandeln des Fehlers: Unauthorized
     */
    public apiZitatZusammenfuehrenPostErrorHandlers(handlers: {
        error400Handler: (error400: BadRequestResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error403Handler: (error403: ForbiddenResult, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
        error401Handler: (error401: SwaggerException, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never>,
    }): (err: any, caught: Observable<void>) => ObservableInput<void> | ObservableInput<never> {
        return (err: any, caught: Observable<void>) => {
            if (SwaggerException.isSwaggerException(err)) {
              switch (err.status) {
                case 401:
                    return handlers.error401Handler(err, caught);
                default:
                    throw new Error('Unexpected swagger exception with status code ' + err.status);
                }
            }
            if (err instanceof BadRequestResult) {
                return handlers.error400Handler(err, caught);
            }
            if (err instanceof ForbiddenResult) {
                return handlers.error403Handler(err, caught);
            }
            throw new Error('Unhandled error code / result');
        }
    }
}

export class BadRequestResult implements IBadRequestResult {
    reason?: BadRequestResultReason;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: IBadRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.description = _data["description"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): BadRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["description"] = this.description;
        data["data"] = this.data;
        return data;
    }
}

export interface IBadRequestResult {
    reason?: BadRequestResultReason;
    description?: string | undefined;
    data?: any | undefined;
}

export class BatchAddFactRequest implements IBatchAddFactRequest {
    objektIds?: string[] | undefined;
    input?: any | undefined;
    message?: string | undefined;

    constructor(data?: IBatchAddFactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["objektIds"])) {
                this.objektIds = [] as any;
                for (let item of _data["objektIds"])
                    this.objektIds!.push(item);
            }
            this.input = _data["input"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BatchAddFactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAddFactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objektIds)) {
            data["objektIds"] = [];
            for (let item of this.objektIds)
                data["objektIds"].push(item);
        }
        data["input"] = this.input;
        data["message"] = this.message;
        return data;
    }
}

export interface IBatchAddFactRequest {
    objektIds?: string[] | undefined;
    input?: any | undefined;
    message?: string | undefined;
}

export class BatchDeleteRequest implements IBatchDeleteRequest {
    objektIds?: string[] | undefined;
    message?: string | undefined;

    constructor(data?: IBatchDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["objektIds"])) {
                this.objektIds = [] as any;
                for (let item of _data["objektIds"])
                    this.objektIds!.push(item);
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BatchDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objektIds)) {
            data["objektIds"] = [];
            for (let item of this.objektIds)
                data["objektIds"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IBatchDeleteRequest {
    objektIds?: string[] | undefined;
    message?: string | undefined;
}

export class BatchFreigabeProzessStartenRequest implements IBatchFreigabeProzessStartenRequest {
    erfassungIds?: number[] | undefined;
    message?: string | undefined;
    bearbeiterUid?: string | undefined;
    bearbeiter?: string | undefined;

    constructor(data?: IBatchFreigabeProzessStartenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["erfassungIds"])) {
                this.erfassungIds = [] as any;
                for (let item of _data["erfassungIds"])
                    this.erfassungIds!.push(item);
            }
            this.message = _data["message"];
            this.bearbeiterUid = _data["bearbeiterUid"];
            this.bearbeiter = _data["bearbeiter"];
        }
    }

    static fromJS(data: any): BatchFreigabeProzessStartenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchFreigabeProzessStartenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.erfassungIds)) {
            data["erfassungIds"] = [];
            for (let item of this.erfassungIds)
                data["erfassungIds"].push(item);
        }
        data["message"] = this.message;
        data["bearbeiterUid"] = this.bearbeiterUid;
        data["bearbeiter"] = this.bearbeiter;
        return data;
    }
}

export interface IBatchFreigabeProzessStartenRequest {
    erfassungIds?: number[] | undefined;
    message?: string | undefined;
    bearbeiterUid?: string | undefined;
    bearbeiter?: string | undefined;
}

export class BatchGetAttributeLocksRequest implements IBatchGetAttributeLocksRequest {
    objektIds?: string[] | undefined;

    constructor(data?: IBatchGetAttributeLocksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["objektIds"])) {
                this.objektIds = [] as any;
                for (let item of _data["objektIds"])
                    this.objektIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BatchGetAttributeLocksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchGetAttributeLocksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objektIds)) {
            data["objektIds"] = [];
            for (let item of this.objektIds)
                data["objektIds"].push(item);
        }
        return data;
    }
}

export interface IBatchGetAttributeLocksRequest {
    objektIds?: string[] | undefined;
}

export class BatchResult implements IBatchResult {
    errors?: ErfassungErrorResult[] | undefined;
    erfassungId?: number | undefined;
    readonly created?: boolean;

    constructor(data?: IBatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErfassungErrorResult.fromJS(item));
            }
            this.erfassungId = _data["erfassungId"];
            (<any>this).created = _data["created"];
        }
    }

    static fromJS(data: any): BatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new BatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["erfassungId"] = this.erfassungId;
        data["created"] = this.created;
        return data;
    }
}

export interface IBatchResult {
    errors?: ErfassungErrorResult[] | undefined;
    erfassungId?: number | undefined;
    created?: boolean;
}

export class BenutzerProfil implements IBenutzerProfil {
    fachlektorMerkmale?: number[] | undefined;
    clientInfo?: any | undefined;

    constructor(data?: IBenutzerProfil) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fachlektorMerkmale"])) {
                this.fachlektorMerkmale = [] as any;
                for (let item of _data["fachlektorMerkmale"])
                    this.fachlektorMerkmale!.push(item);
            }
            this.clientInfo = _data["clientInfo"];
        }
    }

    static fromJS(data: any): BenutzerProfil {
        data = typeof data === 'object' ? data : {};
        let result = new BenutzerProfil();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fachlektorMerkmale)) {
            data["fachlektorMerkmale"] = [];
            for (let item of this.fachlektorMerkmale)
                data["fachlektorMerkmale"].push(item);
        }
        data["clientInfo"] = this.clientInfo;
        return data;
    }
}

export interface IBenutzerProfil {
    fachlektorMerkmale?: number[] | undefined;
    clientInfo?: any | undefined;
}

export class BenutzerProfilFavorit implements IBenutzerProfilFavorit {
    objektTyp?: ObjektTyp;
    objektId?: number;
    displayName?: string | undefined;

    constructor(data?: IBenutzerProfilFavorit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objektTyp = _data["objektTyp"];
            this.objektId = _data["objektId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): BenutzerProfilFavorit {
        data = typeof data === 'object' ? data : {};
        let result = new BenutzerProfilFavorit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objektTyp"] = this.objektTyp;
        data["objektId"] = this.objektId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IBenutzerProfilFavorit {
    objektTyp?: ObjektTyp;
    objektId?: number;
    displayName?: string | undefined;
}

export class Child implements IChild {
    name?: string | undefined;
    importObjektId?: number | undefined;
    importObjektErfassungType?: ChildImportObjektErfassungType | undefined;
    importId?: number;
    objektTyp?: ObjektTyp;
    objektId?: number | undefined;
    lokaleObjektId?: number;
    errors?: ErrorDto[] | undefined;
    importierteMerkmale?: ImportiertesMerkmal[] | undefined;

    constructor(data?: IChild) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.importObjektId = _data["importObjektId"];
            this.importObjektErfassungType = _data["importObjektErfassungType"];
            this.importId = _data["importId"];
            this.objektTyp = _data["objektTyp"];
            this.objektId = _data["objektId"];
            this.lokaleObjektId = _data["lokaleObjektId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorDto.fromJS(item));
            }
            if (Array.isArray(_data["importierteMerkmale"])) {
                this.importierteMerkmale = [] as any;
                for (let item of _data["importierteMerkmale"])
                    this.importierteMerkmale!.push(ImportiertesMerkmal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Child {
        data = typeof data === 'object' ? data : {};
        let result = new Child();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["importObjektId"] = this.importObjektId;
        data["importObjektErfassungType"] = this.importObjektErfassungType;
        data["importId"] = this.importId;
        data["objektTyp"] = this.objektTyp;
        data["objektId"] = this.objektId;
        data["lokaleObjektId"] = this.lokaleObjektId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        if (Array.isArray(this.importierteMerkmale)) {
            data["importierteMerkmale"] = [];
            for (let item of this.importierteMerkmale)
                data["importierteMerkmale"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChild {
    name?: string | undefined;
    importObjektId?: number | undefined;
    importObjektErfassungType?: ChildImportObjektErfassungType | undefined;
    importId?: number;
    objektTyp?: ObjektTyp;
    objektId?: number | undefined;
    lokaleObjektId?: number;
    errors?: ErrorDto[] | undefined;
    importierteMerkmale?: ImportiertesMerkmal[] | undefined;
}

export class Configuration implements IConfiguration {
    id?: number;
    master?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    sourceQuery?: string | undefined;
    tag?: string | undefined;
    ranking?: { [key: string]: ConfigurationRankingCascade[]; } | undefined;

    constructor(data?: IConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.master = _data["master"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sourceQuery = _data["sourceQuery"];
            this.tag = _data["tag"];
            if (_data["ranking"]) {
                this.ranking = {} as any;
                for (let key in _data["ranking"]) {
                    if (_data["ranking"].hasOwnProperty(key))
                        (<any>this.ranking)![key] = _data["ranking"][key] ? _data["ranking"][key].map((i: any) => ConfigurationRankingCascade.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): Configuration {
        data = typeof data === 'object' ? data : {};
        let result = new Configuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["master"] = this.master;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sourceQuery"] = this.sourceQuery;
        data["tag"] = this.tag;
        if (this.ranking) {
            data["ranking"] = {};
            for (let key in this.ranking) {
                if (this.ranking.hasOwnProperty(key))
                    (<any>data["ranking"])[key] = this.ranking[key];
            }
        }
        return data;
    }
}

export interface IConfiguration {
    id?: number;
    master?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    sourceQuery?: string | undefined;
    tag?: string | undefined;
    ranking?: { [key: string]: ConfigurationRankingCascade[]; } | undefined;
}

export class ConfigurationRankingCascade implements IConfigurationRankingCascade {
    steps?: ConfigurationRankingStep[] | undefined;
    firstOrDefault?: boolean;

    constructor(data?: IConfigurationRankingCascade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(ConfigurationRankingStep.fromJS(item));
            }
            this.firstOrDefault = _data["firstOrDefault"];
        }
    }

    static fromJS(data: any): ConfigurationRankingCascade {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationRankingCascade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["firstOrDefault"] = this.firstOrDefault;
        return data;
    }
}

export interface IConfigurationRankingCascade {
    steps?: ConfigurationRankingStep[] | undefined;
    firstOrDefault?: boolean;
}

export class ConfigurationRankingStep implements IConfigurationRankingStep {
    isConditional?: boolean;
    ruleName?: string | undefined;

    constructor(data?: IConfigurationRankingStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConditional = _data["isConditional"];
            this.ruleName = _data["ruleName"];
        }
    }

    static fromJS(data: any): ConfigurationRankingStep {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationRankingStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConditional"] = this.isConditional;
        data["ruleName"] = this.ruleName;
        return data;
    }
}

export interface IConfigurationRankingStep {
    isConditional?: boolean;
    ruleName?: string | undefined;
}

export class CreateFeedbackInput implements ICreateFeedbackInput {
    typ?: CreateFeedbackInputTyp;
    kategorie?: CreateFeedbackInputKategorie;
    prioritaet?: CreateFeedbackInputPrioritaet;
    objekt?: ObjektDatenKey;
    verweise?: number[] | undefined;
    merkmalName?: string | undefined;
    merkmalId?: number | undefined;
    nachschlageTabelleName?: string | undefined;
    nachschlageTabelleWert?: string | undefined;
    url?: string | undefined;
    beschreibung?: string | undefined;
    emailErwartet?: boolean;
    anhaenge?: string[] | undefined;

    constructor(data?: ICreateFeedbackInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"];
            this.kategorie = _data["kategorie"];
            this.prioritaet = _data["prioritaet"];
            this.objekt = _data["objekt"] ? ObjektDatenKey.fromJS(_data["objekt"]) : <any>undefined;
            if (Array.isArray(_data["verweise"])) {
                this.verweise = [] as any;
                for (let item of _data["verweise"])
                    this.verweise!.push(item);
            }
            this.merkmalName = _data["merkmalName"];
            this.merkmalId = _data["merkmalId"];
            this.nachschlageTabelleName = _data["nachschlageTabelleName"];
            this.nachschlageTabelleWert = _data["nachschlageTabelleWert"];
            this.url = _data["url"];
            this.beschreibung = _data["beschreibung"];
            this.emailErwartet = _data["emailErwartet"];
            if (Array.isArray(_data["anhaenge"])) {
                this.anhaenge = [] as any;
                for (let item of _data["anhaenge"])
                    this.anhaenge!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateFeedbackInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ;
        data["kategorie"] = this.kategorie;
        data["prioritaet"] = this.prioritaet;
        data["objekt"] = this.objekt ? this.objekt.toJSON() : <any>undefined;
        if (Array.isArray(this.verweise)) {
            data["verweise"] = [];
            for (let item of this.verweise)
                data["verweise"].push(item);
        }
        data["merkmalName"] = this.merkmalName;
        data["merkmalId"] = this.merkmalId;
        data["nachschlageTabelleName"] = this.nachschlageTabelleName;
        data["nachschlageTabelleWert"] = this.nachschlageTabelleWert;
        data["url"] = this.url;
        data["beschreibung"] = this.beschreibung;
        data["emailErwartet"] = this.emailErwartet;
        if (Array.isArray(this.anhaenge)) {
            data["anhaenge"] = [];
            for (let item of this.anhaenge)
                data["anhaenge"].push(item);
        }
        return data;
    }
}

export interface ICreateFeedbackInput {
    typ?: CreateFeedbackInputTyp;
    kategorie?: CreateFeedbackInputKategorie;
    prioritaet?: CreateFeedbackInputPrioritaet;
    objekt?: ObjektDatenKey;
    verweise?: number[] | undefined;
    merkmalName?: string | undefined;
    merkmalId?: number | undefined;
    nachschlageTabelleName?: string | undefined;
    nachschlageTabelleWert?: string | undefined;
    url?: string | undefined;
    beschreibung?: string | undefined;
    emailErwartet?: boolean;
    anhaenge?: string[] | undefined;
}

export class Dossier implements IDossier {
    objektTyp?: ObjektTyp;
    objektId?: string | undefined;
    name?: string | undefined;
    erfassungStatus?: DossierErfassungStatus | undefined;
    erfassungType?: DossierErfassungType | undefined;
    erfassungTitel?: string | undefined;
    items?: DossierPart[] | undefined;
    locks?: ObjectLocks;
    erfassungRejectedReason?: string | undefined;
    erfassungRejectedBy?: string | undefined;
    erfassungOwner?: UserInfo;
    erfassungRequestForApprovalMessage?: string | undefined;
    erfassungApprovalHistory?: DossierApprovalHistoryItem[] | undefined;
    affectedObjects?: Reference[] | undefined;
    children?: Child[] | undefined;
    type?: number | undefined;
    errors?: number | undefined;
    fehlerReportUrl?: string | undefined;
    erfassungId?: number | undefined;
    parentErfassungId?: number | undefined;

    constructor(data?: IDossier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objektTyp = _data["objektTyp"];
            this.objektId = _data["objektId"];
            this.name = _data["name"];
            this.erfassungStatus = _data["erfassungStatus"];
            this.erfassungType = _data["erfassungType"];
            this.erfassungTitel = _data["erfassungTitel"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DossierPart.fromJS(item));
            }
            this.locks = _data["locks"] ? ObjectLocks.fromJS(_data["locks"]) : <any>undefined;
            this.erfassungRejectedReason = _data["erfassungRejectedReason"];
            this.erfassungRejectedBy = _data["erfassungRejectedBy"];
            this.erfassungOwner = _data["erfassungOwner"] ? UserInfo.fromJS(_data["erfassungOwner"]) : <any>undefined;
            this.erfassungRequestForApprovalMessage = _data["erfassungRequestForApprovalMessage"];
            if (Array.isArray(_data["erfassungApprovalHistory"])) {
                this.erfassungApprovalHistory = [] as any;
                for (let item of _data["erfassungApprovalHistory"])
                    this.erfassungApprovalHistory!.push(DossierApprovalHistoryItem.fromJS(item));
            }
            if (Array.isArray(_data["affectedObjects"])) {
                this.affectedObjects = [] as any;
                for (let item of _data["affectedObjects"])
                    this.affectedObjects!.push(Reference.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Child.fromJS(item));
            }
            this.type = _data["type"];
            this.errors = _data["errors"];
            this.fehlerReportUrl = _data["fehlerReportUrl"];
            this.erfassungId = _data["erfassungId"];
            this.parentErfassungId = _data["parentErfassungId"];
        }
    }

    static fromJS(data: any): Dossier {
        data = typeof data === 'object' ? data : {};
        let result = new Dossier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objektTyp"] = this.objektTyp;
        data["objektId"] = this.objektId;
        data["name"] = this.name;
        data["erfassungStatus"] = this.erfassungStatus;
        data["erfassungType"] = this.erfassungType;
        data["erfassungTitel"] = this.erfassungTitel;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["locks"] = this.locks ? this.locks.toJSON() : <any>undefined;
        data["erfassungRejectedReason"] = this.erfassungRejectedReason;
        data["erfassungRejectedBy"] = this.erfassungRejectedBy;
        data["erfassungOwner"] = this.erfassungOwner ? this.erfassungOwner.toJSON() : <any>undefined;
        data["erfassungRequestForApprovalMessage"] = this.erfassungRequestForApprovalMessage;
        if (Array.isArray(this.erfassungApprovalHistory)) {
            data["erfassungApprovalHistory"] = [];
            for (let item of this.erfassungApprovalHistory)
                data["erfassungApprovalHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.affectedObjects)) {
            data["affectedObjects"] = [];
            for (let item of this.affectedObjects)
                data["affectedObjects"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["errors"] = this.errors;
        data["fehlerReportUrl"] = this.fehlerReportUrl;
        data["erfassungId"] = this.erfassungId;
        data["parentErfassungId"] = this.parentErfassungId;
        return data;
    }
}

export interface IDossier {
    objektTyp?: ObjektTyp;
    objektId?: string | undefined;
    name?: string | undefined;
    erfassungStatus?: DossierErfassungStatus | undefined;
    erfassungType?: DossierErfassungType | undefined;
    erfassungTitel?: string | undefined;
    items?: DossierPart[] | undefined;
    locks?: ObjectLocks;
    erfassungRejectedReason?: string | undefined;
    erfassungRejectedBy?: string | undefined;
    erfassungOwner?: UserInfo;
    erfassungRequestForApprovalMessage?: string | undefined;
    erfassungApprovalHistory?: DossierApprovalHistoryItem[] | undefined;
    affectedObjects?: Reference[] | undefined;
    children?: Child[] | undefined;
    type?: number | undefined;
    errors?: number | undefined;
    fehlerReportUrl?: string | undefined;
    erfassungId?: number | undefined;
    parentErfassungId?: number | undefined;
}

export class DossierPart implements IDossierPart {
    readonly type?: string | undefined;
    name?: string | undefined;
    order?: number;
    hierarchieId?: number;
    items?: DossierPart[] | undefined;
    merkmalId?: number;
    notDeletable?: boolean;
    fields?: DossierAttributeField[] | undefined;
    facts?: DossierAttributeFact[] | undefined;

    constructor(data?: IDossierPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.hierarchieId = _data["hierarchieId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DossierPart.fromJS(item));
            }
            this.merkmalId = _data["merkmalId"];
            this.notDeletable = _data["notDeletable"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DossierAttributeField.fromJS(item));
            }
            if (Array.isArray(_data["facts"])) {
                this.facts = [] as any;
                for (let item of _data["facts"])
                    this.facts!.push(DossierAttributeFact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DossierPart {
        data = typeof data === 'object' ? data : {};
        let result = new DossierPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["order"] = this.order;
        data["hierarchieId"] = this.hierarchieId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["merkmalId"] = this.merkmalId;
        data["notDeletable"] = this.notDeletable;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.facts)) {
            data["facts"] = [];
            for (let item of this.facts)
                data["facts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDossierPart {
    type?: string | undefined;
    name?: string | undefined;
    order?: number;
    hierarchieId?: number;
    items?: DossierPart[] | undefined;
    merkmalId?: number;
    notDeletable?: boolean;
    fields?: DossierAttributeField[] | undefined;
    facts?: DossierAttributeFact[] | undefined;
}

export class DossierAccordion extends DossierPart implements IDossierAccordion {

    constructor(data?: IDossierAccordion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAccordion {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAccordion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAccordion extends IDossierPart {
}

export class DossierApprovalHistoryItem implements IDossierApprovalHistoryItem {
    userName?: string | undefined;
    message?: string | undefined;
    date?: Date;
    action?: DossierApprovalHistoryItemAction;

    constructor(data?: IDossierApprovalHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.message = _data["message"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): DossierApprovalHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new DossierApprovalHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["message"] = this.message;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }
}

export interface IDossierApprovalHistoryItem {
    userName?: string | undefined;
    message?: string | undefined;
    date?: Date;
    action?: DossierApprovalHistoryItemAction;
}

export class DossierAttribute extends DossierPart implements IDossierAttribute {

    constructor(data?: IDossierAttribute) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttribute extends IDossierPart {
}

export class DossierAttributeField implements IDossierAttributeField {
    key?: string | undefined;
    name?: string | undefined;
    isAdmin?: boolean;
    type?: string | undefined;
    unit?: string | undefined;
    itemType?: string | undefined;
    fields?: DossierAttributeField[] | undefined;

    constructor(data?: IDossierAttributeField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            this.isAdmin = _data["isAdmin"];
            this.type = _data["type"];
            this.unit = _data["unit"];
            this.itemType = _data["itemType"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DossierAttributeField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DossierAttributeField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        data["isAdmin"] = this.isAdmin;
        data["type"] = this.type;
        data["unit"] = this.unit;
        data["itemType"] = this.itemType;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDossierAttributeField {
    key?: string | undefined;
    name?: string | undefined;
    isAdmin?: boolean;
    type?: string | undefined;
    unit?: string | undefined;
    itemType?: string | undefined;
    fields?: DossierAttributeField[] | undefined;
}

export class DossierAttributeArrayField extends DossierAttributeField implements IDossierAttributeArrayField {

    constructor(data?: IDossierAttributeArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeArrayField extends IDossierAttributeField {
}

export class DossierAttributeDateTimeArrayField extends DossierAttributeArrayField implements IDossierAttributeDateTimeArrayField {

    constructor(data?: IDossierAttributeDateTimeArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeDateTimeArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeDateTimeArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeDateTimeArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeDateTimeField extends DossierAttributeField implements IDossierAttributeDateTimeField {

    constructor(data?: IDossierAttributeDateTimeField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeDateTimeField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeDateTimeField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeDateTimeField extends IDossierAttributeField {
}

export class DossierAttributeDoubleArrayField extends DossierAttributeArrayField implements IDossierAttributeDoubleArrayField {

    constructor(data?: IDossierAttributeDoubleArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeDoubleArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeDoubleArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeDoubleArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeDoubleField extends DossierAttributeField implements IDossierAttributeDoubleField {

    constructor(data?: IDossierAttributeDoubleField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeDoubleField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeDoubleField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeDoubleField extends IDossierAttributeField {
}

export class DossierAttributeDownloadArrayField extends DossierAttributeArrayField implements IDossierAttributeDownloadArrayField {

    constructor(data?: IDossierAttributeDownloadArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeDownloadArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeDownloadArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeDownloadArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeDownloadField extends DossierAttributeField implements IDossierAttributeDownloadField {

    constructor(data?: IDossierAttributeDownloadField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeDownloadField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeDownloadField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeDownloadField extends IDossierAttributeField {
}

export class DossierAttributeFact implements IDossierAttributeFact {
    key?: string | undefined;
    selected?: boolean | undefined;
    requiresLecturerApproval?: boolean | undefined;
    requiresAdminApproval?: boolean | undefined;
    merkmalId?: number;
    tags?: string[] | undefined;
    erfassungSachverhaltId?: number | undefined;
    sachverhaltId?: number | undefined;
    state?: DossierAttributeFactState | undefined;
    values?: { [key: string]: any; } | undefined;
    rejectedReason?: string | undefined;
    rejectedBy?: string | undefined;

    constructor(data?: IDossierAttributeFact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.selected = _data["selected"];
            this.requiresLecturerApproval = _data["requiresLecturerApproval"];
            this.requiresAdminApproval = _data["requiresAdminApproval"];
            this.merkmalId = _data["merkmalId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.erfassungSachverhaltId = _data["erfassungSachverhaltId"];
            this.sachverhaltId = _data["sachverhaltId"];
            this.state = _data["state"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
            this.rejectedReason = _data["rejectedReason"];
            this.rejectedBy = _data["rejectedBy"];
        }
    }

    static fromJS(data: any): DossierAttributeFact {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeFact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["selected"] = this.selected;
        data["requiresLecturerApproval"] = this.requiresLecturerApproval;
        data["requiresAdminApproval"] = this.requiresAdminApproval;
        data["merkmalId"] = this.merkmalId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["erfassungSachverhaltId"] = this.erfassungSachverhaltId;
        data["sachverhaltId"] = this.sachverhaltId;
        data["state"] = this.state;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        data["rejectedReason"] = this.rejectedReason;
        data["rejectedBy"] = this.rejectedBy;
        return data;
    }
}

export interface IDossierAttributeFact {
    key?: string | undefined;
    selected?: boolean | undefined;
    requiresLecturerApproval?: boolean | undefined;
    requiresAdminApproval?: boolean | undefined;
    merkmalId?: number;
    tags?: string[] | undefined;
    erfassungSachverhaltId?: number | undefined;
    sachverhaltId?: number | undefined;
    state?: DossierAttributeFactState | undefined;
    values?: { [key: string]: any; } | undefined;
    rejectedReason?: string | undefined;
    rejectedBy?: string | undefined;
}

export class DossierAttributeImageArrayField extends DossierAttributeArrayField implements IDossierAttributeImageArrayField {

    constructor(data?: IDossierAttributeImageArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeImageArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeImageArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeImageArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeImageField extends DossierAttributeField implements IDossierAttributeImageField {

    constructor(data?: IDossierAttributeImageField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeImageField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeImageField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeImageField extends IDossierAttributeField {
}

export class DossierAttributeIntArrayField extends DossierAttributeArrayField implements IDossierAttributeIntArrayField {

    constructor(data?: IDossierAttributeIntArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeIntArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeIntArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeIntArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeIntField extends DossierAttributeField implements IDossierAttributeIntField {

    constructor(data?: IDossierAttributeIntField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeIntField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeIntField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeIntField extends IDossierAttributeField {
}

export class DossierAttributeLookupArrayField extends DossierAttributeArrayField implements IDossierAttributeLookupArrayField {

    constructor(data?: IDossierAttributeLookupArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeLookupArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeLookupArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeLookupArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeLookupField extends DossierAttributeField implements IDossierAttributeLookupField {

    constructor(data?: IDossierAttributeLookupField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeLookupField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeLookupField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeLookupField extends IDossierAttributeField {
}

export class DossierAttributeQueryArrayField extends DossierAttributeArrayField implements IDossierAttributeQueryArrayField {

    constructor(data?: IDossierAttributeQueryArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeQueryArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeQueryArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeQueryArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeQueryField extends DossierAttributeField implements IDossierAttributeQueryField {

    constructor(data?: IDossierAttributeQueryField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeQueryField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeQueryField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeQueryField extends IDossierAttributeField {
}

export class DossierAttributeReferenceArrayField extends DossierAttributeArrayField implements IDossierAttributeReferenceArrayField {

    constructor(data?: IDossierAttributeReferenceArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeReferenceArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeReferenceArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeReferenceArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeReferenceField extends DossierAttributeField implements IDossierAttributeReferenceField {

    constructor(data?: IDossierAttributeReferenceField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeReferenceField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeReferenceField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeReferenceField extends IDossierAttributeField {
}

export class DossierAttributeStringArrayField extends DossierAttributeArrayField implements IDossierAttributeStringArrayField {

    constructor(data?: IDossierAttributeStringArrayField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeStringArrayField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeStringArrayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeStringArrayField extends IDossierAttributeArrayField {
}

export class DossierAttributeStringField extends DossierAttributeField implements IDossierAttributeStringField {

    constructor(data?: IDossierAttributeStringField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeStringField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeStringField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeStringField extends IDossierAttributeField {
}

export class DossierAttributeSubsetField extends DossierAttributeField implements IDossierAttributeSubsetField {

    constructor(data?: IDossierAttributeSubsetField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DossierAttributeSubsetField {
        data = typeof data === 'object' ? data : {};
        let result = new DossierAttributeSubsetField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDossierAttributeSubsetField extends IDossierAttributeField {
}

export class EinfacheSucheFeld implements IEinfacheSucheFeld {
    key?: string | undefined;
    label?: string | undefined;
    controlType?: EinfacheSucheFeldControlType;
    order?: number;
    value?: string | undefined;
    options?: string[] | undefined;

    constructor(data?: IEinfacheSucheFeld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.controlType = _data["controlType"];
            this.order = _data["order"];
            this.value = _data["value"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): EinfacheSucheFeld {
        data = typeof data === 'object' ? data : {};
        let result = new EinfacheSucheFeld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["controlType"] = this.controlType;
        data["order"] = this.order;
        data["value"] = this.value;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}

export interface IEinfacheSucheFeld {
    key?: string | undefined;
    label?: string | undefined;
    controlType?: EinfacheSucheFeldControlType;
    order?: number;
    value?: string | undefined;
    options?: string[] | undefined;
}

export class ErfassungErrorResult implements IErfassungErrorResult {
    objektId?: string | undefined;
    objektTyp?: ObjektTyp;
    name?: string | undefined;
    error?: ErfassungErrorResultError;
    affectedObjects?: Reference[] | undefined;
    lockedBy?: string[] | undefined;

    constructor(data?: IErfassungErrorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objektId = _data["objektId"];
            this.objektTyp = _data["objektTyp"];
            this.name = _data["name"];
            this.error = _data["error"];
            if (Array.isArray(_data["affectedObjects"])) {
                this.affectedObjects = [] as any;
                for (let item of _data["affectedObjects"])
                    this.affectedObjects!.push(Reference.fromJS(item));
            }
            if (Array.isArray(_data["lockedBy"])) {
                this.lockedBy = [] as any;
                for (let item of _data["lockedBy"])
                    this.lockedBy!.push(item);
            }
        }
    }

    static fromJS(data: any): ErfassungErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new ErfassungErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objektId"] = this.objektId;
        data["objektTyp"] = this.objektTyp;
        data["name"] = this.name;
        data["error"] = this.error;
        if (Array.isArray(this.affectedObjects)) {
            data["affectedObjects"] = [];
            for (let item of this.affectedObjects)
                data["affectedObjects"].push(item.toJSON());
        }
        if (Array.isArray(this.lockedBy)) {
            data["lockedBy"] = [];
            for (let item of this.lockedBy)
                data["lockedBy"].push(item);
        }
        return data;
    }
}

export interface IErfassungErrorResult {
    objektId?: string | undefined;
    objektTyp?: ObjektTyp;
    name?: string | undefined;
    error?: ErfassungErrorResultError;
    affectedObjects?: Reference[] | undefined;
    lockedBy?: string[] | undefined;
}

export class ErfassungListItem implements IErfassungListItem {
    fehlerReportUrl?: string | undefined;
    id?: number;
    typ?: ErfassungListItemTyp;
    objekt?: ObjektDatenKey;
    status?: ErfassungListItemStatus;
    titel?: string | undefined;
    nutzername?: string | undefined;
    nutzerUid?: string;
    bearbeiter?: string | undefined;
    bearbeiterUid?: string | undefined;
    freigegeben?: Date | undefined;
    freigegebenDurch?: string | undefined;
    freigabeNachricht?: string | undefined;
    ablehnungDurch?: string | undefined;
    ablehnungGrund?: string | undefined;
    fehlerAnzahl?: number;
    freigaben?: Freigaben[] | undefined;

    constructor(data?: IErfassungListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fehlerReportUrl = _data["fehlerReportUrl"];
            this.id = _data["id"];
            this.typ = _data["typ"];
            this.objekt = _data["objekt"] ? ObjektDatenKey.fromJS(_data["objekt"]) : <any>undefined;
            this.status = _data["status"];
            this.titel = _data["titel"];
            this.nutzername = _data["nutzername"];
            this.nutzerUid = _data["nutzerUid"];
            this.bearbeiter = _data["bearbeiter"];
            this.bearbeiterUid = _data["bearbeiterUid"];
            this.freigegeben = _data["freigegeben"] ? new Date(_data["freigegeben"].toString()) : <any>undefined;
            this.freigegebenDurch = _data["freigegebenDurch"];
            this.freigabeNachricht = _data["freigabeNachricht"];
            this.ablehnungDurch = _data["ablehnungDurch"];
            this.ablehnungGrund = _data["ablehnungGrund"];
            this.fehlerAnzahl = _data["fehlerAnzahl"];
            if (Array.isArray(_data["freigaben"])) {
                this.freigaben = [] as any;
                for (let item of _data["freigaben"])
                    this.freigaben!.push(item);
            }
        }
    }

    static fromJS(data: any): ErfassungListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ErfassungListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fehlerReportUrl"] = this.fehlerReportUrl;
        data["id"] = this.id;
        data["typ"] = this.typ;
        data["objekt"] = this.objekt ? this.objekt.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["titel"] = this.titel;
        data["nutzername"] = this.nutzername;
        data["nutzerUid"] = this.nutzerUid;
        data["bearbeiter"] = this.bearbeiter;
        data["bearbeiterUid"] = this.bearbeiterUid;
        data["freigegeben"] = this.freigegeben ? this.freigegeben.toISOString() : <any>undefined;
        data["freigegebenDurch"] = this.freigegebenDurch;
        data["freigabeNachricht"] = this.freigabeNachricht;
        data["ablehnungDurch"] = this.ablehnungDurch;
        data["ablehnungGrund"] = this.ablehnungGrund;
        data["fehlerAnzahl"] = this.fehlerAnzahl;
        if (Array.isArray(this.freigaben)) {
            data["freigaben"] = [];
            for (let item of this.freigaben)
                data["freigaben"].push(item);
        }
        return data;
    }
}

export interface IErfassungListItem {
    fehlerReportUrl?: string | undefined;
    id?: number;
    typ?: ErfassungListItemTyp;
    objekt?: ObjektDatenKey;
    status?: ErfassungListItemStatus;
    titel?: string | undefined;
    nutzername?: string | undefined;
    nutzerUid?: string;
    bearbeiter?: string | undefined;
    bearbeiterUid?: string | undefined;
    freigegeben?: Date | undefined;
    freigegebenDurch?: string | undefined;
    freigabeNachricht?: string | undefined;
    ablehnungDurch?: string | undefined;
    ablehnungGrund?: string | undefined;
    fehlerAnzahl?: number;
    freigaben?: Freigaben[] | undefined;
}

export class ErfassungZuweisenInput implements IErfassungZuweisenInput {
    bearbeiterUid?: string | undefined;
    bearbeiter?: string | undefined;

    constructor(data?: IErfassungZuweisenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bearbeiterUid = _data["bearbeiterUid"];
            this.bearbeiter = _data["bearbeiter"];
        }
    }

    static fromJS(data: any): ErfassungZuweisenInput {
        data = typeof data === 'object' ? data : {};
        let result = new ErfassungZuweisenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bearbeiterUid"] = this.bearbeiterUid;
        data["bearbeiter"] = this.bearbeiter;
        return data;
    }
}

export interface IErfassungZuweisenInput {
    bearbeiterUid?: string | undefined;
    bearbeiter?: string | undefined;
}

export class ErrorDto implements IErrorDto {
    type?: ErrorDtoType;
    attributeName?: string | undefined;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.attributeName = _data["attributeName"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["attributeName"] = this.attributeName;
        return data;
    }
}

export interface IErrorDto {
    type?: ErrorDtoType;
    attributeName?: string | undefined;
}

export class ExportAuftrag implements IExportAuftrag {
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    erstellt?: Date;
    nutzername?: string | undefined;
    abgeschlossen?: Date | undefined;
    thesaurus?: boolean;
    rankingTags?: string[] | undefined;
    datenmodell?: string | undefined;
    groesse?: number;
    objekte?: number;
    downloadUrl?: string | undefined;

    constructor(data?: IExportAuftrag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.beschreibung = _data["beschreibung"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
            this.nutzername = _data["nutzername"];
            this.abgeschlossen = _data["abgeschlossen"] ? new Date(_data["abgeschlossen"].toString()) : <any>undefined;
            this.thesaurus = _data["thesaurus"];
            if (Array.isArray(_data["rankingTags"])) {
                this.rankingTags = [] as any;
                for (let item of _data["rankingTags"])
                    this.rankingTags!.push(item);
            }
            this.datenmodell = _data["datenmodell"];
            this.groesse = _data["groesse"];
            this.objekte = _data["objekte"];
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any): ExportAuftrag {
        data = typeof data === 'object' ? data : {};
        let result = new ExportAuftrag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["beschreibung"] = this.beschreibung;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        data["nutzername"] = this.nutzername;
        data["abgeschlossen"] = this.abgeschlossen ? this.abgeschlossen.toISOString() : <any>undefined;
        data["thesaurus"] = this.thesaurus;
        if (Array.isArray(this.rankingTags)) {
            data["rankingTags"] = [];
            for (let item of this.rankingTags)
                data["rankingTags"].push(item);
        }
        data["datenmodell"] = this.datenmodell;
        data["groesse"] = this.groesse;
        data["objekte"] = this.objekte;
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface IExportAuftrag {
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    erstellt?: Date;
    nutzername?: string | undefined;
    abgeschlossen?: Date | undefined;
    thesaurus?: boolean;
    rankingTags?: string[] | undefined;
    datenmodell?: string | undefined;
    groesse?: number;
    objekte?: number;
    downloadUrl?: string | undefined;
}

export class Extremum implements IExtremum {
    field?: string | undefined;
    operator?: ExtremumOperator;

    constructor(data?: IExtremum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): Extremum {
        data = typeof data === 'object' ? data : {};
        let result = new Extremum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["operator"] = this.operator;
        return data;
    }
}

export interface IExtremum {
    field?: string | undefined;
    operator?: ExtremumOperator;
}

export class FavoritenListeInput implements IFavoritenListeInput {
    name?: string | undefined;
    beschreibung?: string | undefined;
    userAssignments?: FavoritenListeUserAssignment[] | undefined;

    constructor(data?: IFavoritenListeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.beschreibung = _data["beschreibung"];
            if (Array.isArray(_data["userAssignments"])) {
                this.userAssignments = [] as any;
                for (let item of _data["userAssignments"])
                    this.userAssignments!.push(FavoritenListeUserAssignment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FavoritenListeInput {
        data = typeof data === 'object' ? data : {};
        let result = new FavoritenListeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["beschreibung"] = this.beschreibung;
        if (Array.isArray(this.userAssignments)) {
            data["userAssignments"] = [];
            for (let item of this.userAssignments)
                data["userAssignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFavoritenListeInput {
    name?: string | undefined;
    beschreibung?: string | undefined;
    userAssignments?: FavoritenListeUserAssignment[] | undefined;
}

export class FavoritenListeListItem implements IFavoritenListeListItem {
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    zeilen?: number;
    bearbeitet?: Date;
    bearbeitetDurch?: string | undefined;
    importiert?: Date | undefined;
    importiertDurch?: string | undefined;

    constructor(data?: IFavoritenListeListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.beschreibung = _data["beschreibung"];
            this.zeilen = _data["zeilen"];
            this.bearbeitet = _data["bearbeitet"] ? new Date(_data["bearbeitet"].toString()) : <any>undefined;
            this.bearbeitetDurch = _data["bearbeitetDurch"];
            this.importiert = _data["importiert"] ? new Date(_data["importiert"].toString()) : <any>undefined;
            this.importiertDurch = _data["importiertDurch"];
        }
    }

    static fromJS(data: any): FavoritenListeListItem {
        data = typeof data === 'object' ? data : {};
        let result = new FavoritenListeListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["beschreibung"] = this.beschreibung;
        data["zeilen"] = this.zeilen;
        data["bearbeitet"] = this.bearbeitet ? this.bearbeitet.toISOString() : <any>undefined;
        data["bearbeitetDurch"] = this.bearbeitetDurch;
        data["importiert"] = this.importiert ? this.importiert.toISOString() : <any>undefined;
        data["importiertDurch"] = this.importiertDurch;
        return data;
    }
}

export interface IFavoritenListeListItem {
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    zeilen?: number;
    bearbeitet?: Date;
    bearbeitetDurch?: string | undefined;
    importiert?: Date | undefined;
    importiertDurch?: string | undefined;
}

export class FavoritenListeResult implements IFavoritenListeResult {
    exportUrl?: string | undefined;
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    bearbeitet?: Date;
    bearbeitetDurch?: string | undefined;
    bearbeitetDurchUid?: string;
    importiert?: Date | undefined;
    importiertDurch?: string | undefined;
    importiertDurchUid?: string | undefined;
    tabellen?: FavoritenListeTabelle[] | undefined;
    userAssignments?: FavoritenListeUserAssignment[] | undefined;

    constructor(data?: IFavoritenListeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exportUrl = _data["exportUrl"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.beschreibung = _data["beschreibung"];
            this.bearbeitet = _data["bearbeitet"] ? new Date(_data["bearbeitet"].toString()) : <any>undefined;
            this.bearbeitetDurch = _data["bearbeitetDurch"];
            this.bearbeitetDurchUid = _data["bearbeitetDurchUid"];
            this.importiert = _data["importiert"] ? new Date(_data["importiert"].toString()) : <any>undefined;
            this.importiertDurch = _data["importiertDurch"];
            this.importiertDurchUid = _data["importiertDurchUid"];
            if (Array.isArray(_data["tabellen"])) {
                this.tabellen = [] as any;
                for (let item of _data["tabellen"])
                    this.tabellen!.push(FavoritenListeTabelle.fromJS(item));
            }
            if (Array.isArray(_data["userAssignments"])) {
                this.userAssignments = [] as any;
                for (let item of _data["userAssignments"])
                    this.userAssignments!.push(FavoritenListeUserAssignment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FavoritenListeResult {
        data = typeof data === 'object' ? data : {};
        let result = new FavoritenListeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportUrl"] = this.exportUrl;
        data["id"] = this.id;
        data["name"] = this.name;
        data["beschreibung"] = this.beschreibung;
        data["bearbeitet"] = this.bearbeitet ? this.bearbeitet.toISOString() : <any>undefined;
        data["bearbeitetDurch"] = this.bearbeitetDurch;
        data["bearbeitetDurchUid"] = this.bearbeitetDurchUid;
        data["importiert"] = this.importiert ? this.importiert.toISOString() : <any>undefined;
        data["importiertDurch"] = this.importiertDurch;
        data["importiertDurchUid"] = this.importiertDurchUid;
        if (Array.isArray(this.tabellen)) {
            data["tabellen"] = [];
            for (let item of this.tabellen)
                data["tabellen"].push(item.toJSON());
        }
        if (Array.isArray(this.userAssignments)) {
            data["userAssignments"] = [];
            for (let item of this.userAssignments)
                data["userAssignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFavoritenListeResult {
    exportUrl?: string | undefined;
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    bearbeitet?: Date;
    bearbeitetDurch?: string | undefined;
    bearbeitetDurchUid?: string;
    importiert?: Date | undefined;
    importiertDurch?: string | undefined;
    importiertDurchUid?: string | undefined;
    tabellen?: FavoritenListeTabelle[] | undefined;
    userAssignments?: FavoritenListeUserAssignment[] | undefined;
}

export class FavoritenListeTabelle implements IFavoritenListeTabelle {
    favoritenListeTabelleId?: number;
    name?: string | undefined;
    objektTyp?: ObjektTyp;
    spalten?: Spalte[] | undefined;

    constructor(data?: IFavoritenListeTabelle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favoritenListeTabelleId = _data["favoritenListeTabelleId"];
            this.name = _data["name"];
            this.objektTyp = _data["objektTyp"];
            if (Array.isArray(_data["spalten"])) {
                this.spalten = [] as any;
                for (let item of _data["spalten"])
                    this.spalten!.push(Spalte.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FavoritenListeTabelle {
        data = typeof data === 'object' ? data : {};
        let result = new FavoritenListeTabelle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favoritenListeTabelleId"] = this.favoritenListeTabelleId;
        data["name"] = this.name;
        data["objektTyp"] = this.objektTyp;
        if (Array.isArray(this.spalten)) {
            data["spalten"] = [];
            for (let item of this.spalten)
                data["spalten"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFavoritenListeTabelle {
    favoritenListeTabelleId?: number;
    name?: string | undefined;
    objektTyp?: ObjektTyp;
    spalten?: Spalte[] | undefined;
}

export class FavoritenListeTabelleResult implements IFavoritenListeTabelleResult {
    favoritenListeId?: number;
    name?: string | undefined;
    favoritenListeTabelleId?: number;
    tabelleName?: string | undefined;

    constructor(data?: IFavoritenListeTabelleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favoritenListeId = _data["favoritenListeId"];
            this.name = _data["name"];
            this.favoritenListeTabelleId = _data["favoritenListeTabelleId"];
            this.tabelleName = _data["tabelleName"];
        }
    }

    static fromJS(data: any): FavoritenListeTabelleResult {
        data = typeof data === 'object' ? data : {};
        let result = new FavoritenListeTabelleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favoritenListeId"] = this.favoritenListeId;
        data["name"] = this.name;
        data["favoritenListeTabelleId"] = this.favoritenListeTabelleId;
        data["tabelleName"] = this.tabelleName;
        return data;
    }
}

export interface IFavoritenListeTabelleResult {
    favoritenListeId?: number;
    name?: string | undefined;
    favoritenListeTabelleId?: number;
    tabelleName?: string | undefined;
}

export class FavoritenListeUserAssignment implements IFavoritenListeUserAssignment {
    userName?: string | undefined;
    userUid?: string;

    constructor(data?: IFavoritenListeUserAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userUid = _data["userUid"];
        }
    }

    static fromJS(data: any): FavoritenListeUserAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new FavoritenListeUserAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userUid"] = this.userUid;
        return data;
    }
}

export interface IFavoritenListeUserAssignment {
    userName?: string | undefined;
    userUid?: string;
}

export class FeedbackListItem implements IFeedbackListItem {
    uid?: string;
    status?: FeedbackListItemStatus;
    typ?: FeedbackListItemTyp;
    kategorie?: FeedbackListItemKategorie;
    prioritaet?: FeedbackListItemPrioritaet;
    objekt?: ObjektDatenKey;
    objektName?: string | undefined;
    merkmalName?: string | undefined;
    nachschlageTabelleName?: string | undefined;
    url?: string | undefined;
    beschreibung?: string | undefined;
    bearbeiter?: string | undefined;
    bearbeiterUid?: string | undefined;
    erstelltDurch?: string | undefined;
    erstelltDurchUid?: string;
    erstellt?: Date;
    bearbeitet?: Date | undefined;

    constructor(data?: IFeedbackListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.status = _data["status"];
            this.typ = _data["typ"];
            this.kategorie = _data["kategorie"];
            this.prioritaet = _data["prioritaet"];
            this.objekt = _data["objekt"] ? ObjektDatenKey.fromJS(_data["objekt"]) : <any>undefined;
            this.objektName = _data["objektName"];
            this.merkmalName = _data["merkmalName"];
            this.nachschlageTabelleName = _data["nachschlageTabelleName"];
            this.url = _data["url"];
            this.beschreibung = _data["beschreibung"];
            this.bearbeiter = _data["bearbeiter"];
            this.bearbeiterUid = _data["bearbeiterUid"];
            this.erstelltDurch = _data["erstelltDurch"];
            this.erstelltDurchUid = _data["erstelltDurchUid"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
            this.bearbeitet = _data["bearbeitet"] ? new Date(_data["bearbeitet"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FeedbackListItem {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["status"] = this.status;
        data["typ"] = this.typ;
        data["kategorie"] = this.kategorie;
        data["prioritaet"] = this.prioritaet;
        data["objekt"] = this.objekt ? this.objekt.toJSON() : <any>undefined;
        data["objektName"] = this.objektName;
        data["merkmalName"] = this.merkmalName;
        data["nachschlageTabelleName"] = this.nachschlageTabelleName;
        data["url"] = this.url;
        data["beschreibung"] = this.beschreibung;
        data["bearbeiter"] = this.bearbeiter;
        data["bearbeiterUid"] = this.bearbeiterUid;
        data["erstelltDurch"] = this.erstelltDurch;
        data["erstelltDurchUid"] = this.erstelltDurchUid;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        data["bearbeitet"] = this.bearbeitet ? this.bearbeitet.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFeedbackListItem {
    uid?: string;
    status?: FeedbackListItemStatus;
    typ?: FeedbackListItemTyp;
    kategorie?: FeedbackListItemKategorie;
    prioritaet?: FeedbackListItemPrioritaet;
    objekt?: ObjektDatenKey;
    objektName?: string | undefined;
    merkmalName?: string | undefined;
    nachschlageTabelleName?: string | undefined;
    url?: string | undefined;
    beschreibung?: string | undefined;
    bearbeiter?: string | undefined;
    bearbeiterUid?: string | undefined;
    erstelltDurch?: string | undefined;
    erstelltDurchUid?: string;
    erstellt?: Date;
    bearbeitet?: Date | undefined;
}

export class FeedbackResult implements IFeedbackResult {
    uid?: string;
    status?: FeedbackResultStatus;
    typ?: FeedbackResultTyp;
    kategorie?: FeedbackResultKategorie;
    prioritaet?: FeedbackResultPrioritaet;
    objekt?: ObjektDatenKey;
    objektName?: string | undefined;
    verweise?: number[] | undefined;
    merkmalName?: string | undefined;
    merkmalId?: number | undefined;
    nachschlageTabelleName?: string | undefined;
    nachschlageTabelleWert?: string | undefined;
    url?: string | undefined;
    beschreibung?: string | undefined;
    emailErwartet?: boolean;
    bearbeiter?: string | undefined;
    bearbeiterUid?: string | undefined;
    erstelltDurch?: string | undefined;
    erstelltDurchUid?: string;
    erstellt?: Date;
    bearbeitet?: Date | undefined;
    anhaenge?: FeedbackResultAnhang[] | undefined;
    verlauf?: FeedbackResultVerlauf[] | undefined;

    constructor(data?: IFeedbackResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.status = _data["status"];
            this.typ = _data["typ"];
            this.kategorie = _data["kategorie"];
            this.prioritaet = _data["prioritaet"];
            this.objekt = _data["objekt"] ? ObjektDatenKey.fromJS(_data["objekt"]) : <any>undefined;
            this.objektName = _data["objektName"];
            if (Array.isArray(_data["verweise"])) {
                this.verweise = [] as any;
                for (let item of _data["verweise"])
                    this.verweise!.push(item);
            }
            this.merkmalName = _data["merkmalName"];
            this.merkmalId = _data["merkmalId"];
            this.nachschlageTabelleName = _data["nachschlageTabelleName"];
            this.nachschlageTabelleWert = _data["nachschlageTabelleWert"];
            this.url = _data["url"];
            this.beschreibung = _data["beschreibung"];
            this.emailErwartet = _data["emailErwartet"];
            this.bearbeiter = _data["bearbeiter"];
            this.bearbeiterUid = _data["bearbeiterUid"];
            this.erstelltDurch = _data["erstelltDurch"];
            this.erstelltDurchUid = _data["erstelltDurchUid"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
            this.bearbeitet = _data["bearbeitet"] ? new Date(_data["bearbeitet"].toString()) : <any>undefined;
            if (Array.isArray(_data["anhaenge"])) {
                this.anhaenge = [] as any;
                for (let item of _data["anhaenge"])
                    this.anhaenge!.push(FeedbackResultAnhang.fromJS(item));
            }
            if (Array.isArray(_data["verlauf"])) {
                this.verlauf = [] as any;
                for (let item of _data["verlauf"])
                    this.verlauf!.push(FeedbackResultVerlauf.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedbackResult {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["status"] = this.status;
        data["typ"] = this.typ;
        data["kategorie"] = this.kategorie;
        data["prioritaet"] = this.prioritaet;
        data["objekt"] = this.objekt ? this.objekt.toJSON() : <any>undefined;
        data["objektName"] = this.objektName;
        if (Array.isArray(this.verweise)) {
            data["verweise"] = [];
            for (let item of this.verweise)
                data["verweise"].push(item);
        }
        data["merkmalName"] = this.merkmalName;
        data["merkmalId"] = this.merkmalId;
        data["nachschlageTabelleName"] = this.nachschlageTabelleName;
        data["nachschlageTabelleWert"] = this.nachschlageTabelleWert;
        data["url"] = this.url;
        data["beschreibung"] = this.beschreibung;
        data["emailErwartet"] = this.emailErwartet;
        data["bearbeiter"] = this.bearbeiter;
        data["bearbeiterUid"] = this.bearbeiterUid;
        data["erstelltDurch"] = this.erstelltDurch;
        data["erstelltDurchUid"] = this.erstelltDurchUid;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        data["bearbeitet"] = this.bearbeitet ? this.bearbeitet.toISOString() : <any>undefined;
        if (Array.isArray(this.anhaenge)) {
            data["anhaenge"] = [];
            for (let item of this.anhaenge)
                data["anhaenge"].push(item.toJSON());
        }
        if (Array.isArray(this.verlauf)) {
            data["verlauf"] = [];
            for (let item of this.verlauf)
                data["verlauf"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeedbackResult {
    uid?: string;
    status?: FeedbackResultStatus;
    typ?: FeedbackResultTyp;
    kategorie?: FeedbackResultKategorie;
    prioritaet?: FeedbackResultPrioritaet;
    objekt?: ObjektDatenKey;
    objektName?: string | undefined;
    verweise?: number[] | undefined;
    merkmalName?: string | undefined;
    merkmalId?: number | undefined;
    nachschlageTabelleName?: string | undefined;
    nachschlageTabelleWert?: string | undefined;
    url?: string | undefined;
    beschreibung?: string | undefined;
    emailErwartet?: boolean;
    bearbeiter?: string | undefined;
    bearbeiterUid?: string | undefined;
    erstelltDurch?: string | undefined;
    erstelltDurchUid?: string;
    erstellt?: Date;
    bearbeitet?: Date | undefined;
    anhaenge?: FeedbackResultAnhang[] | undefined;
    verlauf?: FeedbackResultVerlauf[] | undefined;
}

export class FeedbackResultAnhang implements IFeedbackResultAnhang {
    name?: string | undefined;
    url?: string | undefined;

    constructor(data?: IFeedbackResultAnhang) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FeedbackResultAnhang {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackResultAnhang();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface IFeedbackResultAnhang {
    name?: string | undefined;
    url?: string | undefined;
}

export class FeedbackResultVerlauf implements IFeedbackResultVerlauf {
    status?: FeedbackResultVerlaufStatus | undefined;
    kommentar?: string | undefined;
    emailErwartet?: boolean | undefined;
    erstelltDurch?: string | undefined;
    erstelltDurchUid?: string;
    erstellt?: Date;

    constructor(data?: IFeedbackResultVerlauf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.kommentar = _data["kommentar"];
            this.emailErwartet = _data["emailErwartet"];
            this.erstelltDurch = _data["erstelltDurch"];
            this.erstelltDurchUid = _data["erstelltDurchUid"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FeedbackResultVerlauf {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackResultVerlauf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["kommentar"] = this.kommentar;
        data["emailErwartet"] = this.emailErwartet;
        data["erstelltDurch"] = this.erstelltDurch;
        data["erstelltDurchUid"] = this.erstelltDurchUid;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFeedbackResultVerlauf {
    status?: FeedbackResultVerlaufStatus | undefined;
    kommentar?: string | undefined;
    emailErwartet?: boolean | undefined;
    erstelltDurch?: string | undefined;
    erstelltDurchUid?: string;
    erstellt?: Date;
}

export class FilterInput implements IFilterInput {
    column?: string | undefined;
    value?: string | undefined;

    constructor(data?: IFilterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FilterInput {
        data = typeof data === 'object' ? data : {};
        let result = new FilterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["value"] = this.value;
        return data;
    }
}

export interface IFilterInput {
    column?: string | undefined;
    value?: string | undefined;
}

export class ForbiddenResult implements IForbiddenResult {
    reason?: ForbiddenResultReason;
    description?: string | undefined;
    data?: any | undefined;

    constructor(data?: IForbiddenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.description = _data["description"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ForbiddenResult {
        data = typeof data === 'object' ? data : {};
        let result = new ForbiddenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["description"] = this.description;
        data["data"] = this.data;
        return data;
    }
}

export interface IForbiddenResult {
    reason?: ForbiddenResultReason;
    description?: string | undefined;
    data?: any | undefined;
}

export class FreigabeProzessStartenRequest implements IFreigabeProzessStartenRequest {
    message?: string | undefined;
    bearbeiterUid?: string | undefined;
    bearbeiter?: string | undefined;

    constructor(data?: IFreigabeProzessStartenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.bearbeiterUid = _data["bearbeiterUid"];
            this.bearbeiter = _data["bearbeiter"];
        }
    }

    static fromJS(data: any): FreigabeProzessStartenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FreigabeProzessStartenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["bearbeiterUid"] = this.bearbeiterUid;
        data["bearbeiter"] = this.bearbeiter;
        return data;
    }
}

export interface IFreigabeProzessStartenRequest {
    message?: string | undefined;
    bearbeiterUid?: string | undefined;
    bearbeiter?: string | undefined;
}

export class FreigebenResult implements IFreigebenResult {
    items?: FreigebenResultItem[] | undefined;
    aborted?: boolean;

    constructor(data?: IFreigebenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FreigebenResultItem.fromJS(item));
            }
            this.aborted = _data["aborted"];
        }
    }

    static fromJS(data: any): FreigebenResult {
        data = typeof data === 'object' ? data : {};
        let result = new FreigebenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["aborted"] = this.aborted;
        return data;
    }
}

export interface IFreigebenResult {
    items?: FreigebenResultItem[] | undefined;
    aborted?: boolean;
}

export class FreigebenResultItem implements IFreigebenResultItem {
    erfassungId?: number;
    result?: FreigebenResultItemResult;
    readonly failed?: boolean;

    constructor(data?: IFreigebenResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erfassungId = _data["erfassungId"];
            this.result = _data["result"];
            (<any>this).failed = _data["failed"];
        }
    }

    static fromJS(data: any): FreigebenResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new FreigebenResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erfassungId"] = this.erfassungId;
        data["result"] = this.result;
        data["failed"] = this.failed;
        return data;
    }
}

export interface IFreigebenResultItem {
    erfassungId?: number;
    result?: FreigebenResultItemResult;
    failed?: boolean;
}

export class IdentitaetPruefenResult implements IIdentitaetPruefenResult {
    collisions?: Reference[] | undefined;
    identities?: IdentitaetPruefenResultIdentity[] | undefined;

    constructor(data?: IIdentitaetPruefenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["collisions"])) {
                this.collisions = [] as any;
                for (let item of _data["collisions"])
                    this.collisions!.push(Reference.fromJS(item));
            }
            if (Array.isArray(_data["identities"])) {
                this.identities = [] as any;
                for (let item of _data["identities"])
                    this.identities!.push(IdentitaetPruefenResultIdentity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentitaetPruefenResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentitaetPruefenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.collisions)) {
            data["collisions"] = [];
            for (let item of this.collisions)
                data["collisions"].push(item.toJSON());
        }
        if (Array.isArray(this.identities)) {
            data["identities"] = [];
            for (let item of this.identities)
                data["identities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIdentitaetPruefenResult {
    collisions?: Reference[] | undefined;
    identities?: IdentitaetPruefenResultIdentity[] | undefined;
}

export class IdentitaetPruefenResultIdentity implements IIdentitaetPruefenResultIdentity {
    text?: string | undefined;
    hash?: string | undefined;

    constructor(data?: IIdentitaetPruefenResultIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): IdentitaetPruefenResultIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new IdentitaetPruefenResultIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["hash"] = this.hash;
        return data;
    }
}

export interface IIdentitaetPruefenResultIdentity {
    text?: string | undefined;
    hash?: string | undefined;
}

export class ImportAuftrag implements IImportAuftrag {
    id?: number;
    erstellt?: Date;
    originalDateiname?: string | undefined;
    importDateiname?: string | undefined;
    formatName?: string | undefined;
    lieferantId?: number;
    nutzername?: string | undefined;
    nutzerUid?: string;
    sachverhalteUeberspringen?: boolean;
    stoffeErstellen?: boolean;
    modus?: ImportAuftragModus;
    abgeschlossen?: Date | undefined;
    fehler?: boolean;
    importErfassungId?: number | undefined;
    importErfassungUid?: string | undefined;

    constructor(data?: IImportAuftrag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
            this.originalDateiname = _data["originalDateiname"];
            this.importDateiname = _data["importDateiname"];
            this.formatName = _data["formatName"];
            this.lieferantId = _data["lieferantId"];
            this.nutzername = _data["nutzername"];
            this.nutzerUid = _data["nutzerUid"];
            this.sachverhalteUeberspringen = _data["sachverhalteUeberspringen"];
            this.stoffeErstellen = _data["stoffeErstellen"];
            this.modus = _data["modus"];
            this.abgeschlossen = _data["abgeschlossen"] ? new Date(_data["abgeschlossen"].toString()) : <any>undefined;
            this.fehler = _data["fehler"];
            this.importErfassungId = _data["importErfassungId"];
            this.importErfassungUid = _data["importErfassungUid"];
        }
    }

    static fromJS(data: any): ImportAuftrag {
        data = typeof data === 'object' ? data : {};
        let result = new ImportAuftrag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        data["originalDateiname"] = this.originalDateiname;
        data["importDateiname"] = this.importDateiname;
        data["formatName"] = this.formatName;
        data["lieferantId"] = this.lieferantId;
        data["nutzername"] = this.nutzername;
        data["nutzerUid"] = this.nutzerUid;
        data["sachverhalteUeberspringen"] = this.sachverhalteUeberspringen;
        data["stoffeErstellen"] = this.stoffeErstellen;
        data["modus"] = this.modus;
        data["abgeschlossen"] = this.abgeschlossen ? this.abgeschlossen.toISOString() : <any>undefined;
        data["fehler"] = this.fehler;
        data["importErfassungId"] = this.importErfassungId;
        data["importErfassungUid"] = this.importErfassungUid;
        return data;
    }
}

export interface IImportAuftrag {
    id?: number;
    erstellt?: Date;
    originalDateiname?: string | undefined;
    importDateiname?: string | undefined;
    formatName?: string | undefined;
    lieferantId?: number;
    nutzername?: string | undefined;
    nutzerUid?: string;
    sachverhalteUeberspringen?: boolean;
    stoffeErstellen?: boolean;
    modus?: ImportAuftragModus;
    abgeschlossen?: Date | undefined;
    fehler?: boolean;
    importErfassungId?: number | undefined;
    importErfassungUid?: string | undefined;
}

export class ImportAuftragListItem implements IImportAuftragListItem {
    id?: number;
    erstellt?: Date;
    originalDateiname?: string | undefined;
    formatName?: string | undefined;
    lieferantId?: number;
    lieferantName?: string | undefined;
    nutzername?: string | undefined;
    nutzerUid?: string;
    status?: ImportAuftragListItemStatus;
    flags?: Flags[] | undefined;
    abgeschlossen?: Date | undefined;
    importErfassungId?: number | undefined;

    constructor(data?: IImportAuftragListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
            this.originalDateiname = _data["originalDateiname"];
            this.formatName = _data["formatName"];
            this.lieferantId = _data["lieferantId"];
            this.lieferantName = _data["lieferantName"];
            this.nutzername = _data["nutzername"];
            this.nutzerUid = _data["nutzerUid"];
            this.status = _data["status"];
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(item);
            }
            this.abgeschlossen = _data["abgeschlossen"] ? new Date(_data["abgeschlossen"].toString()) : <any>undefined;
            this.importErfassungId = _data["importErfassungId"];
        }
    }

    static fromJS(data: any): ImportAuftragListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ImportAuftragListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        data["originalDateiname"] = this.originalDateiname;
        data["formatName"] = this.formatName;
        data["lieferantId"] = this.lieferantId;
        data["lieferantName"] = this.lieferantName;
        data["nutzername"] = this.nutzername;
        data["nutzerUid"] = this.nutzerUid;
        data["status"] = this.status;
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item);
        }
        data["abgeschlossen"] = this.abgeschlossen ? this.abgeschlossen.toISOString() : <any>undefined;
        data["importErfassungId"] = this.importErfassungId;
        return data;
    }
}

export interface IImportAuftragListItem {
    id?: number;
    erstellt?: Date;
    originalDateiname?: string | undefined;
    formatName?: string | undefined;
    lieferantId?: number;
    lieferantName?: string | undefined;
    nutzername?: string | undefined;
    nutzerUid?: string;
    status?: ImportAuftragListItemStatus;
    flags?: Flags[] | undefined;
    abgeschlossen?: Date | undefined;
    importErfassungId?: number | undefined;
}

export class ImportAuftragLogItem implements IImportAuftragLogItem {
    severity?: ImportAuftragLogItemSeverity;
    message?: string | undefined;

    constructor(data?: IImportAuftragLogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.severity = _data["severity"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ImportAuftragLogItem {
        data = typeof data === 'object' ? data : {};
        let result = new ImportAuftragLogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["message"] = this.message;
        return data;
    }
}

export interface IImportAuftragLogItem {
    severity?: ImportAuftragLogItemSeverity;
    message?: string | undefined;
}

export class ImportiertesMerkmal implements IImportiertesMerkmal {
    merkmalName?: string | undefined;
    aktion?: ImportiertesMerkmalAktion;

    constructor(data?: IImportiertesMerkmal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merkmalName = _data["merkmalName"];
            this.aktion = _data["aktion"];
        }
    }

    static fromJS(data: any): ImportiertesMerkmal {
        data = typeof data === 'object' ? data : {};
        let result = new ImportiertesMerkmal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merkmalName"] = this.merkmalName;
        data["aktion"] = this.aktion;
        return data;
    }
}

export interface IImportiertesMerkmal {
    merkmalName?: string | undefined;
    aktion?: ImportiertesMerkmalAktion;
}

export class KonfigurationListItem implements IKonfigurationListItem {
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    quelle?: string | undefined;
    tag?: string | undefined;

    constructor(data?: IKonfigurationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.beschreibung = _data["beschreibung"];
            this.quelle = _data["quelle"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): KonfigurationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new KonfigurationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["beschreibung"] = this.beschreibung;
        data["quelle"] = this.quelle;
        data["tag"] = this.tag;
        return data;
    }
}

export interface IKonfigurationListItem {
    id?: number;
    name?: string | undefined;
    beschreibung?: string | undefined;
    quelle?: string | undefined;
    tag?: string | undefined;
}

export class Lieferant implements ILieferant {
    name?: string | undefined;
    merkmalIds?: number[] | undefined;

    constructor(data?: ILieferant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["merkmalIds"])) {
                this.merkmalIds = [] as any;
                for (let item of _data["merkmalIds"])
                    this.merkmalIds!.push(item);
            }
        }
    }

    static fromJS(data: any): Lieferant {
        data = typeof data === 'object' ? data : {};
        let result = new Lieferant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.merkmalIds)) {
            data["merkmalIds"] = [];
            for (let item of this.merkmalIds)
                data["merkmalIds"].push(item);
        }
        return data;
    }
}

export interface ILieferant {
    name?: string | undefined;
    merkmalIds?: number[] | undefined;
}

export class ListErfassungResult implements IListErfassungResult {
    total?: number;
    items?: ErfassungListItem[] | undefined;

    constructor(data?: IListErfassungResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ErfassungListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListErfassungResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListErfassungResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListErfassungResult {
    total?: number;
    items?: ErfassungListItem[] | undefined;
}

export class ListExportAuftraegeResult implements IListExportAuftraegeResult {
    total?: number;
    items?: ExportAuftrag[] | undefined;

    constructor(data?: IListExportAuftraegeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExportAuftrag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListExportAuftraegeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListExportAuftraegeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListExportAuftraegeResult {
    total?: number;
    items?: ExportAuftrag[] | undefined;
}

export class ListFavoritenListeResult implements IListFavoritenListeResult {
    total?: number;
    items?: FavoritenListeListItem[] | undefined;

    constructor(data?: IListFavoritenListeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FavoritenListeListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListFavoritenListeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListFavoritenListeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListFavoritenListeResult {
    total?: number;
    items?: FavoritenListeListItem[] | undefined;
}

export class ListFavoritenListeZeileResult implements IListFavoritenListeZeileResult {
    total?: number;
    items?: { [key: string]: any; }[] | undefined;

    constructor(data?: IListFavoritenListeZeileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): ListFavoritenListeZeileResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListFavoritenListeZeileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface IListFavoritenListeZeileResult {
    total?: number;
    items?: { [key: string]: any; }[] | undefined;
}

export class ListFeedbacksResult implements IListFeedbacksResult {
    total?: number;
    items?: FeedbackListItem[] | undefined;

    constructor(data?: IListFeedbacksResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeedbackListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListFeedbacksResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListFeedbacksResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListFeedbacksResult {
    total?: number;
    items?: FeedbackListItem[] | undefined;
}

export class ListImportAuftraegeResult implements IListImportAuftraegeResult {
    total?: number;
    items?: ImportAuftragListItem[] | undefined;

    constructor(data?: IListImportAuftraegeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImportAuftragListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListImportAuftraegeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListImportAuftraegeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListImportAuftraegeResult {
    total?: number;
    items?: ImportAuftragListItem[] | undefined;
}

export class ListKonfigurationResult implements IListKonfigurationResult {
    total?: number;
    items?: KonfigurationListItem[] | undefined;

    constructor(data?: IListKonfigurationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KonfigurationListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListKonfigurationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListKonfigurationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListKonfigurationResult {
    total?: number;
    items?: KonfigurationListItem[] | undefined;
}

export class ListNachschlageTabellenResult implements IListNachschlageTabellenResult {
    total?: number;
    items?: NachschlageTabelleListItem[] | undefined;

    constructor(data?: IListNachschlageTabellenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NachschlageTabelleListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListNachschlageTabellenResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListNachschlageTabellenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListNachschlageTabellenResult {
    total?: number;
    items?: NachschlageTabelleListItem[] | undefined;
}

export class ListPSatzBereinigungRegelnResult implements IListPSatzBereinigungRegelnResult {
    total?: number;
    items?: PSatzBereinigungRegelListItem[] | undefined;

    constructor(data?: IListPSatzBereinigungRegelnResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PSatzBereinigungRegelListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListPSatzBereinigungRegelnResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListPSatzBereinigungRegelnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListPSatzBereinigungRegelnResult {
    total?: number;
    items?: PSatzBereinigungRegelListItem[] | undefined;
}

export class ListPSatzRegelnResult implements IListPSatzRegelnResult {
    total?: number;
    items?: PSatzRegelListItem[] | undefined;

    constructor(data?: IListPSatzRegelnResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PSatzRegelListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListPSatzRegelnResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListPSatzRegelnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListPSatzRegelnResult {
    total?: number;
    items?: PSatzRegelListItem[] | undefined;
}

export class ListRankingAuftragResult implements IListRankingAuftragResult {
    total?: number;
    items?: RankingAuftragListItem[] | undefined;

    constructor(data?: IListRankingAuftragResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RankingAuftragListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListRankingAuftragResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListRankingAuftragResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListRankingAuftragResult {
    total?: number;
    items?: RankingAuftragListItem[] | undefined;
}

export class ListRankingRegelResult implements IListRankingRegelResult {
    total?: number;
    items?: RankingRegelListItem[] | undefined;

    constructor(data?: IListRankingRegelResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RankingRegelListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListRankingRegelResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListRankingRegelResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListRankingRegelResult {
    total?: number;
    items?: RankingRegelListItem[] | undefined;
}

export class ListThesaurusRegelResult implements IListThesaurusRegelResult {
    total?: number;
    items?: ThesaurusRegelListItem[] | undefined;

    constructor(data?: IListThesaurusRegelResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ThesaurusRegelListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListThesaurusRegelResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListThesaurusRegelResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListThesaurusRegelResult {
    total?: number;
    items?: ThesaurusRegelListItem[] | undefined;
}

export class ListValidierungsRegelResult implements IListValidierungsRegelResult {
    total?: number;
    items?: ValidierungsRegelListItem[] | undefined;

    constructor(data?: IListValidierungsRegelResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ValidierungsRegelListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListValidierungsRegelResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListValidierungsRegelResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListValidierungsRegelResult {
    total?: number;
    items?: ValidierungsRegelListItem[] | undefined;
}

export class ListWartungsfensterResult implements IListWartungsfensterResult {
    total?: number;
    items?: WartungsfensterListItem[] | undefined;

    constructor(data?: IListWartungsfensterResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WartungsfensterListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListWartungsfensterResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListWartungsfensterResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListWartungsfensterResult {
    total?: number;
    items?: WartungsfensterListItem[] | undefined;
}

export class LocalizedText implements ILocalizedText {
    language?: string | undefined;
    text?: string | undefined;

    constructor(data?: ILocalizedText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): LocalizedText {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["text"] = this.text;
        return data;
    }
}

export interface ILocalizedText {
    language?: string | undefined;
    text?: string | undefined;
}

export class LoeschenRequest implements ILoeschenRequest {
    message?: string | undefined;
    bearbeiterUid?: string | undefined;
    bearbeiter?: string | undefined;

    constructor(data?: ILoeschenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.bearbeiterUid = _data["bearbeiterUid"];
            this.bearbeiter = _data["bearbeiter"];
        }
    }

    static fromJS(data: any): LoeschenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoeschenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["bearbeiterUid"] = this.bearbeiterUid;
        data["bearbeiter"] = this.bearbeiter;
        return data;
    }
}

export interface ILoeschenRequest {
    message?: string | undefined;
    bearbeiterUid?: string | undefined;
    bearbeiter?: string | undefined;
}

export class MatchResult implements IMatchResult {
    sachverhaltId?: number;
    wertId?: number | undefined;

    constructor(data?: IMatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sachverhaltId = _data["sachverhaltId"];
            this.wertId = _data["wertId"];
        }
    }

    static fromJS(data: any): MatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new MatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sachverhaltId"] = this.sachverhaltId;
        data["wertId"] = this.wertId;
        return data;
    }
}

export interface IMatchResult {
    sachverhaltId?: number;
    wertId?: number | undefined;
}

export class MergeRequest implements IMergeRequest {
    objektIds?: string[] | undefined;

    constructor(data?: IMergeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["objektIds"])) {
                this.objektIds = [] as any;
                for (let item of _data["objektIds"])
                    this.objektIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MergeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MergeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objektIds)) {
            data["objektIds"] = [];
            for (let item of this.objektIds)
                data["objektIds"].push(item);
        }
        return data;
    }
}

export interface IMergeRequest {
    objektIds?: string[] | undefined;
}

export class MerkmalBaum implements IMerkmalBaum {
    name?: string | undefined;
    key?: string | undefined;
    id?: number;
    readonly type?: MerkmalBaumType;
    items?: MerkmalBaum[] | undefined;
    allowedTypes?: number[] | undefined;
    root?: boolean;

    constructor(data?: IMerkmalBaum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.key = _data["key"];
            this.id = _data["id"];
            (<any>this).type = _data["type"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerkmalBaum.fromJS(item));
            }
            if (Array.isArray(_data["allowedTypes"])) {
                this.allowedTypes = [] as any;
                for (let item of _data["allowedTypes"])
                    this.allowedTypes!.push(item);
            }
            this.root = _data["root"];
        }
    }

    static fromJS(data: any): MerkmalBaum {
        data = typeof data === 'object' ? data : {};
        let result = new MerkmalBaum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["key"] = this.key;
        data["id"] = this.id;
        data["type"] = this.type;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.allowedTypes)) {
            data["allowedTypes"] = [];
            for (let item of this.allowedTypes)
                data["allowedTypes"].push(item);
        }
        data["root"] = this.root;
        return data;
    }
}

export interface IMerkmalBaum {
    name?: string | undefined;
    key?: string | undefined;
    id?: number;
    type?: MerkmalBaumType;
    items?: MerkmalBaum[] | undefined;
    allowedTypes?: number[] | undefined;
    root?: boolean;
}

export class MerkmalBaumFeld extends MerkmalBaum implements IMerkmalBaumFeld {

    constructor(data?: IMerkmalBaumFeld) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MerkmalBaumFeld {
        data = typeof data === 'object' ? data : {};
        let result = new MerkmalBaumFeld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMerkmalBaumFeld extends IMerkmalBaum {
}

export class MerkmalBaumHierarchie extends MerkmalBaum implements IMerkmalBaumHierarchie {

    constructor(data?: IMerkmalBaumHierarchie) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MerkmalBaumHierarchie {
        data = typeof data === 'object' ? data : {};
        let result = new MerkmalBaumHierarchie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMerkmalBaumHierarchie extends IMerkmalBaum {
}

export class MerkmalBaumMerkmal extends MerkmalBaum implements IMerkmalBaumMerkmal {

    constructor(data?: IMerkmalBaumMerkmal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MerkmalBaumMerkmal {
        data = typeof data === 'object' ? data : {};
        let result = new MerkmalBaumMerkmal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMerkmalBaumMerkmal extends IMerkmalBaum {
}

export class NachschlageTabelle implements INachschlageTabelle {
    nachschlageTabelleId?: number;
    name?: string | undefined;
    offen?: boolean;
    werte?: NachschlageTabelleWert[] | undefined;

    constructor(data?: INachschlageTabelle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nachschlageTabelleId = _data["nachschlageTabelleId"];
            this.name = _data["name"];
            this.offen = _data["offen"];
            if (Array.isArray(_data["werte"])) {
                this.werte = [] as any;
                for (let item of _data["werte"])
                    this.werte!.push(NachschlageTabelleWert.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NachschlageTabelle {
        data = typeof data === 'object' ? data : {};
        let result = new NachschlageTabelle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nachschlageTabelleId"] = this.nachschlageTabelleId;
        data["name"] = this.name;
        data["offen"] = this.offen;
        if (Array.isArray(this.werte)) {
            data["werte"] = [];
            for (let item of this.werte)
                data["werte"].push(item.toJSON());
        }
        return data;
    }
}

export interface INachschlageTabelle {
    nachschlageTabelleId?: number;
    name?: string | undefined;
    offen?: boolean;
    werte?: NachschlageTabelleWert[] | undefined;
}

export class NachschlageTabelleListItem implements INachschlageTabelleListItem {
    id?: number;
    name?: string | undefined;
    offen?: boolean;
    felder?: string | undefined;
    werte?: number;

    constructor(data?: INachschlageTabelleListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.offen = _data["offen"];
            this.felder = _data["felder"];
            this.werte = _data["werte"];
        }
    }

    static fromJS(data: any): NachschlageTabelleListItem {
        data = typeof data === 'object' ? data : {};
        let result = new NachschlageTabelleListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["offen"] = this.offen;
        data["felder"] = this.felder;
        data["werte"] = this.werte;
        return data;
    }
}

export interface INachschlageTabelleListItem {
    id?: number;
    name?: string | undefined;
    offen?: boolean;
    felder?: string | undefined;
    werte?: number;
}

export class NachschlageTabelleWert implements INachschlageTabelleWert {
    nachschlageTabelleWertId?: number;
    wert?: string | undefined;
    wertLokalisiert?: { [key: string]: string; } | undefined;
    wertCount?: number;
    erfassungWertCount?: number;

    constructor(data?: INachschlageTabelleWert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nachschlageTabelleWertId = _data["nachschlageTabelleWertId"];
            this.wert = _data["wert"];
            if (_data["wertLokalisiert"]) {
                this.wertLokalisiert = {} as any;
                for (let key in _data["wertLokalisiert"]) {
                    if (_data["wertLokalisiert"].hasOwnProperty(key))
                        (<any>this.wertLokalisiert)![key] = _data["wertLokalisiert"][key];
                }
            }
            this.wertCount = _data["wertCount"];
            this.erfassungWertCount = _data["erfassungWertCount"];
        }
    }

    static fromJS(data: any): NachschlageTabelleWert {
        data = typeof data === 'object' ? data : {};
        let result = new NachschlageTabelleWert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nachschlageTabelleWertId"] = this.nachschlageTabelleWertId;
        data["wert"] = this.wert;
        if (this.wertLokalisiert) {
            data["wertLokalisiert"] = {};
            for (let key in this.wertLokalisiert) {
                if (this.wertLokalisiert.hasOwnProperty(key))
                    (<any>data["wertLokalisiert"])[key] = this.wertLokalisiert[key];
            }
        }
        data["wertCount"] = this.wertCount;
        data["erfassungWertCount"] = this.erfassungWertCount;
        return data;
    }
}

export interface INachschlageTabelleWert {
    nachschlageTabelleWertId?: number;
    wert?: string | undefined;
    wertLokalisiert?: { [key: string]: string; } | undefined;
    wertCount?: number;
    erfassungWertCount?: number;
}

export class NachschlageTabelleWertInput implements INachschlageTabelleWertInput {
    wert?: string | undefined;
    wertLokalisiert?: { [key: string]: string; } | undefined;

    constructor(data?: INachschlageTabelleWertInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wert = _data["wert"];
            if (_data["wertLokalisiert"]) {
                this.wertLokalisiert = {} as any;
                for (let key in _data["wertLokalisiert"]) {
                    if (_data["wertLokalisiert"].hasOwnProperty(key))
                        (<any>this.wertLokalisiert)![key] = _data["wertLokalisiert"][key];
                }
            }
        }
    }

    static fromJS(data: any): NachschlageTabelleWertInput {
        data = typeof data === 'object' ? data : {};
        let result = new NachschlageTabelleWertInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wert"] = this.wert;
        if (this.wertLokalisiert) {
            data["wertLokalisiert"] = {};
            for (let key in this.wertLokalisiert) {
                if (this.wertLokalisiert.hasOwnProperty(key))
                    (<any>data["wertLokalisiert"])[key] = this.wertLokalisiert[key];
            }
        }
        return data;
    }
}

export interface INachschlageTabelleWertInput {
    wert?: string | undefined;
    wertLokalisiert?: { [key: string]: string; } | undefined;
}

export class NeuesObjektErstellenCreated implements INeuesObjektErstellenCreated {
    objektId?: string | undefined;
    objektTyp?: ObjektTyp;
    location?: string | undefined;

    constructor(data?: INeuesObjektErstellenCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objektId = _data["objektId"];
            this.objektTyp = _data["objektTyp"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): NeuesObjektErstellenCreated {
        data = typeof data === 'object' ? data : {};
        let result = new NeuesObjektErstellenCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objektId"] = this.objektId;
        data["objektTyp"] = this.objektTyp;
        data["location"] = this.location;
        return data;
    }
}

export interface INeuesObjektErstellenCreated {
    objektId?: string | undefined;
    objektTyp?: ObjektTyp;
    location?: string | undefined;
}

export class NumericCondition implements INumericCondition {
    field?: string | undefined;
    operator?: NumericConditionOperator;
    lower?: number | undefined;
    upper?: number | undefined;

    constructor(data?: INumericCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.lower = _data["lower"];
            this.upper = _data["upper"];
        }
    }

    static fromJS(data: any): NumericCondition {
        data = typeof data === 'object' ? data : {};
        let result = new NumericCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["lower"] = this.lower;
        data["upper"] = this.upper;
        return data;
    }
}

export interface INumericCondition {
    field?: string | undefined;
    operator?: NumericConditionOperator;
    lower?: number | undefined;
    upper?: number | undefined;
}

export class ObjectAttributeLock implements IObjectAttributeLock {
    merkmalId?: number;
    lockedBy?: string | undefined;

    constructor(data?: IObjectAttributeLock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merkmalId = _data["merkmalId"];
            this.lockedBy = _data["lockedBy"];
        }
    }

    static fromJS(data: any): ObjectAttributeLock {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectAttributeLock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merkmalId"] = this.merkmalId;
        data["lockedBy"] = this.lockedBy;
        return data;
    }
}

export interface IObjectAttributeLock {
    merkmalId?: number;
    lockedBy?: string | undefined;
}

export class ObjectLocks implements IObjectLocks {
    lockedBy?: string | undefined;
    attributeLocks?: ObjectAttributeLock[] | undefined;

    constructor(data?: IObjectLocks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lockedBy = _data["lockedBy"];
            if (Array.isArray(_data["attributeLocks"])) {
                this.attributeLocks = [] as any;
                for (let item of _data["attributeLocks"])
                    this.attributeLocks!.push(ObjectAttributeLock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObjectLocks {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectLocks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lockedBy"] = this.lockedBy;
        if (Array.isArray(this.attributeLocks)) {
            data["attributeLocks"] = [];
            for (let item of this.attributeLocks)
                data["attributeLocks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObjectLocks {
    lockedBy?: string | undefined;
    attributeLocks?: ObjectAttributeLock[] | undefined;
}

export class ObjektAutoCompleteResult implements IObjektAutoCompleteResult {
    value?: string | undefined;
    objektId?: number;
    name?: string | undefined;
    favorit?: boolean;

    constructor(data?: IObjektAutoCompleteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.objektId = _data["objektId"];
            this.name = _data["name"];
            this.favorit = _data["favorit"];
        }
    }

    static fromJS(data: any): ObjektAutoCompleteResult {
        data = typeof data === 'object' ? data : {};
        let result = new ObjektAutoCompleteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["objektId"] = this.objektId;
        data["name"] = this.name;
        data["favorit"] = this.favorit;
        return data;
    }
}

export interface IObjektAutoCompleteResult {
    value?: string | undefined;
    objektId?: number;
    name?: string | undefined;
    favorit?: boolean;
}

export class ObjektDatenKey implements IObjektDatenKey {
    id?: number;
    typ?: ObjektTyp;

    constructor(data?: IObjektDatenKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typ = _data["typ"];
        }
    }

    static fromJS(data: any): ObjektDatenKey {
        data = typeof data === 'object' ? data : {};
        let result = new ObjektDatenKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typ"] = this.typ;
        return data;
    }
}

export interface IObjektDatenKey {
    id?: number;
    typ?: ObjektTyp;
}

export enum ObjektTyp {
    Stoff = "Stoff",
    Spezies = "Spezies",
    Zitat = "Zitat",
    Lieferant = "Lieferant",
}

export class PSatzBereinigungRegelListItem implements IPSatzBereinigungRegelListItem {
    id?: number;
    sicherheitshinweisKategorie?: string | undefined;
    sicherheitshinweis?: string | undefined;
    sicherheitshinweisKategorieIgnoriert?: string | undefined;
    sicherheitshinweisIgnoriert?: string | undefined;

    constructor(data?: IPSatzBereinigungRegelListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sicherheitshinweisKategorie = _data["sicherheitshinweisKategorie"];
            this.sicherheitshinweis = _data["sicherheitshinweis"];
            this.sicherheitshinweisKategorieIgnoriert = _data["sicherheitshinweisKategorieIgnoriert"];
            this.sicherheitshinweisIgnoriert = _data["sicherheitshinweisIgnoriert"];
        }
    }

    static fromJS(data: any): PSatzBereinigungRegelListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PSatzBereinigungRegelListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sicherheitshinweisKategorie"] = this.sicherheitshinweisKategorie;
        data["sicherheitshinweis"] = this.sicherheitshinweis;
        data["sicherheitshinweisKategorieIgnoriert"] = this.sicherheitshinweisKategorieIgnoriert;
        data["sicherheitshinweisIgnoriert"] = this.sicherheitshinweisIgnoriert;
        return data;
    }
}

export interface IPSatzBereinigungRegelListItem {
    id?: number;
    sicherheitshinweisKategorie?: string | undefined;
    sicherheitshinweis?: string | undefined;
    sicherheitshinweisKategorieIgnoriert?: string | undefined;
    sicherheitshinweisIgnoriert?: string | undefined;
}

export class PSatzCleanUpRule implements IPSatzCleanUpRule {
    id?: number;
    categoryFound?: string | undefined;
    pSatzFound?: string | undefined;
    categoryIgnored?: string | undefined;
    pSatzIgnored?: string | undefined;

    constructor(data?: IPSatzCleanUpRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryFound = _data["categoryFound"];
            this.pSatzFound = _data["pSatzFound"];
            this.categoryIgnored = _data["categoryIgnored"];
            this.pSatzIgnored = _data["pSatzIgnored"];
        }
    }

    static fromJS(data: any): PSatzCleanUpRule {
        data = typeof data === 'object' ? data : {};
        let result = new PSatzCleanUpRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryFound"] = this.categoryFound;
        data["pSatzFound"] = this.pSatzFound;
        data["categoryIgnored"] = this.categoryIgnored;
        data["pSatzIgnored"] = this.pSatzIgnored;
        return data;
    }
}

export interface IPSatzCleanUpRule {
    id?: number;
    categoryFound?: string | undefined;
    pSatzFound?: string | undefined;
    categoryIgnored?: string | undefined;
    pSatzIgnored?: string | undefined;
}

export class PSatzCleanUpRuleData implements IPSatzCleanUpRuleData {
    categoryFound?: string | undefined;
    pSatzFound?: string | undefined;
    categoryIgnored?: string | undefined;
    pSatzIgnored?: string | undefined;

    constructor(data?: IPSatzCleanUpRuleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryFound = _data["categoryFound"];
            this.pSatzFound = _data["pSatzFound"];
            this.categoryIgnored = _data["categoryIgnored"];
            this.pSatzIgnored = _data["pSatzIgnored"];
        }
    }

    static fromJS(data: any): PSatzCleanUpRuleData {
        data = typeof data === 'object' ? data : {};
        let result = new PSatzCleanUpRuleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryFound"] = this.categoryFound;
        data["pSatzFound"] = this.pSatzFound;
        data["categoryIgnored"] = this.categoryIgnored;
        data["pSatzIgnored"] = this.pSatzIgnored;
        return data;
    }
}

export interface IPSatzCleanUpRuleData {
    categoryFound?: string | undefined;
    pSatzFound?: string | undefined;
    categoryIgnored?: string | undefined;
    pSatzIgnored?: string | undefined;
}

export class PSatzRegelListItem implements IPSatzRegelListItem {
    id?: number;
    gefahrenklasse?: string | undefined;
    gefahrenhinweis?: string | undefined;
    sicherheitshinweisKategorie?: string | undefined;
    sicherheitshinweis?: string | undefined;

    constructor(data?: IPSatzRegelListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gefahrenklasse = _data["gefahrenklasse"];
            this.gefahrenhinweis = _data["gefahrenhinweis"];
            this.sicherheitshinweisKategorie = _data["sicherheitshinweisKategorie"];
            this.sicherheitshinweis = _data["sicherheitshinweis"];
        }
    }

    static fromJS(data: any): PSatzRegelListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PSatzRegelListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gefahrenklasse"] = this.gefahrenklasse;
        data["gefahrenhinweis"] = this.gefahrenhinweis;
        data["sicherheitshinweisKategorie"] = this.sicherheitshinweisKategorie;
        data["sicherheitshinweis"] = this.sicherheitshinweis;
        return data;
    }
}

export interface IPSatzRegelListItem {
    id?: number;
    gefahrenklasse?: string | undefined;
    gefahrenhinweis?: string | undefined;
    sicherheitshinweisKategorie?: string | undefined;
    sicherheitshinweis?: string | undefined;
}

export class PSatzRule implements IPSatzRule {
    id?: number;
    egk?: string | undefined;
    egh?: string | undefined;
    pSatz?: string | undefined;
    category?: string | undefined;

    constructor(data?: IPSatzRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.egk = _data["egk"];
            this.egh = _data["egh"];
            this.pSatz = _data["pSatz"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): PSatzRule {
        data = typeof data === 'object' ? data : {};
        let result = new PSatzRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["egk"] = this.egk;
        data["egh"] = this.egh;
        data["pSatz"] = this.pSatz;
        data["category"] = this.category;
        return data;
    }
}

export interface IPSatzRule {
    id?: number;
    egk?: string | undefined;
    egh?: string | undefined;
    pSatz?: string | undefined;
    category?: string | undefined;
}

export class PSatzRuleData implements IPSatzRuleData {
    egk?: string | undefined;
    egh?: string | undefined;
    pSatz?: string | undefined;
    category?: string | undefined;

    constructor(data?: IPSatzRuleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.egk = _data["egk"];
            this.egh = _data["egh"];
            this.pSatz = _data["pSatz"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): PSatzRuleData {
        data = typeof data === 'object' ? data : {};
        let result = new PSatzRuleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["egk"] = this.egk;
        data["egh"] = this.egh;
        data["pSatz"] = this.pSatz;
        data["category"] = this.category;
        return data;
    }
}

export interface IPSatzRuleData {
    egk?: string | undefined;
    egh?: string | undefined;
    pSatz?: string | undefined;
    category?: string | undefined;
}

export class PartialDossier implements IPartialDossier {
    type?: number | undefined;
    erfassungTitel?: string | undefined;
    items?: DossierPart[] | undefined;
    erfassungOwner?: UserInfo;
    erfassungType?: PartialDossierErfassungType | undefined;
    erfassungStatus?: PartialDossierErfassungStatus | undefined;

    constructor(data?: IPartialDossier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.erfassungTitel = _data["erfassungTitel"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DossierPart.fromJS(item));
            }
            this.erfassungOwner = _data["erfassungOwner"] ? UserInfo.fromJS(_data["erfassungOwner"]) : <any>undefined;
            this.erfassungType = _data["erfassungType"];
            this.erfassungStatus = _data["erfassungStatus"];
        }
    }

    static fromJS(data: any): PartialDossier {
        data = typeof data === 'object' ? data : {};
        let result = new PartialDossier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["erfassungTitel"] = this.erfassungTitel;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["erfassungOwner"] = this.erfassungOwner ? this.erfassungOwner.toJSON() : <any>undefined;
        data["erfassungType"] = this.erfassungType;
        data["erfassungStatus"] = this.erfassungStatus;
        return data;
    }
}

export interface IPartialDossier {
    type?: number | undefined;
    erfassungTitel?: string | undefined;
    items?: DossierPart[] | undefined;
    erfassungOwner?: UserInfo;
    erfassungType?: PartialDossierErfassungType | undefined;
    erfassungStatus?: PartialDossierErfassungStatus | undefined;
}

export class RankingAuftrag implements IRankingAuftrag {
    id?: number;
    konfigurationId?: number;
    konfigurationName?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    finishedAt?: Date | undefined;
    status?: RankingAuftragStatus | undefined;
    error?: string | undefined;

    constructor(data?: IRankingAuftrag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.konfigurationId = _data["konfigurationId"];
            this.konfigurationName = _data["konfigurationName"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): RankingAuftrag {
        data = typeof data === 'object' ? data : {};
        let result = new RankingAuftrag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["konfigurationId"] = this.konfigurationId;
        data["konfigurationName"] = this.konfigurationName;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["error"] = this.error;
        return data;
    }
}

export interface IRankingAuftrag {
    id?: number;
    konfigurationId?: number;
    konfigurationName?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    finishedAt?: Date | undefined;
    status?: RankingAuftragStatus | undefined;
    error?: string | undefined;
}

export class RankingAuftragListItem implements IRankingAuftragListItem {
    id?: number;
    nutzername?: string | undefined;
    erstellt?: Date;
    abgeschlossen?: Date | undefined;
    fehler?: string | undefined;
    konfigurationName?: string | undefined;

    constructor(data?: IRankingAuftragListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nutzername = _data["nutzername"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
            this.abgeschlossen = _data["abgeschlossen"] ? new Date(_data["abgeschlossen"].toString()) : <any>undefined;
            this.fehler = _data["fehler"];
            this.konfigurationName = _data["konfigurationName"];
        }
    }

    static fromJS(data: any): RankingAuftragListItem {
        data = typeof data === 'object' ? data : {};
        let result = new RankingAuftragListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nutzername"] = this.nutzername;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        data["abgeschlossen"] = this.abgeschlossen ? this.abgeschlossen.toISOString() : <any>undefined;
        data["fehler"] = this.fehler;
        data["konfigurationName"] = this.konfigurationName;
        return data;
    }
}

export interface IRankingAuftragListItem {
    id?: number;
    nutzername?: string | undefined;
    erstellt?: Date;
    abgeschlossen?: Date | undefined;
    fehler?: string | undefined;
    konfigurationName?: string | undefined;
}

export class RankingAuftragStatistik implements IRankingAuftragStatistik {
    totalSourceObjects?: number;
    factsCountByAttribute?: { [key: string]: number; } | undefined;

    constructor(data?: IRankingAuftragStatistik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSourceObjects = _data["totalSourceObjects"];
            if (_data["factsCountByAttribute"]) {
                this.factsCountByAttribute = {} as any;
                for (let key in _data["factsCountByAttribute"]) {
                    if (_data["factsCountByAttribute"].hasOwnProperty(key))
                        (<any>this.factsCountByAttribute)![key] = _data["factsCountByAttribute"][key];
                }
            }
        }
    }

    static fromJS(data: any): RankingAuftragStatistik {
        data = typeof data === 'object' ? data : {};
        let result = new RankingAuftragStatistik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSourceObjects"] = this.totalSourceObjects;
        if (this.factsCountByAttribute) {
            data["factsCountByAttribute"] = {};
            for (let key in this.factsCountByAttribute) {
                if (this.factsCountByAttribute.hasOwnProperty(key))
                    (<any>data["factsCountByAttribute"])[key] = this.factsCountByAttribute[key];
            }
        }
        return data;
    }
}

export interface IRankingAuftragStatistik {
    totalSourceObjects?: number;
    factsCountByAttribute?: { [key: string]: number; } | undefined;
}

export class RankingRegelListItem implements IRankingRegelListItem {
    name?: string | undefined;
    beschreibung?: string | undefined;
    typ?: RankingRegelListItemTyp;

    constructor(data?: IRankingRegelListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.beschreibung = _data["beschreibung"];
            this.typ = _data["typ"];
        }
    }

    static fromJS(data: any): RankingRegelListItem {
        data = typeof data === 'object' ? data : {};
        let result = new RankingRegelListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["beschreibung"] = this.beschreibung;
        data["typ"] = this.typ;
        return data;
    }
}

export interface IRankingRegelListItem {
    name?: string | undefined;
    beschreibung?: string | undefined;
    typ?: RankingRegelListItemTyp;
}

export class RankingRule implements IRankingRule {
    name?: string | undefined;
    description?: string | undefined;
    type?: RankingRuleType;
    attribute?: string | undefined;
    extremums?: Extremum[] | undefined;
    table?: string | undefined;
    valuePriorities?: ValuePriority[] | undefined;
    supplierPriorities?: SupplierPriority[] | undefined;
    numericConditions?: NumericCondition[] | undefined;

    constructor(data?: IRankingRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.attribute = _data["attribute"];
            if (Array.isArray(_data["extremums"])) {
                this.extremums = [] as any;
                for (let item of _data["extremums"])
                    this.extremums!.push(Extremum.fromJS(item));
            }
            this.table = _data["table"];
            if (Array.isArray(_data["valuePriorities"])) {
                this.valuePriorities = [] as any;
                for (let item of _data["valuePriorities"])
                    this.valuePriorities!.push(ValuePriority.fromJS(item));
            }
            if (Array.isArray(_data["supplierPriorities"])) {
                this.supplierPriorities = [] as any;
                for (let item of _data["supplierPriorities"])
                    this.supplierPriorities!.push(SupplierPriority.fromJS(item));
            }
            if (Array.isArray(_data["numericConditions"])) {
                this.numericConditions = [] as any;
                for (let item of _data["numericConditions"])
                    this.numericConditions!.push(NumericCondition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RankingRule {
        data = typeof data === 'object' ? data : {};
        let result = new RankingRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["attribute"] = this.attribute;
        if (Array.isArray(this.extremums)) {
            data["extremums"] = [];
            for (let item of this.extremums)
                data["extremums"].push(item.toJSON());
        }
        data["table"] = this.table;
        if (Array.isArray(this.valuePriorities)) {
            data["valuePriorities"] = [];
            for (let item of this.valuePriorities)
                data["valuePriorities"].push(item.toJSON());
        }
        if (Array.isArray(this.supplierPriorities)) {
            data["supplierPriorities"] = [];
            for (let item of this.supplierPriorities)
                data["supplierPriorities"].push(item.toJSON());
        }
        if (Array.isArray(this.numericConditions)) {
            data["numericConditions"] = [];
            for (let item of this.numericConditions)
                data["numericConditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRankingRule {
    name?: string | undefined;
    description?: string | undefined;
    type?: RankingRuleType;
    attribute?: string | undefined;
    extremums?: Extremum[] | undefined;
    table?: string | undefined;
    valuePriorities?: ValuePriority[] | undefined;
    supplierPriorities?: SupplierPriority[] | undefined;
    numericConditions?: NumericCondition[] | undefined;
}

export class Reference implements IReference {
    objektTyp?: ObjektTyp;
    objektId?: number | undefined;
    erfassungId?: number | undefined;
    name?: string | undefined;

    constructor(data?: IReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objektTyp = _data["objektTyp"];
            this.objektId = _data["objektId"];
            this.erfassungId = _data["erfassungId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Reference {
        data = typeof data === 'object' ? data : {};
        let result = new Reference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objektTyp"] = this.objektTyp;
        data["objektId"] = this.objektId;
        data["erfassungId"] = this.erfassungId;
        data["name"] = this.name;
        return data;
    }
}

export interface IReference {
    objektTyp?: ObjektTyp;
    objektId?: number | undefined;
    erfassungId?: number | undefined;
    name?: string | undefined;
}

export class ReferencesResult implements IReferencesResult {
    total?: number;
    references?: Reference[] | undefined;

    constructor(data?: IReferencesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(Reference.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReferencesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReferencesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReferencesResult {
    total?: number;
    references?: Reference[] | undefined;
}

export class RejectReason implements IRejectReason {
    reason?: string | undefined;

    constructor(data?: IRejectReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RejectReason {
        data = typeof data === 'object' ? data : {};
        let result = new RejectReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IRejectReason {
    reason?: string | undefined;
}

export class SachverhaltBearbeiten implements ISachverhaltBearbeiten {
    header!: SachverhaltBearbeitenHeader;
    fields!: SachverhaltBearbeitenFieldBase[];
    values?: { [key: string]: any; } | undefined;

    constructor(data?: ISachverhaltBearbeiten) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.header = new SachverhaltBearbeitenHeader();
            this.fields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? SachverhaltBearbeitenHeader.fromJS(_data["header"]) : new SachverhaltBearbeitenHeader();
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SachverhaltBearbeitenFieldBase.fromJS(item));
            }
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): SachverhaltBearbeiten {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeiten();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        return data;
    }
}

export interface ISachverhaltBearbeiten {
    header: SachverhaltBearbeitenHeader;
    fields: SachverhaltBearbeitenFieldBase[];
    values?: { [key: string]: any; } | undefined;
}

export class SachverhaltBearbeitenFieldBase implements ISachverhaltBearbeitenFieldBase {
    key!: string;
    readonly type!: string;
    label?: string | undefined;
    required?: boolean;
    multiple?: boolean;
    valueLength?: number;
    hinweisTextHtml?: string | undefined;
    options?: string[] | undefined;
    table?: string | undefined;
    isOpen?: boolean;
    operators?: string[] | undefined;
    plausibility?: string[] | undefined;
    units?: string[] | undefined;
    defaultUnit?: string | undefined;
    minOperatorKey?: string | undefined;
    minValueKey?: string | undefined;
    minUnitKey?: string | undefined;
    maxOperatorKey?: string | undefined;
    maxValueKey?: string | undefined;
    maxUnitKey?: string | undefined;
    plausibilityKey?: string | undefined;
    descriptionKey?: string | undefined;
    stringValueKey?: string | undefined;
    objektTyp?: ObjektTyp;
    multiline?: boolean;
    fields?: SachverhaltBearbeitenField[] | undefined;

    constructor(data?: ISachverhaltBearbeitenFieldBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            (<any>this).type = _data["type"];
            this.label = _data["label"];
            this.required = _data["required"];
            this.multiple = _data["multiple"];
            this.valueLength = _data["valueLength"];
            this.hinweisTextHtml = _data["hinweisTextHtml"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.table = _data["table"];
            this.isOpen = _data["isOpen"];
            if (Array.isArray(_data["operators"])) {
                this.operators = [] as any;
                for (let item of _data["operators"])
                    this.operators!.push(item);
            }
            if (Array.isArray(_data["plausibility"])) {
                this.plausibility = [] as any;
                for (let item of _data["plausibility"])
                    this.plausibility!.push(item);
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(item);
            }
            this.defaultUnit = _data["defaultUnit"];
            this.minOperatorKey = _data["minOperatorKey"];
            this.minValueKey = _data["minValueKey"];
            this.minUnitKey = _data["minUnitKey"];
            this.maxOperatorKey = _data["maxOperatorKey"];
            this.maxValueKey = _data["maxValueKey"];
            this.maxUnitKey = _data["maxUnitKey"];
            this.plausibilityKey = _data["plausibilityKey"];
            this.descriptionKey = _data["descriptionKey"];
            this.stringValueKey = _data["stringValueKey"];
            this.objektTyp = _data["objektTyp"];
            this.multiline = _data["multiline"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SachverhaltBearbeitenField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SachverhaltBearbeitenFieldBase {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenFieldBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["type"] = this.type;
        data["label"] = this.label;
        data["required"] = this.required;
        data["multiple"] = this.multiple;
        data["valueLength"] = this.valueLength;
        data["hinweisTextHtml"] = this.hinweisTextHtml;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["table"] = this.table;
        data["isOpen"] = this.isOpen;
        if (Array.isArray(this.operators)) {
            data["operators"] = [];
            for (let item of this.operators)
                data["operators"].push(item);
        }
        if (Array.isArray(this.plausibility)) {
            data["plausibility"] = [];
            for (let item of this.plausibility)
                data["plausibility"].push(item);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item);
        }
        data["defaultUnit"] = this.defaultUnit;
        data["minOperatorKey"] = this.minOperatorKey;
        data["minValueKey"] = this.minValueKey;
        data["minUnitKey"] = this.minUnitKey;
        data["maxOperatorKey"] = this.maxOperatorKey;
        data["maxValueKey"] = this.maxValueKey;
        data["maxUnitKey"] = this.maxUnitKey;
        data["plausibilityKey"] = this.plausibilityKey;
        data["descriptionKey"] = this.descriptionKey;
        data["stringValueKey"] = this.stringValueKey;
        data["objektTyp"] = this.objektTyp;
        data["multiline"] = this.multiline;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISachverhaltBearbeitenFieldBase {
    key: string;
    type: string;
    label?: string | undefined;
    required?: boolean;
    multiple?: boolean;
    valueLength?: number;
    hinweisTextHtml?: string | undefined;
    options?: string[] | undefined;
    table?: string | undefined;
    isOpen?: boolean;
    operators?: string[] | undefined;
    plausibility?: string[] | undefined;
    units?: string[] | undefined;
    defaultUnit?: string | undefined;
    minOperatorKey?: string | undefined;
    minValueKey?: string | undefined;
    minUnitKey?: string | undefined;
    maxOperatorKey?: string | undefined;
    maxValueKey?: string | undefined;
    maxUnitKey?: string | undefined;
    plausibilityKey?: string | undefined;
    descriptionKey?: string | undefined;
    stringValueKey?: string | undefined;
    objektTyp?: ObjektTyp;
    multiline?: boolean;
    fields?: SachverhaltBearbeitenField[] | undefined;
}

export class SachverhaltBearbeitenField extends SachverhaltBearbeitenFieldBase implements ISachverhaltBearbeitenField {

    constructor(data?: ISachverhaltBearbeitenField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenField extends ISachverhaltBearbeitenFieldBase {
}

export class SachverhaltBearbeitenDateTimeField extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenDateTimeField {

    constructor(data?: ISachverhaltBearbeitenDateTimeField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenDateTimeField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenDateTimeField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenDateTimeField extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenDoubleField extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenDoubleField {

    constructor(data?: ISachverhaltBearbeitenDoubleField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenDoubleField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenDoubleField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenDoubleField extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenFileField extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenFileField {

    constructor(data?: ISachverhaltBearbeitenFileField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenFileField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenFileField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenFileField extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenHeader implements ISachverhaltBearbeitenHeader {
    merkmal!: string;
    merkmalName!: string;
    hinweisTextHtml?: string | undefined;

    constructor(data?: ISachverhaltBearbeitenHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merkmal = _data["merkmal"];
            this.merkmalName = _data["merkmalName"];
            this.hinweisTextHtml = _data["hinweisTextHtml"];
        }
    }

    static fromJS(data: any): SachverhaltBearbeitenHeader {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merkmal"] = this.merkmal;
        data["merkmalName"] = this.merkmalName;
        data["hinweisTextHtml"] = this.hinweisTextHtml;
        return data;
    }
}

export interface ISachverhaltBearbeitenHeader {
    merkmal: string;
    merkmalName: string;
    hinweisTextHtml?: string | undefined;
}

export class SachverhaltBearbeitenImageField extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenImageField {

    constructor(data?: ISachverhaltBearbeitenImageField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenImageField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenImageField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenImageField extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenIntField extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenIntField {

    constructor(data?: ISachverhaltBearbeitenIntField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenIntField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenIntField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenIntField extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenLookupField extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenLookupField {

    constructor(data?: ISachverhaltBearbeitenLookupField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenLookupField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenLookupField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenLookupField extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenRange extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenRange {

    constructor(data?: ISachverhaltBearbeitenRange) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenRange {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenRange extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenRefField extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenRefField {

    constructor(data?: ISachverhaltBearbeitenRefField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenRefField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenRefField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenRefField extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenStringField extends SachverhaltBearbeitenField implements ISachverhaltBearbeitenStringField {

    constructor(data?: ISachverhaltBearbeitenStringField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenStringField {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenStringField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenStringField extends ISachverhaltBearbeitenField {
}

export class SachverhaltBearbeitenSubset extends SachverhaltBearbeitenFieldBase implements ISachverhaltBearbeitenSubset {

    constructor(data?: ISachverhaltBearbeitenSubset) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SachverhaltBearbeitenSubset {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhaltBearbeitenSubset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISachverhaltBearbeitenSubset extends ISachverhaltBearbeitenFieldBase {
}

export class SachverhalteKopierenRequest implements ISachverhalteKopierenRequest {
    objektId?: string | undefined;
    zielObjektIds?: string[] | undefined;
    sachverhaltRefs?: SachverhalteKopierenSachverhaltRef[] | undefined;

    constructor(data?: ISachverhalteKopierenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objektId = _data["objektId"];
            if (Array.isArray(_data["zielObjektIds"])) {
                this.zielObjektIds = [] as any;
                for (let item of _data["zielObjektIds"])
                    this.zielObjektIds!.push(item);
            }
            if (Array.isArray(_data["sachverhaltRefs"])) {
                this.sachverhaltRefs = [] as any;
                for (let item of _data["sachverhaltRefs"])
                    this.sachverhaltRefs!.push(SachverhalteKopierenSachverhaltRef.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SachverhalteKopierenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhalteKopierenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objektId"] = this.objektId;
        if (Array.isArray(this.zielObjektIds)) {
            data["zielObjektIds"] = [];
            for (let item of this.zielObjektIds)
                data["zielObjektIds"].push(item);
        }
        if (Array.isArray(this.sachverhaltRefs)) {
            data["sachverhaltRefs"] = [];
            for (let item of this.sachverhaltRefs)
                data["sachverhaltRefs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISachverhalteKopierenRequest {
    objektId?: string | undefined;
    zielObjektIds?: string[] | undefined;
    sachverhaltRefs?: SachverhalteKopierenSachverhaltRef[] | undefined;
}

export class SachverhalteKopierenResponseItem implements ISachverhalteKopierenResponseItem {
    objektId?: string | undefined;
    success?: boolean;

    constructor(data?: ISachverhalteKopierenResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objektId = _data["objektId"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SachverhalteKopierenResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhalteKopierenResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objektId"] = this.objektId;
        data["success"] = this.success;
        return data;
    }
}

export interface ISachverhalteKopierenResponseItem {
    objektId?: string | undefined;
    success?: boolean;
}

export class SachverhalteKopierenSachverhaltRef implements ISachverhalteKopierenSachverhaltRef {
    sachverhaltId?: number | undefined;
    erfassungSachverhaltId?: number | undefined;

    constructor(data?: ISachverhalteKopierenSachverhaltRef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sachverhaltId = _data["sachverhaltId"];
            this.erfassungSachverhaltId = _data["erfassungSachverhaltId"];
        }
    }

    static fromJS(data: any): SachverhalteKopierenSachverhaltRef {
        data = typeof data === 'object' ? data : {};
        let result = new SachverhalteKopierenSachverhaltRef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sachverhaltId"] = this.sachverhaltId;
        data["erfassungSachverhaltId"] = this.erfassungSachverhaltId;
        return data;
    }
}

export interface ISachverhalteKopierenSachverhaltRef {
    sachverhaltId?: number | undefined;
    erfassungSachverhaltId?: number | undefined;
}

export class SearchResult implements ISearchResult {
    searchId?: string | undefined;
    total?: number;
    items?: { [key: string]: any; }[] | undefined;

    constructor(data?: ISearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchId = _data["searchId"];
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchId"] = this.searchId;
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface ISearchResult {
    searchId?: string | undefined;
    total?: number;
    items?: { [key: string]: any; }[] | undefined;
}

export class Setting implements ISetting {
    key?: string | undefined;
    value?: string | undefined;
    maxLines?: number;
    modified?: Date;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.maxLines = _data["maxLines"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["maxLines"] = this.maxLines;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISetting {
    key?: string | undefined;
    value?: string | undefined;
    maxLines?: number;
    modified?: Date;
}

export class SortInput implements ISortInput {
    column?: string | undefined;
    direction?: SortInputDirection;

    constructor(data?: ISortInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): SortInput {
        data = typeof data === 'object' ? data : {};
        let result = new SortInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column;
        data["direction"] = this.direction;
        return data;
    }
}

export interface ISortInput {
    column?: string | undefined;
    direction?: SortInputDirection;
}

export class Spalte implements ISpalte {
    name?: string | undefined;
    type?: SpalteType;

    constructor(data?: ISpalte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Spalte {
        data = typeof data === 'object' ? data : {};
        let result = new Spalte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ISpalte {
    name?: string | undefined;
    type?: SpalteType;
}

export class StoffErstellenCreated implements IStoffErstellenCreated {
    stoffId?: string | undefined;
    location?: string | undefined;

    constructor(data?: IStoffErstellenCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stoffId = _data["stoffId"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): StoffErstellenCreated {
        data = typeof data === 'object' ? data : {};
        let result = new StoffErstellenCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stoffId"] = this.stoffId;
        data["location"] = this.location;
        return data;
    }
}

export interface IStoffErstellenCreated {
    stoffId?: string | undefined;
    location?: string | undefined;
}

export class StringObjectKeyValuePair implements IStringObjectKeyValuePair {
    key?: string | undefined;
    value?: any | undefined;

    constructor(data?: IStringObjectKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StringObjectKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringObjectKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IStringObjectKeyValuePair {
    key?: string | undefined;
    value?: any | undefined;
}

export class Suchanfrage implements ISuchanfrage {
    refiningSearchId?: string | undefined;
    searchId?: string | undefined;
    pageSize?: number;
    skip?: number;
    query?: string | undefined;
    queryType?: SuchanfrageQueryType;
    kontext?: ObjektTyp;

    constructor(data?: ISuchanfrage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refiningSearchId = _data["refiningSearchId"];
            this.searchId = _data["searchId"];
            this.pageSize = _data["pageSize"];
            this.skip = _data["skip"];
            this.query = _data["query"];
            this.queryType = _data["queryType"];
            this.kontext = _data["kontext"];
        }
    }

    static fromJS(data: any): Suchanfrage {
        data = typeof data === 'object' ? data : {};
        let result = new Suchanfrage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refiningSearchId"] = this.refiningSearchId;
        data["searchId"] = this.searchId;
        data["pageSize"] = this.pageSize;
        data["skip"] = this.skip;
        data["query"] = this.query;
        data["queryType"] = this.queryType;
        data["kontext"] = this.kontext;
        return data;
    }
}

export interface ISuchanfrage {
    refiningSearchId?: string | undefined;
    searchId?: string | undefined;
    pageSize?: number;
    skip?: number;
    query?: string | undefined;
    queryType?: SuchanfrageQueryType;
    kontext?: ObjektTyp;
}

export class SupplierPriority implements ISupplierPriority {
    supplier?: string | undefined;
    priority?: number;

    constructor(data?: ISupplierPriority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): SupplierPriority {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPriority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier;
        data["priority"] = this.priority;
        return data;
    }
}

export interface ISupplierPriority {
    supplier?: string | undefined;
    priority?: number;
}

export class SystemInfo implements ISystemInfo {
    systemMessageHtml?: string | undefined;
    wartungsfenster?: WartungsfensterListItem[] | undefined;

    constructor(data?: ISystemInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemMessageHtml = _data["systemMessageHtml"];
            if (Array.isArray(_data["wartungsfenster"])) {
                this.wartungsfenster = [] as any;
                for (let item of _data["wartungsfenster"])
                    this.wartungsfenster!.push(WartungsfensterListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemMessageHtml"] = this.systemMessageHtml;
        if (Array.isArray(this.wartungsfenster)) {
            data["wartungsfenster"] = [];
            for (let item of this.wartungsfenster)
                data["wartungsfenster"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemInfo {
    systemMessageHtml?: string | undefined;
    wartungsfenster?: WartungsfensterListItem[] | undefined;
}

export class TabellenSucheKey implements ITabellenSucheKey {
    key?: string | undefined;
    controlType?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: ITabellenSucheKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.controlType = _data["controlType"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TabellenSucheKey {
        data = typeof data === 'object' ? data : {};
        let result = new TabellenSucheKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["controlType"] = this.controlType;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITabellenSucheKey {
    key?: string | undefined;
    controlType?: string | undefined;
    displayName?: string | undefined;
}

export class TabellenSucheZeile implements ITabellenSucheZeile {
    relation?: TabellenSucheZeileRelation;
    openingBrackets?: number;
    key?: string | undefined;
    operator?: TabellenSucheZeileOperator;
    value?: any | undefined;
    closingBrackets?: number;

    constructor(data?: ITabellenSucheZeile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relation = _data["relation"];
            this.openingBrackets = _data["openingBrackets"];
            this.key = _data["key"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            this.closingBrackets = _data["closingBrackets"];
        }
    }

    static fromJS(data: any): TabellenSucheZeile {
        data = typeof data === 'object' ? data : {};
        let result = new TabellenSucheZeile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relation"] = this.relation;
        data["openingBrackets"] = this.openingBrackets;
        data["key"] = this.key;
        data["operator"] = this.operator;
        data["value"] = this.value;
        data["closingBrackets"] = this.closingBrackets;
        return data;
    }
}

export interface ITabellenSucheZeile {
    relation?: TabellenSucheZeileRelation;
    openingBrackets?: number;
    key?: string | undefined;
    operator?: TabellenSucheZeileOperator;
    value?: any | undefined;
    closingBrackets?: number;
}

export class TableInput implements ITableInput {
    skip?: number | undefined;
    maxCount?: number | undefined;
    sort?: SortInput[] | undefined;
    filter?: FilterInput[] | undefined;

    constructor(data?: ITableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skip = _data["skip"];
            this.maxCount = _data["maxCount"];
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(SortInput.fromJS(item));
            }
            if (Array.isArray(_data["filter"])) {
                this.filter = [] as any;
                for (let item of _data["filter"])
                    this.filter!.push(FilterInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TableInput {
        data = typeof data === 'object' ? data : {};
        let result = new TableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["maxCount"] = this.maxCount;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item.toJSON());
        }
        if (Array.isArray(this.filter)) {
            data["filter"] = [];
            for (let item of this.filter)
                data["filter"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITableInput {
    skip?: number | undefined;
    maxCount?: number | undefined;
    sort?: SortInput[] | undefined;
    filter?: FilterInput[] | undefined;
}

export class ThesaurusRegel implements IThesaurusRegel {
    aktiv?: boolean;
    name?: string | undefined;
    regel?: string | undefined;
    quelle?: string | undefined;
    zwischen?: string | undefined;
    ziel?: string | undefined;
    beschreibung?: string | undefined;
    schluessel?: string[] | undefined;

    constructor(data?: IThesaurusRegel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aktiv = _data["aktiv"];
            this.name = _data["name"];
            this.regel = _data["regel"];
            this.quelle = _data["quelle"];
            this.zwischen = _data["zwischen"];
            this.ziel = _data["ziel"];
            this.beschreibung = _data["beschreibung"];
            if (Array.isArray(_data["schluessel"])) {
                this.schluessel = [] as any;
                for (let item of _data["schluessel"])
                    this.schluessel!.push(item);
            }
        }
    }

    static fromJS(data: any): ThesaurusRegel {
        data = typeof data === 'object' ? data : {};
        let result = new ThesaurusRegel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aktiv"] = this.aktiv;
        data["name"] = this.name;
        data["regel"] = this.regel;
        data["quelle"] = this.quelle;
        data["zwischen"] = this.zwischen;
        data["ziel"] = this.ziel;
        data["beschreibung"] = this.beschreibung;
        if (Array.isArray(this.schluessel)) {
            data["schluessel"] = [];
            for (let item of this.schluessel)
                data["schluessel"].push(item);
        }
        return data;
    }
}

export interface IThesaurusRegel {
    aktiv?: boolean;
    name?: string | undefined;
    regel?: string | undefined;
    quelle?: string | undefined;
    zwischen?: string | undefined;
    ziel?: string | undefined;
    beschreibung?: string | undefined;
    schluessel?: string[] | undefined;
}

export class ThesaurusRegelListItem implements IThesaurusRegelListItem {
    aktiv?: boolean;
    name?: string | undefined;
    regel?: string | undefined;
    quelle?: string | undefined;
    zwischen?: string | undefined;
    ziel?: string | undefined;
    beschreibung?: string | undefined;
    schluessel?: string[] | undefined;
    anzahl?: number;

    constructor(data?: IThesaurusRegelListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aktiv = _data["aktiv"];
            this.name = _data["name"];
            this.regel = _data["regel"];
            this.quelle = _data["quelle"];
            this.zwischen = _data["zwischen"];
            this.ziel = _data["ziel"];
            this.beschreibung = _data["beschreibung"];
            if (Array.isArray(_data["schluessel"])) {
                this.schluessel = [] as any;
                for (let item of _data["schluessel"])
                    this.schluessel!.push(item);
            }
            this.anzahl = _data["anzahl"];
        }
    }

    static fromJS(data: any): ThesaurusRegelListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ThesaurusRegelListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aktiv"] = this.aktiv;
        data["name"] = this.name;
        data["regel"] = this.regel;
        data["quelle"] = this.quelle;
        data["zwischen"] = this.zwischen;
        data["ziel"] = this.ziel;
        data["beschreibung"] = this.beschreibung;
        if (Array.isArray(this.schluessel)) {
            data["schluessel"] = [];
            for (let item of this.schluessel)
                data["schluessel"].push(item);
        }
        data["anzahl"] = this.anzahl;
        return data;
    }
}

export interface IThesaurusRegelListItem {
    aktiv?: boolean;
    name?: string | undefined;
    regel?: string | undefined;
    quelle?: string | undefined;
    zwischen?: string | undefined;
    ziel?: string | undefined;
    beschreibung?: string | undefined;
    schluessel?: string[] | undefined;
    anzahl?: number;
}

export class UpdateFeedbackInput implements IUpdateFeedbackInput {
    status?: UpdateFeedbackInputStatus;
    kommentar?: string | undefined;
    emailErwartet?: boolean;

    constructor(data?: IUpdateFeedbackInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.kommentar = _data["kommentar"];
            this.emailErwartet = _data["emailErwartet"];
        }
    }

    static fromJS(data: any): UpdateFeedbackInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFeedbackInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["kommentar"] = this.kommentar;
        data["emailErwartet"] = this.emailErwartet;
        return data;
    }
}

export interface IUpdateFeedbackInput {
    status?: UpdateFeedbackInputStatus;
    kommentar?: string | undefined;
    emailErwartet?: boolean;
}

export class UserInfo implements IUserInfo {
    uid?: string;
    name?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserInfo {
    uid?: string;
    name?: string | undefined;
}

export class UserItem implements IUserItem {
    readonly uid?: string;
    readonly name?: string | undefined;
    readonly givenName?: string | undefined;
    readonly familyName?: string | undefined;

    constructor(data?: IUserItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).uid = _data["uid"];
            (<any>this).name = _data["name"];
            (<any>this).givenName = _data["givenName"];
            (<any>this).familyName = _data["familyName"];
        }
    }

    static fromJS(data: any): UserItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["givenName"] = this.givenName;
        data["familyName"] = this.familyName;
        return data;
    }
}

export interface IUserItem {
    uid?: string;
    name?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;
}

export class ValidierungsRegel implements IValidierungsRegel {
    name?: string | undefined;
    merkmalName?: string | undefined;
    regel?: string | undefined;
    betroffeneFelder?: string[] | undefined;
    fehlermeldungen?: LocalizedText[] | undefined;

    constructor(data?: IValidierungsRegel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.merkmalName = _data["merkmalName"];
            this.regel = _data["regel"];
            if (Array.isArray(_data["betroffeneFelder"])) {
                this.betroffeneFelder = [] as any;
                for (let item of _data["betroffeneFelder"])
                    this.betroffeneFelder!.push(item);
            }
            if (Array.isArray(_data["fehlermeldungen"])) {
                this.fehlermeldungen = [] as any;
                for (let item of _data["fehlermeldungen"])
                    this.fehlermeldungen!.push(LocalizedText.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidierungsRegel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidierungsRegel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["merkmalName"] = this.merkmalName;
        data["regel"] = this.regel;
        if (Array.isArray(this.betroffeneFelder)) {
            data["betroffeneFelder"] = [];
            for (let item of this.betroffeneFelder)
                data["betroffeneFelder"].push(item);
        }
        if (Array.isArray(this.fehlermeldungen)) {
            data["fehlermeldungen"] = [];
            for (let item of this.fehlermeldungen)
                data["fehlermeldungen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidierungsRegel {
    name?: string | undefined;
    merkmalName?: string | undefined;
    regel?: string | undefined;
    betroffeneFelder?: string[] | undefined;
    fehlermeldungen?: LocalizedText[] | undefined;
}

export class ValidierungsRegelListItem implements IValidierungsRegelListItem {
    name?: string | undefined;
    merkmalName?: string | undefined;
    regel?: string | undefined;
    betroffeneFelder?: string[] | undefined;

    constructor(data?: IValidierungsRegelListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.merkmalName = _data["merkmalName"];
            this.regel = _data["regel"];
            if (Array.isArray(_data["betroffeneFelder"])) {
                this.betroffeneFelder = [] as any;
                for (let item of _data["betroffeneFelder"])
                    this.betroffeneFelder!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidierungsRegelListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ValidierungsRegelListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["merkmalName"] = this.merkmalName;
        data["regel"] = this.regel;
        if (Array.isArray(this.betroffeneFelder)) {
            data["betroffeneFelder"] = [];
            for (let item of this.betroffeneFelder)
                data["betroffeneFelder"].push(item);
        }
        return data;
    }
}

export interface IValidierungsRegelListItem {
    name?: string | undefined;
    merkmalName?: string | undefined;
    regel?: string | undefined;
    betroffeneFelder?: string[] | undefined;
}

export class ValuePriority implements IValuePriority {
    value?: string | undefined;
    priority?: number;

    constructor(data?: IValuePriority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): ValuePriority {
        data = typeof data === 'object' ? data : {};
        let result = new ValuePriority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IValuePriority {
    value?: string | undefined;
    priority?: number;
}

export class Wartungsfenster implements IWartungsfenster {
    id?: number;
    erstelltDurch?: string | undefined;
    erstellt?: Date;
    kurzfristig?: boolean;
    beginn?: Date | undefined;
    ende?: Date | undefined;
    grund?: string | undefined;
    status?: WartungsfensterStatus | undefined;
    emailGesendet?: EmailGesendet[] | undefined;
    verlauf?: WartungsfensterVerlauf[] | undefined;

    constructor(data?: IWartungsfenster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.erstelltDurch = _data["erstelltDurch"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
            this.kurzfristig = _data["kurzfristig"];
            this.beginn = _data["beginn"] ? new Date(_data["beginn"].toString()) : <any>undefined;
            this.ende = _data["ende"] ? new Date(_data["ende"].toString()) : <any>undefined;
            this.grund = _data["grund"];
            this.status = _data["status"];
            if (Array.isArray(_data["emailGesendet"])) {
                this.emailGesendet = [] as any;
                for (let item of _data["emailGesendet"])
                    this.emailGesendet!.push(item);
            }
            if (Array.isArray(_data["verlauf"])) {
                this.verlauf = [] as any;
                for (let item of _data["verlauf"])
                    this.verlauf!.push(WartungsfensterVerlauf.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Wartungsfenster {
        data = typeof data === 'object' ? data : {};
        let result = new Wartungsfenster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["erstelltDurch"] = this.erstelltDurch;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        data["kurzfristig"] = this.kurzfristig;
        data["beginn"] = this.beginn ? this.beginn.toISOString() : <any>undefined;
        data["ende"] = this.ende ? this.ende.toISOString() : <any>undefined;
        data["grund"] = this.grund;
        data["status"] = this.status;
        if (Array.isArray(this.emailGesendet)) {
            data["emailGesendet"] = [];
            for (let item of this.emailGesendet)
                data["emailGesendet"].push(item);
        }
        if (Array.isArray(this.verlauf)) {
            data["verlauf"] = [];
            for (let item of this.verlauf)
                data["verlauf"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWartungsfenster {
    id?: number;
    erstelltDurch?: string | undefined;
    erstellt?: Date;
    kurzfristig?: boolean;
    beginn?: Date | undefined;
    ende?: Date | undefined;
    grund?: string | undefined;
    status?: WartungsfensterStatus | undefined;
    emailGesendet?: EmailGesendet[] | undefined;
    verlauf?: WartungsfensterVerlauf[] | undefined;
}

export class WartungsfensterListItem implements IWartungsfensterListItem {
    id?: number;
    kurzfristig?: boolean;
    beginn?: Date;
    ende?: Date | undefined;
    grund?: string | undefined;
    erstelltDurch?: string | undefined;
    erstellt?: Date;
    status?: WartungsfensterListItemStatus;
    emailGesendet?: EmailGesendet2[] | undefined;

    constructor(data?: IWartungsfensterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kurzfristig = _data["kurzfristig"];
            this.beginn = _data["beginn"] ? new Date(_data["beginn"].toString()) : <any>undefined;
            this.ende = _data["ende"] ? new Date(_data["ende"].toString()) : <any>undefined;
            this.grund = _data["grund"];
            this.erstelltDurch = _data["erstelltDurch"];
            this.erstellt = _data["erstellt"] ? new Date(_data["erstellt"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["emailGesendet"])) {
                this.emailGesendet = [] as any;
                for (let item of _data["emailGesendet"])
                    this.emailGesendet!.push(item);
            }
        }
    }

    static fromJS(data: any): WartungsfensterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new WartungsfensterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kurzfristig"] = this.kurzfristig;
        data["beginn"] = this.beginn ? this.beginn.toISOString() : <any>undefined;
        data["ende"] = this.ende ? this.ende.toISOString() : <any>undefined;
        data["grund"] = this.grund;
        data["erstelltDurch"] = this.erstelltDurch;
        data["erstellt"] = this.erstellt ? this.erstellt.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.emailGesendet)) {
            data["emailGesendet"] = [];
            for (let item of this.emailGesendet)
                data["emailGesendet"].push(item);
        }
        return data;
    }
}

export interface IWartungsfensterListItem {
    id?: number;
    kurzfristig?: boolean;
    beginn?: Date;
    ende?: Date | undefined;
    grund?: string | undefined;
    erstelltDurch?: string | undefined;
    erstellt?: Date;
    status?: WartungsfensterListItemStatus;
    emailGesendet?: EmailGesendet2[] | undefined;
}

export class WartungsfensterVerlauf implements IWartungsfensterVerlauf {
    bearbeitet?: Date;
    bearbeitetDurch?: string | undefined;
    status?: WartungsfensterVerlaufStatus;

    constructor(data?: IWartungsfensterVerlauf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bearbeitet = _data["bearbeitet"] ? new Date(_data["bearbeitet"].toString()) : <any>undefined;
            this.bearbeitetDurch = _data["bearbeitetDurch"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WartungsfensterVerlauf {
        data = typeof data === 'object' ? data : {};
        let result = new WartungsfensterVerlauf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bearbeitet"] = this.bearbeitet ? this.bearbeitet.toISOString() : <any>undefined;
        data["bearbeitetDurch"] = this.bearbeitetDurch;
        data["status"] = this.status;
        return data;
    }
}

export interface IWartungsfensterVerlauf {
    bearbeitet?: Date;
    bearbeitetDurch?: string | undefined;
    status?: WartungsfensterVerlaufStatus;
}

export class WerteZusammenfuehrenInput implements IWerteZusammenfuehrenInput {
    nachschlageTabelleWertId?: number;
    quellNachschlageTabelleWertIds?: number[] | undefined;

    constructor(data?: IWerteZusammenfuehrenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nachschlageTabelleWertId = _data["nachschlageTabelleWertId"];
            if (Array.isArray(_data["quellNachschlageTabelleWertIds"])) {
                this.quellNachschlageTabelleWertIds = [] as any;
                for (let item of _data["quellNachschlageTabelleWertIds"])
                    this.quellNachschlageTabelleWertIds!.push(item);
            }
        }
    }

    static fromJS(data: any): WerteZusammenfuehrenInput {
        data = typeof data === 'object' ? data : {};
        let result = new WerteZusammenfuehrenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nachschlageTabelleWertId"] = this.nachschlageTabelleWertId;
        if (Array.isArray(this.quellNachschlageTabelleWertIds)) {
            data["quellNachschlageTabelleWertIds"] = [];
            for (let item of this.quellNachschlageTabelleWertIds)
                data["quellNachschlageTabelleWertIds"].push(item);
        }
        return data;
    }
}

export interface IWerteZusammenfuehrenInput {
    nachschlageTabelleWertId?: number;
    quellNachschlageTabelleWertIds?: number[] | undefined;
}

export class ZitatZusammenfuehrenInput implements IZitatZusammenfuehrenInput {
    zitatId?: number;
    zitatIds?: number[] | undefined;

    constructor(data?: IZitatZusammenfuehrenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zitatId = _data["zitatId"];
            if (Array.isArray(_data["zitatIds"])) {
                this.zitatIds = [] as any;
                for (let item of _data["zitatIds"])
                    this.zitatIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ZitatZusammenfuehrenInput {
        data = typeof data === 'object' ? data : {};
        let result = new ZitatZusammenfuehrenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zitatId"] = this.zitatId;
        if (Array.isArray(this.zitatIds)) {
            data["zitatIds"] = [];
            for (let item of this.zitatIds)
                data["zitatIds"].push(item);
        }
        return data;
    }
}

export interface IZitatZusammenfuehrenInput {
    zitatId?: number;
    zitatIds?: number[] | undefined;
}

export enum Modus {
    Hinzufuegen = "Hinzufuegen",
    Ersatzlieferung = "Ersatzlieferung",
    PartielleErsatzlieferung = "PartielleErsatzlieferung",
}

export enum BatchMode {
    AnalyzeOnly = "AnalyzeOnly",
    IgnoreErroneousObjects = "IgnoreErroneousObjects",
    FailOnAnyErrors = "FailOnAnyErrors",
}

export enum BatchMode2 {
    AnalyzeOnly = "AnalyzeOnly",
    IgnoreErroneousObjects = "IgnoreErroneousObjects",
    FailOnAnyErrors = "FailOnAnyErrors",
}

export enum BadRequestResultReason {
    RuleValidationFailed = "RuleValidationFailed",
    ValidationError = "ValidationError",
    InvalidState = "InvalidState",
    NoFactsToApproveOrReject = "NoFactsToApproveOrReject",
    IdentityCollision = "IdentityCollision",
    CardinalityValidationFailed = "CardinalityValidationFailed",
    DuplicateCopy = "DuplicateCopy",
    DuplicateCopiesInAttributes = "DuplicateCopiesInAttributes",
    InvalidStateTransition = "InvalidStateTransition",
    ValueNotFound = "ValueNotFound",
    ObjectNotFound = "ObjectNotFound",
}

export enum ChildImportObjektErfassungType {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Merge = "Merge",
    BatchUpdate = "BatchUpdate",
    BatchDelete = "BatchDelete",
    Import = "Import",
}

export enum CreateFeedbackInputTyp {
    System = "System",
    Stoffdaten = "Stoffdaten",
}

export enum CreateFeedbackInputKategorie {
    Allgemein = "Allgemein",
    EintragInNachschlagetabelle = "EintragInNachschlagetabelle",
    KeinePassendeKategorie = "KeinePassendeKategorie",
    Dublette = "Dublette",
    Strukturformel = "Strukturformel",
    Registriername = "Registriername",
    SonstigerInhaltlicherFehler = "SonstigerInhaltlicherFehler",
    HinweisZumZitat = "HinweisZumZitat",
}

export enum CreateFeedbackInputPrioritaet {
    Normal = "Normal",
    Dringend = "Dringend",
}

export enum DossierErfassungStatus {
    Neu = "Neu",
    InFreigabe = "InFreigabe",
    Freigegeben = "Freigegeben",
    Zurueckgewiesen = "Zurueckgewiesen",
    Abgeschlossen = "Abgeschlossen",
    Archiviert = "Archiviert",
}

export enum DossierErfassungType {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Merge = "Merge",
    BatchUpdate = "BatchUpdate",
    BatchDelete = "BatchDelete",
    Import = "Import",
}

export enum DossierApprovalHistoryItemAction {
    RequestedForApproval = "RequestedForApproval",
    RejectedAsLecturer = "RejectedAsLecturer",
    RejectedAsAdmin = "RejectedAsAdmin",
    Rejected = "Rejected",
    ApprovedAsLecturer = "ApprovedAsLecturer",
    ApprovedAsAdmin = "ApprovedAsAdmin",
    Approved = "Approved",
    Finalized = "Finalized",
    FinalizedWithErrors = "FinalizedWithErrors",
    FinalizationFailedWithErrors = "FinalizationFailedWithErrors",
    AssignedToUser = "AssignedToUser",
    Withdraw = "Withdraw",
}

export enum DossierAttributeFactState {
    Updated = "Updated",
    Deleted = "Deleted",
    Created = "Created",
    Computed = "Computed",
    Thesaurus = "Thesaurus",
    Ranking = "Ranking",
}

export enum EinfacheSucheFeldControlType {
    Unsupported = "Unsupported",
    Hierarchie = "Hierarchie",
    Merkmal = "Merkmal",
    Text = "Text",
    Int = "Int",
    DateTime = "DateTime",
    Double = "Double",
    Lookup = "Lookup",
}

export enum ErfassungErrorResultError {
    DuplicateFact = "DuplicateFact",
    IdentityCollision = "IdentityCollision",
    ReferenceViolation = "ReferenceViolation",
    Locked = "Locked",
    CardinalityViolation = "CardinalityViolation",
    UnexpectedError = "UnexpectedError",
}

export enum ErfassungListItemTyp {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Merge = "Merge",
    BatchUpdate = "BatchUpdate",
    BatchDelete = "BatchDelete",
    Import = "Import",
}

export enum ErfassungListItemStatus {
    Neu = "Neu",
    InFreigabe = "InFreigabe",
    Freigegeben = "Freigegeben",
    Zurueckgewiesen = "Zurueckgewiesen",
    Abgeschlossen = "Abgeschlossen",
    Archiviert = "Archiviert",
}

export enum Freigaben {
    Administrator = "Administrator",
    Fachlektor = "Fachlektor",
    Zusammenfuehrung = "Zusammenfuehrung",
    Import = "Import",
}

export enum ErrorDtoType {
    CardinalityViolation = "CardinalityViolation",
    UnexpectedError = "UnexpectedError",
}

export enum ExtremumOperator {
    Max = "Max",
    Min = "Min",
}

export enum FeedbackListItemStatus {
    Offen = "Offen",
    InBearbeitung = "InBearbeitung",
    Erledigt = "Erledigt",
}

export enum FeedbackListItemTyp {
    System = "System",
    Stoffdaten = "Stoffdaten",
}

export enum FeedbackListItemKategorie {
    Allgemein = "Allgemein",
    EintragInNachschlagetabelle = "EintragInNachschlagetabelle",
    KeinePassendeKategorie = "KeinePassendeKategorie",
    Dublette = "Dublette",
    Strukturformel = "Strukturformel",
    Registriername = "Registriername",
    SonstigerInhaltlicherFehler = "SonstigerInhaltlicherFehler",
    HinweisZumZitat = "HinweisZumZitat",
}

export enum FeedbackListItemPrioritaet {
    Normal = "Normal",
    Dringend = "Dringend",
}

export enum FeedbackResultStatus {
    Offen = "Offen",
    InBearbeitung = "InBearbeitung",
    Erledigt = "Erledigt",
}

export enum FeedbackResultTyp {
    System = "System",
    Stoffdaten = "Stoffdaten",
}

export enum FeedbackResultKategorie {
    Allgemein = "Allgemein",
    EintragInNachschlagetabelle = "EintragInNachschlagetabelle",
    KeinePassendeKategorie = "KeinePassendeKategorie",
    Dublette = "Dublette",
    Strukturformel = "Strukturformel",
    Registriername = "Registriername",
    SonstigerInhaltlicherFehler = "SonstigerInhaltlicherFehler",
    HinweisZumZitat = "HinweisZumZitat",
}

export enum FeedbackResultPrioritaet {
    Normal = "Normal",
    Dringend = "Dringend",
}

export enum FeedbackResultVerlaufStatus {
    Offen = "Offen",
    InBearbeitung = "InBearbeitung",
    Erledigt = "Erledigt",
}

export enum ForbiddenResultReason {
    Authorization = "Authorization",
    LockedByOtherUser = "LockedByOtherUser",
    SupplierIsNotAssigned = "SupplierIsNotAssigned",
    ReferenceViolation = "ReferenceViolation",
    ClosedTable = "ClosedTable",
    ValueInUse = "ValueInUse",
    MasterConfigurationCannotBeDeleted = "MasterConfigurationCannotBeDeleted",
}

export enum FreigebenResultItemResult {
    Ok = "Ok",
    NothingToApprove = "NothingToApprove",
    NotFound = "NotFound",
    InvalidState = "InvalidState",
}

export enum ImportAuftragModus {
    Hinzufuegen = "Hinzufuegen",
    Ersatzlieferung = "Ersatzlieferung",
    PartielleErsatzlieferung = "PartielleErsatzlieferung",
}

export enum ImportAuftragListItemStatus {
    Ausstehend = "Ausstehend",
    Fehlgeschlagen = "Fehlgeschlagen",
    KeineAenderung = "KeineAenderung",
    InFreigabe = "InFreigabe",
    Freigegeben = "Freigegeben",
    Abgeschlossen = "Abgeschlossen",
}

export enum Flags {
    Hinzufuegen = "Hinzufuegen",
    Ersatzlieferung = "Ersatzlieferung",
    PartielleErsatzlieferung = "PartielleErsatzlieferung",
    SachverhalteUeberspringen = "SachverhalteUeberspringen",
    StoffeErstellen = "StoffeErstellen",
}

export enum ImportAuftragLogItemSeverity {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
    Headline = "Headline",
}

export enum ImportiertesMerkmalAktion {
    Importiert = "Importiert",
    EntferntDurchErsatzlieferung = "EntferntDurchErsatzlieferung",
}

export enum MerkmalBaumType {
    Hierarchie = "Hierarchie",
    Merkmal = "Merkmal",
    Feld = "Feld",
}

export enum NumericConditionOperator {
    Equals = "Equals",
    LessThan = "LessThan",
    GreaterThan = "GreaterThan",
}

export enum PartialDossierErfassungType {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Merge = "Merge",
    BatchUpdate = "BatchUpdate",
    BatchDelete = "BatchDelete",
    Import = "Import",
}

export enum PartialDossierErfassungStatus {
    Neu = "Neu",
    InFreigabe = "InFreigabe",
    Freigegeben = "Freigegeben",
    Zurueckgewiesen = "Zurueckgewiesen",
    Abgeschlossen = "Abgeschlossen",
    Archiviert = "Archiviert",
}

export enum RankingAuftragStatus {
    Success = "Success",
    Failed = "Failed",
}

export enum RankingRegelListItemTyp {
    Extremwert = "Extremwert",
    Lieferant = "Lieferant",
    NachschlageTabelle = "NachschlageTabelle",
    NumerischeBedingung = "NumerischeBedingung",
}

export enum RankingRuleType {
    LookupTable = "LookupTable",
    NumericCondition = "NumericCondition",
    Extremum = "Extremum",
    Supplier = "Supplier",
}

export enum SortInputDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export enum SpalteType {
    Text = "Text",
    Number = "Number",
    Date = "Date",
}

export enum SuchanfrageQueryType {
    Simple = "Simple",
    Advanced = "Advanced",
    Expert = "Expert",
}

export enum TabellenSucheZeileRelation {
    Without = "Without",
    Link = "Link",
    Or = "Or",
    And = "And",
}

export enum TabellenSucheZeileOperator {
    Eq = "Eq",
    NotEq = "NotEq",
    Gt = "Gt",
    Gte = "Gte",
    Lt = "Lt",
    Lte = "Lte",
    StartsWith = "StartsWith",
    EndsWith = "EndsWith",
    Contains = "Contains",
    Wildcard = "Wildcard",
    IsNotNull = "IsNotNull",
    IsNull = "IsNull",
}

export enum UpdateFeedbackInputStatus {
    Offen = "Offen",
    InBearbeitung = "InBearbeitung",
    Erledigt = "Erledigt",
}

export enum WartungsfensterStatus {
    NichtGestartet = "NichtGestartet",
    Aktiv = "Aktiv",
    Beendet = "Beendet",
    Storniert = "Storniert",
}

export enum EmailGesendet {
    Geplant = "Geplant",
    Aktiviert = "Aktiviert",
    Beendet = "Beendet",
    Storniert = "Storniert",
}

export enum WartungsfensterListItemStatus {
    NichtGestartet = "NichtGestartet",
    Aktiv = "Aktiv",
    Beendet = "Beendet",
    Storniert = "Storniert",
}

export enum EmailGesendet2 {
    Geplant = "Geplant",
    Aktiviert = "Aktiviert",
    Beendet = "Beendet",
    Storniert = "Storniert",
}

export enum WartungsfensterVerlaufStatus {
    NichtGestartet = "NichtGestartet",
    Aktiv = "Aktiv",
    Beendet = "Beendet",
    Storniert = "Storniert",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}